import React, { useState, useEffect, useContext, useMemo } from 'react';
import { toast } from 'react-toastify';
import {
    create_product_processing,
    get_product_processing,
    getProductMaster,
    getRawMaterials,
    update_product_process_status,
    add_process_charges,
    finalize_processing,
    get_product_details,
    list_raw_material_transactions,
    createExpanse,
    postGeneralData,
    create_product_details,
    listProductQty,
    createPurchaseprocess,
    getUnits,
    get_completed_process_details,
    cancel_processing,
    getBankBalance,
    delete_processing,
    get_product_orders,
    get_product_order_details,
    getBatchWiseSalesReport
} from "../../../Utility/Api";
import { WarehouseContext } from "../../../Utility/UserContext";
import { getFormattedCurrentDate2, NaviGate, getStoredEntriesPerPage, setStoredEntriesPerPage } from "../../../Utility/function";
import { Pagination } from "../../Common/Functions";
import { useNavigate, useLocation } from 'react-router-dom';

const displayLimit = (limit) => {
    if (!limit) return '1 Kg';
    const str = String(limit).toLowerCase();
    if (str.includes('kg')) return limit;
    return `${limit} Kg`;
};

const ProcessStepBar = ({ currentStep }) => {
    const steps = [
        { label: "Create Process", icon: "bi bi-file-earmark-plus" },
        { label: "Manufacturing Details", icon: "bi bi-gear" },
        { label: "Distribution", icon: "bi bi-box-seam" }
    ];

    return (
        <div className="mb-5 mt-3">
            <style>{`
                .stepper-container {
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    width: 100%;
                    max-width: 800px;
                    margin: 0 auto;
                    padding: 0 0 0.5rem 0;
                }
                .stepper-line {
                    position: absolute;
                    top: 22px; /* Centered with the 44px outer circle */
                    left: 16.67%;
                    right: 16.67%;
                    height: 2px;
                    background-color: #E2E8F0;
                    z-index: 1;
                }
                .stepper-line-progress {
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    background-color: #3B82F6;
                    transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
                }
                .stepper-step {
                    position: relative;
                    z-index: 2;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    flex: 1;
                    text-align: center;
                }
                
                /* Outer Ring */
                .step-icon-outer {
                    width: 44px;
                    height: 44px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #FFFFFF;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                    border: 1.5px solid #E2E8F0;
                }
                
                .stepper-step.active .step-icon-outer {
                    border: 2px solid #3B82F6;
                    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
                }
                
                .stepper-step.completed .step-icon-outer {
                    border: 2px solid #10B981;
                }
                
                .stepper-step.pending .step-icon-outer {
                    border: 1.5px solid #CBD5E1;
                }
                
                /* Inner Circles */
                .step-icon-inner {
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.95rem;
                    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }
                
                .stepper-step.active .step-icon-inner {
                    background-color: #3B82F6;
                    color: #FFFFFF;
                }
                
                .stepper-step.completed .step-icon-inner {
                    background-color: #10B981;
                    color: #FFFFFF;
                }
                
                .stepper-step.pending .step-icon-inner {
                    background-color: transparent;
                    color: #94A3B8;
                }
                
                /* Labels */
                .step-text {
                    margin-top: 12px;
                    font-size: 0.725rem;
                    font-weight: 700;
                    text-transform: uppercase;
                    letter-spacing: 0.06em;
                    color: #94A3B8;
                    transition: all 0.3s ease;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    line-height: 1;
                }
                
                .stepper-step.active .step-text {
                    color: #3B82F6;
                }
                
                .stepper-step.completed .step-text {
                    color: #10B981;
                }
                
                /* Active Dot Indicator */
                .active-dot {
                    width: 5px;
                    height: 5px;
                    border-radius: 50%;
                    background-color: #3B82F6;
                    margin-top: 6px;
                    animation: activePulse 2s infinite ease-in-out;
                }

                @keyframes activePulse {
                    0% { transform: scale(0.8); opacity: 0.5; }
                    50% { transform: scale(1.3); opacity: 1; }
                    100% { transform: scale(0.8); opacity: 0.5; }
                }
            `}</style>

            <div className="stepper-container">
                {/* Connecting Line */}
                <div className="stepper-line">
                    <div
                        className="stepper-line-progress"
                        style={{
                            width: `${currentStep === 1 ? 0 : currentStep === 2 ? 50 : 100}%`
                        }}
                    ></div>
                </div>

                {steps.map((step, index) => {
                    const stepNumber = index + 1;
                    const isActive = stepNumber === currentStep;
                    const isCompleted = stepNumber < currentStep;
                    const isPending = stepNumber > currentStep;

                    let stepClass = "pending";
                    if (isActive) stepClass = "active";
                    else if (isCompleted) stepClass = "completed";

                    return (
                        <div key={index} className={`stepper-step ${stepClass}`}>
                            <div className="step-icon-outer">
                                <div className="step-icon-inner">
                                    {isCompleted ? (
                                        <i className="bi bi-check-lg" style={{ fontSize: "1.1rem" }}></i>
                                    ) : (
                                        <i className={step.icon}></i>
                                    )}
                                </div>
                            </div>
                            <div className="step-text">
                                <span>{step.label}</span>
                                {isActive && <div className="active-dot"></div>}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

const formatIngredientQty = (qty, unit) => {
    const val = parseFloat(qty || 0);
    if (val === 0) return "0";
    const lowerUnit = (unit || "").toLowerCase();
    if (lowerUnit === "grams" || lowerUnit === "g" || lowerUnit === "gram" || lowerUnit === "ml" || lowerUnit === "milliliters") {
        return Math.round(val).toString();
    }
    if (val < 0.01) {
        return parseFloat(val.toFixed(6)).toString();
    }
    return parseFloat(val.toFixed(2)).toString();
};

const getIngredientQtyAndUnitDisplay = (item, rawMaterials = [], unitMap = {}) => {
    const rmDetail = rawMaterials.find(rm => 
        String(rm.id) === String(item.raw_mat_id || item.raw_id || item.id) || 
        rm.title === item.raw_material_name
    );
    const pcsPerKg = parseFloat(rmDetail?.pcs_per_kg || 0);
    const unitStr = (unitMap[String(item.unit || item.unit_id)] || item.unit || '').toString().toLowerCase();

    // Packaging material (type=1) purchased in kg with pcs_per_kg, used/displayed in pcs
    if (pcsPerKg > 0 && (unitStr === 'pcs' || String(rmDetail?.type) === '1')) {
        const rawVal = parseFloat(item.qty || 0);
        const pcsVal = (rawVal < 50 && (rawVal % 1 !== 0)) ? Math.round(rawVal * pcsPerKg) : Math.round(rawVal);
        return `${pcsVal} pcs`;
    }

    if (rmDetail && String(rmDetail.type) === "2") {
        return `${formatIngredientQty(item.qty)} li`;
    }

    const finalUnit = unitMap[String(item.unit || item.unit_id)] || item.unit || 'units';
    return `${formatIngredientQty(item.qty)} ${finalUnit}`;
};


const formatIngredientPrice = (item) => {
    const qty = parseFloat(item.qty || 0);
    const priceUnit = parseFloat(item.price_unit || 0);
    const storedPrice = parseFloat(item.price || 0);
    let cost = qty * priceUnit;

    // Fallback: Use database-rounded price if price_unit is missing/invalid
    if (isNaN(priceUnit) || priceUnit <= 0 || isNaN(cost) || cost <= 0) {
        cost = storedPrice;
    }

    // Sanity check: if calculated cost is >10x the stored price, the qty is in pcs
    // but price_unit is per-kg (old transactions before the fix). Use stored price.
    if (storedPrice > 0 && cost > storedPrice * 10) {
        cost = storedPrice;
    }

    if (cost === 0) return "₹0.00";
    if (cost < 0.01) {
        return "₹" + cost.toFixed(4); // Show 4 decimal places for tiny fractional costs
    }
    return "₹" + cost.toFixed(2);
};

const Product_process = () => {
    const { showLoader, hideLoader, shopItem, UserItem, warehouse } = useContext(WarehouseContext);
    const navigate = useNavigate();
    const location = useLocation();

    const [currentStep, setCurrentStep] = useState(1);
    const [activeProcessId, setActiveProcessId] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [products, setProducts] = useState([]);
    const [rawMaterials, setRawMaterials] = useState([]);
    const [processList, setProcessList] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [ingredientsList, setIngredientsList] = useState([]);
    const isLitreType = (id) => {
        if (!id) return false;
        const rawMaterial = rawMaterials.find(rm => String(rm.id) === String(id));
        return rawMaterial && String(rawMaterial.type) === "2";
    };

    const normalizeIngredientQtyAndUnit = (rawQty, rawUnit, isLitre) => {
        let qty = parseFloat(rawQty) || 0;
        let unit = rawUnit || (isLitre ? "Ml" : "grams");
        const lowerUnit = unit.toLowerCase();

        if ((lowerUnit === "ml" || lowerUnit === "milliliters") && qty >= 1000) {
            qty = parseFloat((qty / 1000).toFixed(3));
            unit = "Li";
        } else if ((lowerUnit === "grams" || lowerUnit === "g" || lowerUnit === "gram") && qty >= 1000) {
            qty = parseFloat((qty / 1000).toFixed(3));
            unit = "kg";
        } else if (lowerUnit === "grams" || lowerUnit === "g" || lowerUnit === "gram" || lowerUnit === "ml" || lowerUnit === "milliliters") {
            qty = Math.round(qty);
        }

        return { qty, unit };
    };
    const [showPurchaseModal, setShowPurchaseModal] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [entriesPerPage, setEntriesPerPage] = useState(getStoredEntriesPerPage(10));
    const [productDetails, setProductDetails] = useState([]);
    const [distributionItems, setDistributionItems] = useState([]);
    const [totalDistributedQty, setTotalDistributedQty] = useState(0);
    const [rawMaterialsList, setRawMaterialsList] = useState([]);
    const [originalRawMaterials, setOriginalRawMaterials] = useState([]);

    const groupedDisplayMaterials = useMemo(() => {
        if (!rawMaterialsList || rawMaterialsList.length === 0) return [];
        const map = new Map();
        rawMaterialsList.forEach((mat) => {
            const key = String(mat.raw_mat_id || mat.raw_material_name);
            if (!map.has(key)) {
                map.set(key, { ...mat, qty: parseFloat(mat.qty || 0), price: parseFloat(mat.price || 0) });
            } else {
                const existing = map.get(key);
                existing.qty += parseFloat(mat.qty || 0);
                existing.price += parseFloat(mat.price || 0);
            }
        });
        return Array.from(map.values());
    }, [rawMaterialsList]);
    const [originalDesiredQty, setOriginalDesiredQty] = useState(0);
    const [loading, setLoading] = useState(false);
    const [distributionError, setDistributionError] = useState("");
    const [showExistingBatchModal, setShowExistingBatchModal] = useState(false);
    const [foundBatch, setFoundBatch] = useState(null);
    const [unitsList, setUnitsList] = useState([]);
    const [selectedCompletedProcess, setSelectedCompletedProcess] = useState(null);
    const [showCompletedDetailsModal, setShowCompletedDetailsModal] = useState(false);
    const [showBatchReportModal, setShowBatchReportModal] = useState(false);
    const [batchReportData, setBatchReportData] = useState(null);

    // State for New Distribution Flow (Images 3 & 4 Specs)
    const [newDistributionRows, setNewDistributionRows] = useState([
        {
            id: 1,
            product_qty: "",
            product_unit: "1",
            packaging_id: "",
            pack_qty: "",
            pack_unit: "pcs",
            wastage_val: "",
            wastage_unit: "pcs",
            pack_qty_edited: false
        }
    ]);

    const addNewDistributionRow = () => {
        const kgId = getAvailableUnits.find(u => u.title?.toUpperCase() === 'KG' || u.title?.toLowerCase() === 'kg')?.id || "1";
        const pcsId = getAvailableUnits.find(u => u.title?.toLowerCase() === 'pcs')?.id || "pcs";

        const newId = newDistributionRows.length > 0
            ? Math.max(...newDistributionRows.map(r => r.id || 0)) + 1
            : 1;
        setNewDistributionRows([
            ...newDistributionRows,
            {
                id: newId,
                product_qty: "",
                product_unit: kgId,
                packaging_id: "",
                pack_qty: "",
                pack_unit: pcsId,
                wastage_val: "",
                wastage_unit: pcsId,
                pack_qty_edited: false
            }
        ]);
    };

    const removeNewDistributionRow = (index) => {
        if (newDistributionRows.length === 1) {
            toast.info("At least one row is required in the new distribution flow.");
            return;
        }
        const updated = newDistributionRows.filter((_, i) => i !== index);
        setNewDistributionRows(updated);
    };

    const calculateAutoWastage = (row) => {
        if (!row || !row.packaging_id || !row.product_qty || !row.pack_qty) return null;

        const mat = rawMaterials.find(rm => String(rm.id) === String(row.packaging_id));
        if (!mat || !mat.title) return null;

        // Extract gram capacity from cover title (e.g. "10 Gram cover" -> 10, "100 Gram Pouch" -> 100)
        const match = mat.title.match(/(\d+(?:\.\d+)?)\s*(grams?|g|kgs?|kilograms?)?/i);
        if (!match) return null;

        let coverGrams = parseFloat(match[1]);
        const coverGramUnit = (match[2] || "gram").toLowerCase();
        if (coverGramUnit.startsWith("kg")) {
            coverGrams = coverGrams * 1000;
        }
        if (coverGrams <= 0) return null;

        // Product bulk powder weight in grams for this row
        let pQty = parseFloat(row.product_qty || 0);
        const pUnitTitle = (unitMap[String(row.product_unit)] || row.product_unit || "kg").toString().toLowerCase();
        let bulkGrams = pQty;
        if (pUnitTitle === "kg" || pUnitTitle === "kilogram" || pUnitTitle === "l" || pUnitTitle === "litre" || pUnitTitle === "li") {
            bulkGrams = pQty * 1000;
        }
        if (bulkGrams <= 0) return null;

        // Covers needed to pack bulk powder
        const neededPcs = bulkGrams / coverGrams;

        // Entered covers in pack_qty
        const pcsPerKg = parseFloat(row.pcs_per_kg || mat.pcs_per_kg || 0);
        const packUnitTitle = (unitMap[String(row.pack_unit)] || row.pack_unit || "pcs").toString().trim().toLowerCase();
        const isKgPackUnit = packUnitTitle === "kg" || packUnitTitle === "kilogram" || packUnitTitle === "1";
        const packQtyVal = parseFloat(row.pack_qty || 0);

        const enteredPcs = isKgPackUnit ? (packQtyVal * pcsPerKg) : packQtyVal;
        if (enteredPcs <= 0) return null;

        // Automatic wasted covers (pcs)
        const autoWastedPcs = Math.max(0, enteredPcs - neededPcs);

        // Convert autoWastedPcs into selected wastage_unit
        const wastageUnitRaw = String(row.wastage_unit || "pcs");
        const wastageUnitTitle = (wastageUnitRaw === "₹" || wastageUnitRaw === "rs")
            ? "₹"
            : (unitMap[wastageUnitRaw] || wastageUnitRaw || "pcs").toString().toLowerCase();

        let autoWastageVal = 0;
        if (wastageUnitTitle === "pcs" || wastageUnitTitle === "pack") {
            autoWastageVal = autoWastedPcs;
        } else if (wastageUnitTitle === "kg" || wastageUnitTitle === "1" || wastageUnitTitle === "kilogram" || wastageUnitTitle === "l" || wastageUnitTitle === "litre" || wastageUnitTitle === "li") {
            autoWastageVal = pcsPerKg > 0 ? (autoWastedPcs / pcsPerKg) : ((autoWastedPcs * coverGrams) / 1000);
        } else if (wastageUnitTitle === "gram" || wastageUnitTitle === "g" || wastageUnitTitle === "gm" || wastageUnitTitle === "grams" || wastageUnitTitle === "ml") {
            autoWastageVal = pcsPerKg > 0 ? ((autoWastedPcs / pcsPerKg) * 1000) : (autoWastedPcs * coverGrams);
        } else if (wastageUnitTitle === "₹") {
            const baseCoverPrice = parseFloat(mat.latest_price_unit || mat.price_unit || mat.cost_price || 0);
            const costPerPiece = pcsPerKg > 0 ? (baseCoverPrice / pcsPerKg) : baseCoverPrice;
            autoWastageVal = autoWastedPcs * costPerPiece;
        }

        return {
            neededPcs,
            enteredPcs,
            autoWastedPcs,
            autoWastageVal: parseFloat(autoWastageVal.toFixed(3))
        };
    };

    const handleNewRowChange = (index, field, value) => {
        const updated = [...newDistributionRows];
        updated[index] = { ...updated[index], [field]: value };

        if (field === "wastage_val") {
            updated[index].wastage_val_edited = true;
        }

        if (field === "packaging_id") {
            if (!value) {
                // Reset fields when "-- Select Material --" is selected
                updated[index].pcs_per_kg = "";
                updated[index].pack_qty = "";
                updated[index].pack_unit = "pcs";
                updated[index].pack_qty_edited = false;
                updated[index].wastage_val_edited = false;
            } else {
                const mat = rawMaterials.find(rm => String(rm.id) === String(value));
                if (mat) {
                    if (mat.pcs_per_kg !== null && mat.pcs_per_kg !== undefined && mat.pcs_per_kg !== "") {
                        updated[index].pcs_per_kg = String(mat.pcs_per_kg);
                    } else {
                        updated[index].pcs_per_kg = "";
                    }

                    const matUnitTitle = (unitMap[String(mat.unit_id)] || mat.unit_id || "").toString().trim().toLowerCase();
                    if (matUnitTitle === "kg" || matUnitTitle === "1") {
                        const kgUnitId = getAvailableUnits.find(u => u.title?.toUpperCase() === 'KG')?.id || "1";
                        updated[index].pack_unit = kgUnitId;
                        if (!updated[index].pack_qty_edited) {
                            updated[index].pack_qty = "";
                        }
                    } else {
                        const pcsUnitId = getAvailableUnits.find(u => u.title?.toLowerCase() === 'pcs')?.id || "pcs";
                        updated[index].pack_unit = pcsUnitId;
                        updated[index].pack_qty_edited = false;
                    }
                }
            }
        }

        if (field === "packaging_id" || field === "product_qty" || field === "product_unit") {
            const row = updated[index];
            const pMatId = row.packaging_id;
            const pQty = row.product_qty;
            const pUnitId = row.product_unit;

            if (pMatId && pQty) {
                const mat = rawMaterials.find(rm => String(rm.id) === String(pMatId));
                if (mat && mat.title) {
                    const matUnitTitle = (unitMap[String(mat.unit_id)] || mat.unit_id || "").toString().trim().toLowerCase();
                    const isKgMat = matUnitTitle === "kg" || matUnitTitle === "1";

                    // Only auto-fill suggested pack_qty in pcs if material is pcs type
                    if (!isKgMat) {
                        const match = mat.title.match(/^(\d+)\s*(grams?|g|kgs?|kilograms?)?/i);
                        if (match) {
                            const coverGrams = convertToGrams(match[1], match[2] || "grams");
                            let bulkGrams = parseFloat(pQty || 0);
                            const unitTitle = (unitMap[String(pUnitId)] || pUnitId || "kg").toString().toLowerCase();
                            if (unitTitle === "kg" || unitTitle === "kilogram" || unitTitle === "litre" || unitTitle === "li") {
                                bulkGrams = bulkGrams * 1000;
                            }
                            if (coverGrams > 0 && bulkGrams > 0) {
                                const calculatedPcs = Math.round(bulkGrams / coverGrams);
                                if (!row.pack_qty_edited) {
                                    updated[index].pack_qty = calculatedPcs.toString();
                                }
                            }
                        }
                    }
                }
            }
        }

        if (field === "pack_qty") {
            updated[index].pack_qty_edited = true;
        }

        // Auto-recalculate wastage if relevant fields changed
        if (["packaging_id", "product_qty", "product_unit", "pack_qty", "pack_unit", "wastage_unit"].includes(field)) {
            if (field === "wastage_unit") {
                updated[index].wastage_val_edited = false;
            }
            if (!updated[index].wastage_val_edited) {
                const autoRes = calculateAutoWastage(updated[index]);
                if (autoRes !== null && autoRes.autoWastedPcs >= 0) {
                    updated[index].wastage_val = String(autoRes.autoWastageVal);
                }
            }
        }

        setNewDistributionRows(updated);
    };

    const getNewRowCalculations = (row) => {
        const hasProductQty = row.product_qty !== undefined && row.product_qty !== null && String(row.product_qty).trim() !== "" && parseFloat(row.product_qty) > 0;
        const costPerKg = hasProductQty ? calculatePerUnitCost() : 0;
        const pQty = parseFloat(row.product_qty || 0);
        const pUnitTitle = (unitMap[String(row.product_unit)] || row.product_unit || "kg").toString().toLowerCase();
        let qtyInKg = pQty;
        if (pUnitTitle === "gram" || pUnitTitle === "g" || pUnitTitle === "gm" || pUnitTitle === "grams" || pUnitTitle === "ml") {
            qtyInKg = pQty / 1000;
        }

        // Product Bulk Cost based on entered Product Qty for this row
        const productBulkCost = qtyInKg * costPerKg;
        const rowProductCost = productBulkCost;

        let baseCoverPrice = 0;
        let selectedMat = null;
        if (row.packaging_id) {
            selectedMat = rawMaterials.find(rm => String(rm.id) === String(row.packaging_id));
            if (selectedMat) {
                baseCoverPrice = parseFloat(selectedMat.latest_price_unit || selectedMat.price_unit || selectedMat.cost_price || 0);
            }
        }

        const packUnitTitle = (unitMap[String(row.pack_unit)] || row.pack_unit || "pcs").toString().trim().toLowerCase();
        const isKgPackUnit = packUnitTitle === "kg" || packUnitTitle === "kilogram" || packUnitTitle === "1";

        const packQtyVal = parseFloat(row.pack_qty || 0);
        const pcsPerKg = parseFloat(row.pcs_per_kg || selectedMat?.pcs_per_kg || 0);
        const costPerPiece = pcsPerKg > 0 ? (baseCoverPrice / pcsPerKg) : baseCoverPrice;

        const calculatedPcs = isKgPackUnit ? (packQtyVal * pcsPerKg) : packQtyVal;

        // --- OLD CODE (Preserved) ---
        // const packCoverPrice = baseCoverPrice;

        // Dynamic pack cover price based on entered pack quantity (0 when no pack qty entered)
        const packCoverPrice = packQtyVal > 0 ? (calculatedPcs * costPerPiece) : 0;

        const wastageVal = parseFloat(row.wastage_val || 0);
        const wastageUnitRaw = String(row.wastage_unit || "");
        const wastageUnitTitle = (wastageUnitRaw === "₹" || wastageUnitRaw === "rs")
            ? "₹"
            : (unitMap[wastageUnitRaw] || wastageUnitRaw || "gram").toString().toLowerCase();

        let wastageCost = 0;
        if (wastageUnitTitle === "₹") {
            wastageCost = wastageVal;
        } else if (wastageUnitTitle === "gram" || wastageUnitTitle === "g" || wastageUnitTitle === "gm" || wastageUnitTitle === "ml") {
            wastageCost = (wastageVal / 1000) * costPerKg;
        } else if (wastageUnitTitle === "kg" || wastageUnitTitle === "l" || wastageUnitTitle === "litre" || wastageUnitTitle === "li") {
            wastageCost = wastageVal * costPerKg;
        } else if (wastageUnitTitle === "pcs" || wastageUnitTitle === "pack") {
            wastageCost = wastageVal * costPerPiece;
        }

        let wastedPcs = 0;
        if (wastageUnitTitle === "pcs" || wastageUnitTitle === "pack") {
            wastedPcs = wastageVal;
        } else if (wastageUnitTitle === "gram" || wastageUnitTitle === "g" || wastageUnitTitle === "gm" || wastageUnitTitle === "ml") {
            if (pcsPerKg > 0) wastedPcs = (wastageVal / 1000) * pcsPerKg;
        } else if (wastageUnitTitle === "kg" || wastageUnitTitle === "l" || wastageUnitTitle === "litre" || wastageUnitTitle === "li") {
            if (pcsPerKg > 0) wastedPcs = wastageVal * pcsPerKg;
        }

        const usablePcs = Math.max(0, calculatedPcs - wastedPcs);

        // Packaging Cover Cost for Usable Packets
        const packCoverTotalCost = usablePcs * costPerPiece;

        const overallCosting = rowProductCost + packCoverTotalCost + wastageCost;

        const perPieceCosting = usablePcs > 0
            ? (overallCosting / usablePcs)
            : (calculatedPcs > 0 ? (overallCosting / calculatedPcs) : 0);

        return {
            qtyInKg,
            costPerKg,
            productBulkCost,
            rowProductCost,
            baseCoverPrice,
            packCoverPrice,
            costPerPiece,
            packCoverTotalCost,
            wastageCost,
            overallCosting,
            perPieceCosting,
            isKgPackUnit,
            pcsPerKg,
            packQtyVal,
            calculatedPcs,
            wastedPcs,
            usablePcs
        };
    };

    const calculateNewDistributionSummary = () => {
        const totalBulkKg = parseFloat(
            activeProcess?.avl_qty !== undefined && activeProcess?.avl_qty !== null
                ? activeProcess.avl_qty
                : (activeProcess?.manufactured_qty || activeProcess?.desired_qty || 0)
        );

        let totalDistributedKg = 0;
        let totalPackCost = 0;
        let totalWastageCost = 0;
        let totalOverallCosting = 0;
        let totalPcs = 0;
        let totalUsablePcs = 0;

        newDistributionRows.forEach(row => {
            const calcs = getNewRowCalculations(row);
            totalDistributedKg += calcs.qtyInKg;
            totalPackCost += calcs.packCoverTotalCost;
            totalWastageCost += calcs.wastageCost;
            totalOverallCosting += calcs.overallCosting;
            totalPcs += calcs.calculatedPcs;
            totalUsablePcs += calcs.usablePcs;
        });

        const remainingKg = totalBulkKg - totalDistributedKg;
        const remainingGrams = remainingKg * 1000;
        const avgPerPieceCost = totalUsablePcs > 0
            ? (totalOverallCosting / totalUsablePcs)
            : (totalPcs > 0 ? (totalOverallCosting / totalPcs) : 0);

        return {
            totalBulkKg,
            totalDistributedKg,
            remainingKg,
            remainingGrams,
            totalPackCost,
            totalWastageCost,
            totalOverallCosting,
            totalPcs,
            totalUsablePcs,
            avgPerPieceCost
        };
    };

    const [newCharge, setNewCharge] = useState({ description: '', amount: '' });

    const [activeProcess, setActiveProcess] = useState(null);

    // Form data for creating new process (Step 1)
    const [formData, setFormData] = useState({
        p_id: "",
        desired_qty: "",
        unit: "kg",
        mfgdate: new Date().toISOString().split("T")[0],
        expdate: "",
        // warehouse_id: warehouse?.id || "0",
        shop_id: shopItem?.shop_id || "0",
        branch_id: UserItem?.user_id || "1",
        user_id: UserItem?.user_id || "10",
        created_by: UserItem?.user_id,
        ingredients: []
    });

    // Form data for manufacturing charges (Step 2)
    const [chargesData, setChargesData] = useState({
        processing_id: "",
        manufactured_qty: "",
        other_charges: "0",
        eb_rent_charges: "0",
        labour_charges: "0",
        package_charges: "0",
        status: "3",
        profit: "",
        // warehouse_id: warehouse?.id || "0",
        shop_id: shopItem?.shop_id || "0",
        branch_id: UserItem?.user_id || "1",
        user_id: UserItem?.user_id || "10",
        created_by: UserItem?.user_id,
        expiry_date: ""
    });

    // Form data for distribution (Step 3)
    const [distributionData, setDistributionData] = useState({
        processing_id: "",
        status: "4",
        created_by: UserItem?.user_id || "0",
        shop_id: shopItem?.shop_id || "0",
        branch_id: UserItem?.user_id || "1",
        // warehouse_id: warehouse?.id || "0",
        batch_distribution: []
    });

    const [formData1, setFormData1] = useState({
        p_id: "",
        p_code: "",
        p_weight: "",
        pbox_unit: "",
        p_price: "",
        pbox_qty: "",
        pbox_code: "",
        pbox_price: ""
    });

    const initialPurchaseState = {
        p_id: "",
        desired_qty: "",
        unit: "kg",
        mfgdate: "",
        expdate: "",
        oldbatchnum: "",
        from: "",
        purchase_prize: "",
        sale_prize: "",
        shop_id: shopItem?.shop_id || "0",
        branch_id: UserItem?.user_id || "1",
        warehouse_id: "1",
        created_by: UserItem?.user_id,
    };

    const [purchaseData, setPurchaseData] = useState(initialPurchaseState);
    const updatePurchase = (field, value) => {
        setPurchaseData(prev => ({
            ...prev,
            [field]: value === "" ? "" : value
        }));
    };

    const handleProductChange = (e) => {
        const productId = e.target.value;
        const selected = products.find(p => p.product_id == productId);

        setPurchaseData(prev => ({
            ...prev,
            p_id: productId,
            unit: selected?.unit ?? prev.unit
        }));
    };

    const resetModal = () => {
        setShowPurchaseModal(false);
        setPurchaseData(initialPurchaseState);
    };


    const handleCreateProcess1 = async (e) => {
        e.preventDefault();
        showLoader();

        try {
            // Safe helper variables to calculate totals
            const total_purchase = Number(purchaseData.desired_qty || 0) * Number(purchaseData.purchase_prize || 0);
            const total_sale = Number(purchaseData.desired_qty || 0) * Number(purchaseData.sale_prize || 0);

            const payload = {
                p_id: purchaseData.p_id,
                qty: Number(purchaseData.desired_qty),
                p_date: purchaseData.mfgdate,
                p_price: Number(purchaseData.purchase_prize),
                s_price: Number(purchaseData.sale_prize),
                // p_price: total_purchase,
                // s_price: total_sale,
                from_batch_no: purchaseData.oldbatchnum,
                exp_date: purchaseData.expdate,
                shop_id: shopItem?.shop_id || "0",
                branch_id: purchaseData.branch_id,
                warehouse_id: "1",
                created_by: UserItem?.user_id,
            };

            console.log("Payload sent to API:", payload);

            const res = await createPurchaseprocess(payload);
            const {
                status,
                message,
                batch_no,
                overall_cost,
                mfg_price_unit,
                sales_price_unit,
            } = res.data;


            if (status === "success") {
                toast.success(
                    <>
                        <div><strong>{message}</strong></div>
                        <div>Batch No: <b>{batch_no}</b></div>
                        {/* <div>MFG Price / Unit: <b>₹{mfg_price_unit}</b></div> */}
                        <div>Sales Price / Unit: <b>₹{sales_price_unit}</b></div>
                        {/* <div>Overall Cost: <b>₹{overall_cost}</b></div> */}
                    </>
                );

                const processingId = res.data.processing_id;
                const overallCost = Number(res.data.overall_cost);

                const generalDataBank = {
                    type: "2",
                    ref_id: processingId,
                    remarks: "Bank - To Product Processing Charges",
                    date: getFormattedCurrentDate2(),
                    created_by: UserItem?.user_id,
                    shop_id: shopItem?.id || "0",
                    amount: overallCost,
                    is_debit: "0", // Credit
                };

                await postGeneralData(generalDataBank);

                // 2️⃣ Product Processing Debit Entry
                const generalDataPP = {
                    type: "3.1",
                    ref_id: processingId,
                    remarks: "Product Processed",
                    date: getFormattedCurrentDate2(),
                    created_by: UserItem?.user_id,
                    shop_id: shopItem?.id || "0",
                    amount: overallCost,
                    is_debit: "1", // Debit
                };

                await postGeneralData(generalDataPP);

                fetchProcessList();
                resetModal();
            } else {
                toast.warn(message || "Unknown server response");
            }
        } catch (error) {
            console.error("Error creating purchase:", error);
            const errorMsg = error?.response?.data?.message || error.message || "Something went wrong";
            toast.error(errorMsg);
        } finally {
            hideLoader();
        }
    };


    const fetchUnitsList = async () => {
        try {
            const response = await getUnits();
            if (response.data && response.data.data) {
                setUnitsList(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching units:", error);
        }
    };

    const getUnitName = (unit_id) => {
        const unit = unitsList.find(u => u.id === unit_id);
        return unit ? unit.title : "-";
    };

    const getAvailableUnits = useMemo(() => {
        const list = [...unitsList];
        if (!list.some(u => String(u.title).toLowerCase() === "pcs")) {
            list.push({ id: "pcs", title: "pcs" });
        }
        return list;
    }, [unitsList]);

    const unitMap = useMemo(() => {
        const map = {};
        unitsList.forEach(u => {
            map[String(u.id)] = u.title;
        });
        map["pcs"] = "pcs";
        return map;
    }, [unitsList]);

    const getPackagingCardStyle = () => {
        if (!selectedPackagingId) return {};
        const pMat = rawMaterials.find(rm => String(rm.id) === String(selectedPackagingId));
        const unit = unitMap[String(pMat?.unit_id)] || pMat?.unit_id || "kg";
        if (unit.toLowerCase() === "pcs") {
            return { backgroundColor: "#d1e7dd" }; // beautiful light green
        } else if (unit.toLowerCase() === "kg") {
            return { backgroundColor: "#f8d7da" }; // beautiful light red
        }
        return {};
    };



    const [errors, setErrors] = useState({});
    const [errorss, setErrorss] = useState({});

    const [expenseItems, setExpenseItems] = useState([
        { id: 1, description: 'Labour Charges', amount: 0 },
        { id: 2, description: 'Package Charges', amount: 0 },
        { id: 3, description: 'EB/Rent Charges', amount: 0 },
        { id: 4, description: 'Other Charges', amount: 0 }
    ]);
    const [customExpenses, setCustomExpenses] = useState([]);

    // Packaging materials state variables
    const [selectedPackagingId, setSelectedPackagingId] = useState("");
    const [selectedPackagingQty, setSelectedPackagingQty] = useState("");
    const [selectedPackagingPrice, setSelectedPackagingPrice] = useState("");

    // Initial load
    useEffect(() => {
        fetchProducts();
        fetchProcessList();
        fetchProductDetails();
        fetchRawMaterials();
        fetchUnitsList();
    }, [location.pathname]);

    useEffect(() => {
        if (location.state && location.state.openCreateModal) {
            setCurrentStep(1);
            setShowCreateModal(true);
            // Clear the openCreateModal state from the history to prevent re-opening on reload or navigation change
            navigate(location.pathname, {
                replace: true,
                state: { ...location.state, openCreateModal: false }
            });
        }
    }, [location.state, location.pathname, navigate]);



    const fetchProducts = async () => {
        showLoader();
        try {
            const response = await getProductMaster();
            if (response.data && response.data.data) {
                setProducts(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching products:", error);
            toast.error("Failed to fetch products");
        } finally {
            hideLoader();
        }
    };

    const fetchRawMaterials = async () => {
        try {
            const response = await getRawMaterials();
            if (response.data && response.data.data) {
                setRawMaterials(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching raw materials:", error);
            toast.error("Failed to fetch raw materials");
        }
    };

    const fetchRawMaterialsForProcess = async (processingId) => {
        if (!processingId) {
            console.error("Cannot fetch raw materials: Process ID is undefined");
            toast.error("Error fetching raw materials: Invalid process ID");
            setRawMaterialsList([]);
            return;
        }

        try {
            console.log("Fetching raw materials for process ID:", processingId);
            showLoader();
            // Ensure timestamp is added for cache-busting
            const timestamp = new Date().getTime();
            const response = await list_raw_material_transactions(processingId, timestamp);

            if (response.data && response.data.transactions) {
                const rawMaterials = response.data.transactions;
                console.log("Raw materials data:", rawMaterials);
                setRawMaterialsList(rawMaterials);
                setOriginalRawMaterials(rawMaterials);
            } else {
                console.warn("No transactions found in response:", response.data);
                setRawMaterialsList([]);
                setOriginalRawMaterials([]);
            }
        } catch (error) {
            console.error("Error fetching raw materials:", error);
            toast.error("Failed to fetch raw materials data");
            setRawMaterialsList([]);
        } finally {
            hideLoader();
        }
    };


    const fetchProcessList = async (page = currentPage, search = "", limit = entriesPerPage) => {
        showLoader();
        try {
            const params = {
                shop_id: shopItem?.shop_id || "0",
                ware_id: warehouse?.id || "1",
                page,
                search,
                limit,
                page_size: limit,
            };

            const response = await get_product_processing(params);

            if (response.data && response.data.data) {
                console.log("Product Process List Data:", response.data.data);
                // setProcessList(response.data.data);
                let virtualList = [];
                try {
                    const ordersRes = await get_product_orders({
                        shop_id: shopItem?.shop_id || "0",
                        status: "3"
                    });
                    const ordersList = ordersRes.data?.data || [];
                    if (ordersList.length > 0) {
                        const orderDetailsResponses = await Promise.all(
                            ordersList.map(order => get_product_order_details({ om_id: order.id }))
                        );

                        orderDetailsResponses.forEach((res, idx) => {
                            const order = ordersList[idx];
                            const items = res.data?.data || [];
                            items.forEach(item => {
                                const exists = response.data.data.some(rp =>
                                    rp.p_id == item.p_id &&
                                    rp.remarks &&
                                    (rp.remarks.includes(order.order_id) || rp.remarks === `Order: ${order.order_id}`)
                                );

                                if (!exists) {
                                    const packetWeight = parseFloat(item.p_weight || 0);
                                    let calculatedQty = parseFloat(item.qty || 0);
                                    let calculatedUnit = "kg";

                                    if (packetWeight > 0) {
                                        calculatedQty = (calculatedQty * packetWeight) / 1000;
                                    }

                                    virtualList.push({
                                        id: `order_${order.order_id}_${item.p_id}`,
                                        p_id: item.p_id,
                                        product_title: item.product_title,
                                        desired_qty: parseFloat(calculatedQty.toFixed(3)),
                                        manufactured_qty: parseFloat(calculatedQty.toFixed(3)),
                                        unit: calculatedUnit,
                                        status: "0",
                                        batch_no: `Order #${order.order_id}`,
                                        create_date: item.create_date || order.date_time,
                                        shop_id: order.shop_id,
                                        warehouse_id: order.warehouse_id,
                                        branch_id: order.branch_id,
                                        created_by: order.created_by,
                                        is_order_based: true,
                                        order_id: order.order_id,
                                        order_db_id: order.id,
                                        order_item_id: item.id
                                    });
                                }
                            });
                        });
                    }
                } catch (err) {
                    console.error("Error fetching virtual order processes:", err);
                }

                const combinedList = [...virtualList, ...response.data.data];
                const calculatedTotalPages = response.data.pagination?.total_pages || Math.max(1, Math.ceil(combinedList.length / limit));
                setTotalPages(calculatedTotalPages);

                const startIndex = (page - 1) * limit;
                const endIndex = startIndex + limit;
                setProcessList(combinedList.slice(startIndex, endIndex));
            }
        } catch (error) {
            console.error("Error fetching process list:", error);
            toast.error("Failed to fetch process list");
        } finally {
            hideLoader();
        }
    };

    const fetchProductDetails = async () => {
        showLoader();
        try {
            const params = {
                shop_id: shopItem?.shop_id || "",
            };
            const response = await get_product_details(params);
            if (response.data && response.data.data) {
                setProductDetails(response.data.data);
                return response.data.data;
            }
            return [];
        } catch (error) {
            console.error("Error fetching product details:", error);
            toast.error("Failed to fetch product details");
            return [];
        } finally {
            hideLoader();
        }
    };

    const calculateRawMaterialTotal1 = () => {
        if (!rawMaterialsList || rawMaterialsList.length === 0) return 0;
        return rawMaterialsList.reduce((sum, item) => {
            const qty = parseFloat(item.qty || 0);
            const price = parseFloat(item.price || 0);
            return sum + qty * price;
        }, 0);
    };
    const calculateRawMaterialTotal = () => {
        if (!rawMaterialsList || rawMaterialsList.length === 0) return 0;
        return rawMaterialsList.reduce((sum, item) => {
            // const qty = parseFloat(item.qty || 0);
            const price = parseFloat(item.price || 0);
            return sum + price;
        }, 0);
    };


    const totalPackagingPrice = useMemo(() => {
        let total = 0;
        distributionItems.forEach(item => {
            if (item.packaging_id) {
                total += parseFloat(item.packaging_qty || 0) * parseFloat(item.packaging_price || 0);
            }
        });
        return total.toFixed(2);
    }, [distributionItems]);

    const calculateTotalCost = () => {
        const rawMaterialCost = calculateRawMaterialTotal();
        const standardExpensesTotal = expenseItems.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
        const customExpensesTotal = customExpenses.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
        const packagingCost = parseFloat(totalPackagingPrice || 0);
        return rawMaterialCost + standardExpensesTotal + customExpensesTotal + packagingCost;
    };

    const calculatePerUnitCost = () => {
        const totalCost = calculateTotalCost();
        const manufacturedQty = parseFloat(chargesData.manufactured_qty || activeProcess?.desired_qty || activeProcess?.manufactured_qty || 0);
        if (totalCost > 0 && manufacturedQty > 0) {
            return totalCost / manufacturedQty;
        }

        if (activeProcess) {
            const directPerUnitCost = parseFloat(
                activeProcess.mfg_price_unit ||
                activeProcess.cost_per_kg ||
                activeProcess.per_unit_cost ||
                activeProcess.price_per_kg ||
                activeProcess.unit_price ||
                activeProcess.cost_price ||
                0
            );
            if (directPerUnitCost > 0) {
                return directPerUnitCost;
            }

            const overallCost = parseFloat(activeProcess.overall_price || activeProcess.total_cost || 0);
            const processQty = parseFloat(
                activeProcess.manufactured_qty ||
                activeProcess.desired_qty ||
                activeProcess.avl_qty ||
                activeProcess.mfg_qty ||
                0
            );
            if (overallCost > 0 && processQty > 0) {
                return overallCost / processQty;
            }
        }
        return 0;
    };

    const formatWithoutRounding = (num) => {
        if (!num || isNaN(num)) return "0.00";
        const str = num.toString();
        if (str.includes('.')) {
            const parts = str.split('.');
            return `${parts[0]}.${parts[1].substring(0, 2).padEnd(2, '0')}`;
        }
        return `${str}.00`;
    };


    const fetchIngredientsFromProductMaster = (productId) => {
        if (!productId) return;

        try {
            const product = products.find(p => String(p.product_id) === String(productId));
            if (product && product.ingridents) {
                const ingredientsData = JSON.parse(product.ingridents);

                if (Array.isArray(ingredientsData) && ingredientsData.length > 0) {
                    const weightLimit = parseFloat(String(product.weight_limit || '1').match(/([\d.]+)/)?.[1]) || 1;
                    const desiredQty = parseFloat(formData.desired_qty) || 0;
                    const enrichedIngredients = ingredientsData.map(ing => {
                        // const rawMaterial = rawMaterials.find(rm => String(rm.id) === String(ing.id));
                        const itemType = ing.item_type || "raw";
                        const baseQty = parseFloat(ing.qty) || 0;
                        const rawMaterial = rawMaterials.find(rm => String(rm.id) === String(ing.id));
                        const isLitre = rawMaterial && String(rawMaterial.type) === "2";
                        const calcQty = desiredQty > 0 ? parseFloat((baseQty * (desiredQty / weightLimit)).toFixed(3)) : baseQty;
                        const normalized = normalizeIngredientQtyAndUnit(calcQty, ing.unit, isLitre);

                        if (itemType === "product") {
                            const prod = products.find(p => String(p.product_id || p.id) === String(ing.id));
                            return {
                                id: ing.id,
                                item_type: "product",
                                title: prod ? `${prod.title} (Readymade)` : `Product #${ing.id} (Readymade)`,
                                remaining_stock: prod ? (parseFloat(prod.qty || prod.remaining_stock || 0)) : 0,
                                base_qty: baseQty,
                                unit: ing.unit,
                                custom_qty: normalized.qty,
                                custom_unit: normalized.unit
                            };
                        } else {
                            return {
                                id: ing.id,
                                item_type: "raw",
                                title: rawMaterial ? `${rawMaterial.title} (Raw Material)` : `Raw Material #${ing.id}`,
                                remaining_stock: rawMaterial ? rawMaterial.remaining_stock : 0,
                                base_qty: baseQty,
                                unit: ing.unit,
                                custom_qty: normalized.qty,
                                custom_unit: normalized.unit
                            };
                        }
                    });

                    setIngredientsList(enrichedIngredients);
                    setSelectedProduct(product);
                } else {
                    setIngredientsList([]);
                    setSelectedProduct(product);
                }
            } else {
                setIngredientsList([]);
                setSelectedProduct(null);
            }
        } catch (error) {
            console.error("Error parsing ingredients:", error);
            toast.error("Failed to parse product ingredients");
            setIngredientsList([]);
        }
    };

    const prepareDistribution = (processData, customProductDetails = null) => {
        if (!processData) return;

        showLoader();
        try {
            const detailsToUse = customProductDetails || productDetails;
            const relevantDetails = detailsToUse.filter(detail =>
                String(detail.p_id) === String(processData.p_id || processData.product_id)
            );

            if (relevantDetails.length === 0) {
                toast.warning("No package details found for this product. Please add product details.");
                hideLoader();
                return;
            }

            let processQtyInGrams = convertToGrams(
                processData.avl_qty !== undefined && processData.avl_qty !== null
                    ? processData.avl_qty
                    : (processData.manufactured_qty || processData.mfg_qty || processData.desired_qty),
                processData.unit || "kg"
            );

            // Create distribution items
            const items = relevantDetails.map((detail, idx) => {
                const rawWeight = parseFloat(detail.p_weight || 0);
                const weightInGrams = convertToGrams(rawWeight, detail.pbox_unit);
                return {
                    row_id: `row_${idx}_${Date.now()}_${Math.random().toString(36).substring(2, 6)}`,
                    id: detail.id,
                    pbox_unit: detail.pbox_unit,
                    product_title: detail.product_title || `${rawWeight} ${detail.pbox_unit || 'g'} Package`,
                    p_weight: rawWeight,
                    weight_in_grams: weightInGrams,
                    qty: 0,
                    pbox_code: detail.pbox_code,
                    packaging_id: "",
                    packaging_qty: "",
                    packaging_price: "0",
                    packaging_unit: "pcs"
                };
            });

            setDistributionItems(items);
            setDistributionData(prev => ({
                ...prev,
                processing_id: processData.id || activeProcessId
            }));

            // Calculate suggested distribution based on weights in grams
            calculateSuggestedDistribution(items, processQtyInGrams);
        } catch (error) {
            console.error("Error preparing distribution:", error);
            toast.error("Failed to prepare distribution");
        } finally {
            hideLoader();
        }
    };

    const calculateSuggestedDistribution = (items, totalWeight) => {
        if (!items || items.length === 0) return;

        const getItemGrams = (item) => item.weight_in_grams || convertToGrams(item.p_weight, item.pbox_unit);

        const sortedItems = [...items].sort((a, b) => getItemGrams(b) - getItemGrams(a));
        let remainingWeight = totalWeight;
        const distributedItems = [...items];

        while (remainingWeight > 0 && distributedItems.some(item => getItemGrams(item) <= remainingWeight)) {
            const itemToUse = distributedItems.find(item => getItemGrams(item) <= remainingWeight);
            if (!itemToUse) break;

            const itemGrams = getItemGrams(itemToUse);
            if (!itemGrams || itemGrams <= 0) break;

            const itemIndex = distributedItems.findIndex(i => i.id === itemToUse.id);
            const newQty = (distributedItems[itemIndex].qty || 0) + 1;
            distributedItems[itemIndex].qty = newQty;
            if (distributedItems[itemIndex].packaging_id) {
                distributedItems[itemIndex].packaging_qty = newQty.toString();
            }
            remainingWeight -= itemGrams;
        }

        if (remainingWeight > 0) {
            const losePacksIndex = distributedItems.findIndex(item =>
                item.pbox_code === "FREE SIZE / LOSE QTY" || item.id === "FREE_SIZE"
            );
            if (losePacksIndex !== -1) {
                const itemGrams = getItemGrams(distributedItems[losePacksIndex]);
                if (itemGrams > 0) {
                    const extraQty = remainingWeight / itemGrams;
                    const newQty = (distributedItems[losePacksIndex].qty || 0) + extraQty;
                    distributedItems[losePacksIndex].qty = parseFloat(newQty.toFixed(3));
                    if (distributedItems[losePacksIndex].packaging_id) {
                        distributedItems[losePacksIndex].packaging_qty = parseFloat(newQty.toFixed(3)).toString();
                    }
                    remainingWeight = 0;
                }
            }
        }

        setDistributionItems(distributedItems);
        calculateTotalDistributed(distributedItems);
    };

    // Handle form change for step 1
    const handleFormChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));

        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ""
            }));
        }

        if (name === "desired_qty") {
            const newQty = parseFloat(value) || 0;
            const weightLimit = selectedProduct ? (parseFloat(String(selectedProduct.weight_limit || '1').match(/([\d.]+)/)?.[1]) || 1) : 1;
            setIngredientsList(prev => prev.map(ing => {
                const base = parseFloat(ing.base_qty) || 0;
                const rawMat = rawMaterials.find(rm => String(rm.id) === String(ing.id));
                const isLitre = rawMat && String(rawMat.type) === "2";
                const calcQty = newQty > 0 ? parseFloat((base * (newQty / weightLimit)).toFixed(3)) : base;
                const normalized = normalizeIngredientQtyAndUnit(calcQty, ing.unit, isLitre);
                return {
                    ...ing,
                    custom_qty: normalized.qty,
                    custom_unit: normalized.unit
                };
            }));
        }

        //new
        if (name === "p_id" && value) {
            fetchIngredientsFromProductMaster(value);

            checkExistingProcessedProduct(value).then((batch) => {
                if (batch) {
                    setFoundBatch(batch);
                    setShowExistingBatchModal(true);
                    toast.info(`Existing Batch Found: ${batch.batch_no} (Remaining: ${Number(batch.remaining).toFixed(3)} ${batch.unit})`);
                }
            });

            // Pre-fill unit from product master
            const selectedProd = products.find(p => p.product_id == value);
            if (selectedProd && selectedProd.unit) {
                setFormData(prev => ({
                    ...prev,
                    unit: selectedProd.unit
                }));
            }
        }


    };


    const handleUseRemainingStock = async () => {
        if (!foundBatch) return;

        setShowExistingBatchModal(false);
        setShowCreateModal(false);

        const processId = foundBatch.processing_id;

        setActiveProcess({
            id: processId,
            product_id: foundBatch.p_id,
            product_title: foundBatch.product_name,
            manufactured_qty: foundBatch.remaining,
            unit: foundBatch.unit,
            batch_no: foundBatch.batch_no,
            processing_id: processId
        });

        setActiveProcessId(processId);

        await fetchRawMaterialsForProcess(processId);

        prepareDistribution({
            id: processId,
            product_id: foundBatch.p_id,
            manufactured_qty: foundBatch.remaining,
            unit: foundBatch.unit,
        });

        setCurrentStep(3);
    };


    const handleContinueNewProcess = () => {
        setShowExistingBatchModal(false);
        setCurrentStep(1);
        setShowCreateModal(true);
    };

    const handleIngredientQtyChange = (index, value) => {
        const updatedIngredients = [...ingredientsList];
        updatedIngredients[index].custom_qty = value;
        setIngredientsList(updatedIngredients);
    };

    const handleIngredientUnitChange = (index, value) => {
        const updatedIngredients = [...ingredientsList];
        updatedIngredients[index].custom_unit = value;
        setIngredientsList(updatedIngredients);
    };

    const handleExpenseChange = (id, value) => {
        const updatedItems = expenseItems.map(item =>
            item.id === id ? { ...item, amount: value } : item
        );
        setExpenseItems(updatedItems);
    };

    const handleChargesChange = (e) => {
        const { name, value } = e.target;
        setChargesData(prev => ({
            ...prev,
            [name]: value
        }));
    };




    const convertToGrams = (value, unit) => {
        const val = parseFloat(value || 0);
        if (!unit) return val;
        const normalized = unit.toLowerCase();

        switch (normalized) {
            case "kg":
            case "kilogram":
            case "kilograms":
                return val * 1000;
            case "mg":
            case "milligram":
            case "milligrams":
                return val / 1000;
            case "g":
            case "gram":
            case "grams":
            default:
                return val;
        }
    };

    const getTargetInGrams = (process) => {
        const rawQty = parseFloat(process.manufactured_qty || process.desired_qty || 0);
        const unit = process.qty_unit || "g";
        return convertToGrams(rawQty, unit);
    };

    const getAvailableWeightOptions = () => {
        const targetPId = activeProcess?.product_id || activeProcess?.p_id;
        const detailsToUse = productDetails.filter(detail =>
            String(detail.p_id) === String(targetPId)
        );
        const hasFreeSize = detailsToUse.some(d => d.pbox_code === "FREE SIZE / LOSE QTY" || d.id === "FREE_SIZE");
        if (!hasFreeSize && detailsToUse.length > 0) {
            return [
                ...detailsToUse,
                {
                    id: "FREE_SIZE",
                    pbox_code: "FREE SIZE / LOSE QTY",
                    p_weight: 1,
                    pbox_unit: "kilograms",
                    product_title: "Lose Packs"
                }
            ];
        }
        return detailsToUse;
    };

    const handleRowWeightChange = (rowIdOrIndex, selectedDetailId) => {
        const options = getAvailableWeightOptions();
        const selectedDetail = options.find(d => String(d.id) === String(selectedDetailId));
        if (!selectedDetail) return;

        const rawWeight = parseFloat(selectedDetail.p_weight || 0);
        const weightInGrams = convertToGrams(rawWeight, selectedDetail.pbox_unit);

        const updated = distributionItems.map((item, idx) => {
            if (item.row_id === rowIdOrIndex || idx === rowIdOrIndex || item.id === rowIdOrIndex) {
                return {
                    ...item,
                    id: selectedDetail.id,
                    pbox_unit: selectedDetail.pbox_unit,
                    product_title: selectedDetail.product_title || `${rawWeight} ${selectedDetail.pbox_unit || 'g'} Package`,
                    p_weight: rawWeight,
                    weight_in_grams: weightInGrams,
                    pbox_code: selectedDetail.pbox_code,
                };
            }
            return item;
        });
        setDistributionItems(updated);
        calculateTotalDistributed(updated);
    };

    const handleDistributionQtyChange = (targetId, value) => {
        if (value === "") {
            const updatedItems = distributionItems.map((item) =>
                (item.row_id === targetId || item.id === targetId) ? { ...item, qty: "", packaging_qty: "" } : item
            );
            setDistributionItems(updatedItems);
            calculateTotalDistributed(updatedItems);
            return;
        }

        const newQty = parseFloat(value) || 0;
        if (newQty < 0) {
            toast.warning("Quantity cannot be negative");
            return;
        }

        const updatedItems = distributionItems.map((item) =>
            (item.row_id === targetId || item.id === targetId) ? { ...item, qty: value, packaging_qty: item.packaging_id ? value : item.packaging_qty } : item
        );

        setDistributionItems(updatedItems);
        calculateTotalDistributed(updatedItems);
    };

    const handleRowPackagingIdChange = (targetId, val) => {
        const updatedItems = distributionItems.map(item => {
            if (item.row_id === targetId || item.id === targetId) {
                if (!val) {
                    return {
                        ...item,
                        packaging_id: "",
                        packaging_qty: "",
                        packaging_price: "0",
                        packaging_unit: "pcs"
                    };
                }
                const rawMat = rawMaterials.find(rm => String(rm.id) === String(val));
                if (rawMat) {
                    const price = rawMat.latest_price_unit || "0";
                    const unit = unitMap[String(rawMat.unit_id)] || rawMat.unit_id || "pcs";

                    const match = rawMat.title.match(/^(\d+)\s*(grams?|g|kgs?|kilograms?)?/i);
                    if (match && item.id !== "FREE_SIZE" && item.pbox_code !== "FREE SIZE / LOSE QTY") {
                        const coverSizeGrams = convertToGrams(match[1], match[2]);
                        const packageWeightGrams = convertToGrams(item.p_weight, item.pbox_unit);
                        if (packageWeightGrams !== coverSizeGrams) {
                            toast.error(`Cannot select ${rawMat.title}. The packaging size must match the package weight (${item.p_weight} ${item.pbox_unit || 'grams'}).`);
                            return item;
                        }
                    }

                    return {
                        ...item,
                        packaging_id: val,
                        packaging_price: price,
                        packaging_qty: item.qty ? item.qty.toString() : "",
                        packaging_unit: unit
                    };
                }
            }
            return item;
        });
        setDistributionItems(updatedItems);
    };

    const handleRowPackagingQtyChange = (targetId, val) => {
        if (val === "") {
            const updatedItems = distributionItems.map(item =>
                (item.row_id === targetId || item.id === targetId) ? { ...item, packaging_qty: "" } : item
            );
            setDistributionItems(updatedItems);
            return;
        }
        const newQty = parseFloat(val) || 0;
        if (newQty < 0) return;
        const updatedItems = distributionItems.map(item =>
            (item.row_id === targetId || item.id === targetId) ? { ...item, packaging_qty: val } : item
        );
        setDistributionItems(updatedItems);
    };

    const calculateTotalDistributed = (items) => {
        let totalInGrams = 0;

        items.forEach((item) => {
            const weightInGrams = convertToGrams(item.p_weight, item.pbox_unit);
            // const qty = parseInt(item.qty || 0);
            const qty = parseFloat(item.qty || 0);
            totalInGrams += weightInGrams * qty;
        });

        setTotalDistributedQty(totalInGrams);

        setDistributionData((prev) => ({
            ...prev,
            batch_distribution: items
                .filter((item) => item.qty > 0)
                .map((item) => ({
                    id: item.id,
                    qty: item.qty,
                })),
        }));
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData1({ ...formData1, [name]: value });
    };

    const handleProductSelect = (e) => {
        const productId = e.target.value;
        const selectedProduct = products.find(
            (p) => p.product_id.toString() === productId
        );

        setFormData1({
            ...formData1,
            p_id: productId,
            p_code: selectedProduct?.product_code || "",
            pbox_unit: selectedProduct?.unit || "",
            p_price: selectedProduct?.sales_price || "",
            pbox_qty: selectedProduct?.box_qty || "",
            pbox_code: selectedProduct?.box_barcode || "",
            pbox_price: selectedProduct?.box_sales || ""
        });
    };

    const validateForm = (step) => {
        const newErrors = {};

        if (step == 1) {
            if (!formData.p_id) newErrors.p_id = "Product is required";
            if (!formData.desired_qty) newErrors.desired_qty = "Desired quantity is required";
            if (!formData.unit) newErrors.unit = "Unit is required";
            // if (!formData.expdate) newErrors.expdate = "Expiry date is required";
        }

        if (step == 2) {
            if (!chargesData.manufactured_qty) newErrors.manufactured_qty = "Manufactured quantity is required";
            // if (!chargesData.expiry_date) newErrors.expiry_date = "Expiry date is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateProductDetails = () => {
        const temp = {};
        if (!formData1.p_id) temp.p_id = "Product is required";
        if (!formData1.p_weight) temp.p_weight = "Weight is required";
        if (!formData1.pbox_unit) temp.pbox_unit = "Unit is required";
        if (!formData1.p_price) temp.p_price = "Price is required";

        // Check for duplicate weight and unit in the same product
        const targetPId = formData1.p_id?.toString();
        const targetWeight = parseFloat(formData1.p_weight);
        const targetUnit = formData1.pbox_unit?.trim().toLowerCase();

        if (targetPId && !isNaN(targetWeight) && targetUnit) {
            const isDuplicate = productDetails.some(detail => {
                // Skip check for "FREE SIZE / LOSE QTY" default details
                if (detail.pbox_code === "FREE SIZE / LOSE QTY") return false;

                const detPId = detail.p_id?.toString();
                const detWeight = parseFloat(detail.p_weight);
                const detUnit = detail.pbox_unit?.trim().toLowerCase();

                return (
                    detPId === targetPId &&
                    !isNaN(detWeight) &&
                    Math.abs(detWeight - targetWeight) < 0.0001 &&
                    detUnit === targetUnit
                );
            });

            if (isDuplicate) {
                temp.p_weight = "This product weight already exists.";
                temp.pbox_unit = "This product weight already exists.";
                toast.error(`Product weight pack '${formData1.p_weight} ${formData1.pbox_unit}' already exists for this product.`);
            }
        }

        setErrorss(temp);
        return Object.keys(temp).length === 0;
    };



    const validateDistribution = () => {
        if (!activeProcess) return false;

        let processQtyKg = parseFloat(
            activeProcess.avl_qty !== undefined && activeProcess.avl_qty !== null
                ? activeProcess.avl_qty
                : activeProcess.manufactured_qty
        );
        let processQtyInGrams = processQtyKg * 1000;

        // if (processQtyInGrams < 100) {
        //     processQtyInGrams = processQtyInGrams * 1000; // convert to grams if needed
        // }

        setDistributionError("");

        if (totalDistributedQty === 0) {
            setDistributionError("Please enter at least one distribution quantity");
            return false;
        }

        const tolerance = Math.max(processQtyInGrams * 0.001, 1); // 0.1% tolerance or 1g

        // Only check if total exceeds the allowed max
        if (totalDistributedQty > processQtyInGrams + tolerance) {
            const excess = totalDistributedQty - processQtyInGrams;
            setDistributionError(`Distribution exceeds the allowed quantity by ${excess.toFixed(0)} grams. Please adjust quantities.`);
            return false;
        }

        if (totalDistributedQty < processQtyInGrams) {
            const shortage = processQtyInGrams - totalDistributedQty;
            setDistributionError(`Distribution is short by ${shortage.toFixed(0)} grams.`);
            // return true; // still allow
        }

        return true;
    };


    // --- OLD DUP ISDISTRIBUTIONCOMPLETE (Preserved) ---
    /*
    const isDistributionComplete = () => {
        if (!activeProcess) return false;

        let processQty = parseFloat(
            activeProcess.avl_qty !== undefined && activeProcess.avl_qty !== null
                ? activeProcess.avl_qty
                : activeProcess.manufactured_qty
        );
        // let processQtyInGrams = processQty < 100 ? processQty * 1000 : processQty;
        let processQtyInGrams = processQty * 1000;

        const tolerance = Math.max(processQtyInGrams * 0.001, 1); // 0.1% tolerance or 1g

        // Allow distribution as long as it doesn't exceed max allowed
        return totalDistributedQty <= processQtyInGrams + tolerance;
    };
    */

    // --- OLD DUP CHECKEXISTINGPROCESSEDPRODUCT (Preserved) ---
    /*
    const checkExistingProcessedProduct = async (productId) => {
        try {
            // Call your existing axios API function
            const response = await listProductQty({}, productId);

            if (
                response.data &&
                response.data.status === "success" &&
                response.data.data &&
                response.data.data.length > 0
            ) {
                const batch = response.data.data[0];

                if (parseFloat(batch.remaining || 0) > 0) {
                    return batch; // return existing batch
                }
            }

            return null;
        } catch (err) {
            console.error("Error checking product qty:", err);
            return null;
        }
    };
    */




    // Submit handlers for each step
    const handleCreateProcess = async (e) => {
        e.preventDefault();

        if (isSubmitting) return;
        if (!validateForm(1)) return;

        // Check if any ingredient quantity is 0, empty, null, or undefined
        const hasZeroQty = ingredientsList.some(
            (ing) =>
                parseFloat(ing.custom_qty) === 0 ||
                ing.custom_qty === "" ||
                ing.custom_qty === null ||
                ing.custom_qty === undefined
        );
        if (hasZeroQty) {
            const proceed = window.confirm("Some raw material quantity is 0. Can you proceed?");
            if (!proceed) {
                return;
            }
        }

        setIsSubmitting(true);

        if (activeProcessId) {
            showLoader();
            try {
                const processDetails = {
                    ...activeProcess,
                    product_id: formData.p_id,
                    product_title: products.find(p => p.product_id == formData.p_id)?.title || activeProcess.product_title || "Product",
                    desired_qty: formData.desired_qty,
                    unit: formData.unit,
                    exp_date: formData.expdate
                };
                setActiveProcess(processDetails);

                setChargesData(prev => ({
                    ...prev,
                    processing_id: activeProcessId,
                    manufactured_qty: formData.desired_qty,
                    expiry_date: formData.expdate
                }));

                await fetchRawMaterialsForProcess(activeProcessId);
                setCurrentStep(2);
            } catch (error) {
                console.error("Error in Step 1 Edit transition:", error);
                toast.error("Failed to transition to Step 2");
            } finally {
                hideLoader();
                setIsSubmitting(false);
            }
            return;
        }

        showLoader();
        try {
            const processIngredients = ingredientsList
                .filter(ing => ing.custom_unit)
                .map(ing => ({
                    id: ing.id,
                    item_type: ing.item_type || "raw",
                    qty: ing.custom_qty !== undefined && ing.custom_qty !== "" ? Number(ing.custom_qty) : 0,
                    unit: ing.custom_unit
                }));

            const processData = {
                product_id: Number(formData.p_id),
                desired_qty: Number(formData.desired_qty),
                unit: formData.unit,
                warehouse_id: warehouse?.id || "0",
                shop_id: shopItem?.shop_code || shopItem?.shop_id || "",
                branch_id: localStorage.getItem("branch_code") || "0",
                user_id: UserItem?.user_code || UserItem?.user_id || "0",
                created_by: UserItem?.user_code || UserItem?.user_id || "0",
                expdate: formData.expdate || "-",
                mfgdate: formData.mfgdate || "-",
                ingredients: processIngredients,
                remarks: activeProcess?.is_order_based ? `Order: ${activeProcess.order_id}` : ""
            };

            console.log("Creating process with data:", processData);

            const response = await create_product_processing(processData);

            if (response.data && response.data.status === "success") {
                toast.success("Process created successfully");

                const processId = await (response.data.id ||
                    response.data.process_id ||
                    response.data.processing_id ||
                    response.data.data?.id ||
                    response.data.process?.id);

                console.log("Extracted process ID:", processId);

                // if (!activeProcess?.is_order_based) {
                //     setShowCreateModal(false);
                //     setShowPurchaseModal(false);
                //     resetMainForm();
                //     fetchProcessList();
                //     return;
                // }

                if (!processId) {
                    resetMainForm();
                    fetchProcessList();
                    return;
                }

                setActiveProcessId(processId);

                const processDetails = {
                    id: processId,
                    product_id: formData.p_id,
                    product_title: products.find(p => p.product_id == formData.p_id)?.title || "Product",
                    desired_qty: formData.desired_qty,
                    unit: formData.unit,
                    exp_date: formData.expdate,
                    // is_order_based: true,
                    is_order_based: !!activeProcess?.is_order_based,
                    order_id: activeProcess?.order_id,
                    order_db_id: activeProcess?.order_db_id
                };
                setActiveProcess(processDetails);

                setChargesData({
                    ...chargesData,
                    processing_id: processId,
                    manufactured_qty: formData.desired_qty,
                    expiry_date: formData.expdate
                });
                setOriginalDesiredQty(parseFloat(formData.desired_qty || 0));

                setTimeout(async () => {
                    await fetchRawMaterialsForProcess(processId);
                    setCurrentStep(2);
                }, 500);
            } else {
                toast.error(response.data?.message || "Failed to create process");
            }
        } catch (error) {
            console.error("Error creating process:", error);
            const errorData = error?.response?.data;
            if (errorData?.status === "error" && errorData?.details) {
                const insufficientDetails = errorData.details
                    .map(d => `${d.raw_mat_name || `Ingredient #${d.raw_mat_id}`} (Required: ${d.required.toFixed(2)}, Available: ${d.available.toFixed(2)})`)
                    .join(", ");
                toast.error(`Insufficient stock for: ${insufficientDetails}`);
            } else {
                toast.error(errorData?.message || "Error creating process");
            }
        } finally {
            hideLoader();
            setIsSubmitting(false);
        }
    };

    const handleManufacturingSubmit = async (e) => {
        e.preventDefault();

        if (isSubmitting) return;
        if (!validateForm(2)) return;

        if (!activeProcessId) {
            toast.error("Missing process ID. Please restart the process.");
            return;
        }

        setIsSubmitting(true);
        showLoader();
        try {
            // Stock verification for selected packaging material
            if (selectedPackagingId) {
                if (!selectedPackagingQty || parseFloat(selectedPackagingQty) <= 0) {
                    toast.error("Please enter a valid quantity for the selected packaging material.");
                    hideLoader();
                    return;
                }
                const rawMat = rawMaterials.find(rm => String(rm.id) === String(selectedPackagingId));
                if (rawMat && parseFloat(selectedPackagingQty) > parseFloat(rawMat.remaining_stock || 0)) {
                    toast.error(`Insufficient packaging material stock! Available: ${parseFloat(rawMat.remaining_stock || 0).toFixed(2)} ${unitMap[String(rawMat.unit_id)] || rawMat.unit_id || 'kg'}`);
                    hideLoader();
                    return;
                }
            }

            // Sum all standard and custom charges to check against bank balance
            const standardExpensesTotal = expenseItems.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
            const customExpensesTotal = customExpenses.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);
            const totalRequiredExpenses = standardExpensesTotal + customExpensesTotal;

            if (totalRequiredExpenses > 0) {
                try {
                    const balanceRes = await getBankBalance(shopItem?.id || shopItem?.shop_id || "0");
                    const bankBalance = balanceRes?.data?.bank_balance !== undefined ? parseFloat(balanceRes.data.bank_balance) : null;

                    if (bankBalance !== null && totalRequiredExpenses > bankBalance) {
                        toast.error(`Insufficient balance! Total Charges: ₹${totalRequiredExpenses.toFixed(2)}, Available Bank/Cash Balance: ₹${bankBalance.toFixed(2)}`);
                        hideLoader();
                        return; // Stop the user
                    }
                } catch (balanceError) {
                    console.error("Error checking bank balance:", balanceError);
                    toast.error("Failed to verify bank/cash balance. Please try again.");
                    hideLoader();
                    return; // Stop the user
                }
            }

            const allExpenses = [
                ...expenseItems,
                ...customExpenses
            ];

            const otherChargesTotal = customExpenses.reduce(
                (sum, item) => sum + parseFloat(item.amount || 0),
                0
            ).toString();

            const packagingMaterialsPayload = selectedPackagingId && selectedPackagingQty ? [{
                raw_mat_id: selectedPackagingId,
                qty: selectedPackagingQty,
                price_unit: selectedPackagingPrice,
                total_price: (parseFloat(selectedPackagingQty) * parseFloat(selectedPackagingPrice)).toString(),
                unit: (() => { const rm = rawMaterials.find(rm => String(rm.id) === String(selectedPackagingId)); return (unitMap[String(rm?.unit_id)] || rm?.unit_id || "kg").toString().toLowerCase(); })()
            }] : [];

            const manufacturingData = {
                processing_id: activeProcessId,
                desired_qty: activeProcess.desired_qty,
                manufactured_qty: chargesData.manufactured_qty,
                profit: Number(chargesData.profit) || 0,
                other_charges: expenseItems.find(i => i.description === 'Other Charges')?.amount || "0",
                eb_rent_charges: expenseItems.find(i => i.description === 'EB/Rent Charges')?.amount || "0",
                labour_charges: expenseItems.find(i => i.description === 'Labour Charges')?.amount || "0",
                package_charges: expenseItems.find(i => i.description === 'Package Charges')?.amount || "0",
                status: "3",
                shop_id: shopItem?.shop_id || "0",
                branch_id: UserItem?.user_id || "0",
                user_id: UserItem?.user_id || "0",
                created_by: UserItem?.user_id,
                expiry_date: chargesData.expiry_date,
                custom_expenses: customExpenses.map(item => ({
                    title: item.description,
                    amount: item.amount
                })),
                packaging_materials: packagingMaterialsPayload
            };

            console.log("Submitting manufacturing data:", manufacturingData);

            // if (customExpenses && customExpenses.length > 0) {
            //     for (const item of customExpenses) {
            //         const expensePayload = {
            //             shop_id: shopItem?.shop_id || "0",
            //             title: `Custom Process Expense - ${item.description}`,
            //             date: getFormattedCurrentDate2(),
            //             amount: parseFloat(item.amount || 0).toString(),
            //             type: 2, // Bank type or standard expense
            //             in_or_out: 1, // 1: Expense outflow
            //             created_by: UserItem?.user_id || "0",
            //             remark: `Custom expense added during product processing for process #${activeProcessId}`
            //         };

            //         try {
            //             const expResponse = await createExpanse(expensePayload);
            //             if (!expResponse || (expResponse.data && expResponse.data.status !== "success")) {
            //                 toast.error(`Failed to create custom expense "${item.description}": ${expResponse?.data?.message || "Unknown error"}`);
            //                 hideLoader();
            //                 return; // Stop the user
            //             }
            //         } catch (expError) {
            //             console.error("Error creating custom expense:", expError);
            //             const errMsg = expError?.response?.data?.message || "Failed to create custom expense due to an error.";
            //             toast.error(`Failed to create custom expense "${item.description}": ${errMsg}`);
            //             hideLoader();
            //             return; // Stop the user
            //         }
            //     }
            // }

            // Note: Custom expenses are now logged individually in the Expense model atomically on the backend in update_processing.

            const response = await add_process_charges(manufacturingData);

            if (response.data && response.data.status === "success") {
                toast.success("Manufacturing details saved successfully");

                try {
                    // Calculate raw materials and packaging cost
                    const rawMaterialTotal = calculateRawMaterialTotal();
                    const packagingCost = selectedPackagingId && selectedPackagingQty
                        ? parseFloat(selectedPackagingQty) * parseFloat(selectedPackagingPrice || 0)
                        : 0;

                    const totalStockCost = (rawMaterialTotal + packagingCost).toFixed(2);

                    // Commented old costOfManufature logic:
                    // const costOfManufature = calculateRawMaterialTotal().toFixed(2);

                    const generalDataRM = {
                        type: "3",
                        ref_id: activeProcessId,
                        remarks: "Raw Material to Product Processing",
                        date: getFormattedCurrentDate2(),
                        created_by: UserItem?.user_id,
                        shop_id: shopItem?.id || "0",
                        // amount: costOfManufature,
                        amount: totalStockCost, // Updated from costOfManufature
                        is_debit: "0",
                    };
                    await postGeneralData(generalDataRM);

                    const generalDataPP = {
                        type: "3.1",
                        ref_id: activeProcessId,
                        remarks: "Product Processed",
                        date: getFormattedCurrentDate2(),
                        created_by: UserItem?.user_id,
                        shop_id: shopItem?.id || "0",
                        // amount: costOfManufature,
                        amount: totalStockCost, // Updated from costOfManufature
                        is_debit: "1",
                    };
                    await postGeneralData(generalDataPP);
                } catch (error) {
                    console.error("Error in manufacturing accounts:", error);
                }

                // setActiveProcess(prev => ({
                //     ...prev,
                //     manufactured_qty: chargesData.manufactured_qty,
                //     mfg_qty: chargesData.manufactured_qty
                // }));

                // prepareDistribution({
                //     ...activeProcess,
                //     id: activeProcessId,
                //     manufactured_qty: chargesData.manufactured_qty,
                //     mfg_qty: chargesData.manufactured_qty
                // });
                // setCurrentStep(3);

                setActiveProcess(null);
                setActiveProcessId(null);
                setCurrentStep(1);
                resetMainForm();
                setShowCreateModal(false);
                setShowPurchaseModal(false);

                fetchProcessList();
            } else {
                toast.error(response.data?.message || "Failed to save manufacturing details");
            }
        } catch (error) {
            console.error("Error in manufacturing step:", error);
            toast.error(error?.response?.data?.message || "Error saving manufacturing details");
        } finally {
            hideLoader();
            setIsSubmitting(false);
        }
    };


    const isDistributionComplete = () => {
        if (!activeProcess) return false;
        // --- OLD CODE (Preserved) ---
        // let processQty = parseFloat(activeProcess.avl_qty !== undefined ? activeProcess.avl_qty : activeProcess.manufactured_qty);
        // let processQtyInGrams = processQty * 1000;
        // return totalDistributedQty <= processQtyInGrams + 1;

        const summary = calculateNewDistributionSummary();
        return summary.totalDistributedKg > 0 && summary.remainingKg >= -0.01;
    };

    const checkExistingProcessedProduct = async (productId) => {
        try {
            // Call your existing axios API function
            const response = await listProductQty({}, productId);

            if (
                response.data &&
                response.data.status === "success" &&
                response.data.data &&
                response.data.data.length > 0
            ) {
                const batch = response.data.data[0];

                if (parseFloat(batch.remaining || 0) > 0) {
                    return batch; // return existing batch
                }
            }

            return null;
        } catch (err) {
            console.error("Error checking product qty:", err);
            return null;
        }
    };

    // Submit handlers for each step
    const handleDistributionSubmit = async (e) => {
        e.preventDefault();

        if (isSubmitting) return;

        // Double-check process ID
        if (!activeProcessId) {
            toast.error("Missing process ID. Please restart the process.");
            return;
        }

        const summary = calculateNewDistributionSummary();
        if (summary.totalDistributedKg <= 0) {
            toast.error("Please enter product quantity in at least one distribution item.");
            return;
        }

        if (summary.remainingKg < -0.01) {
            toast.error(`Total distributed quantity (${summary.totalDistributedKg.toFixed(2)} kg) exceeds available bulk stock (${summary.totalBulkKg.toFixed(2)} kg).`);
            return;
        }

        setIsSubmitting(true);

        const batchDistributionMap = {};
        const packagingMaterialsPayload = [];

        newDistributionRows.forEach(row => {
            const calcs = getNewRowCalculations(row);

            if (row.packaging_id) {
                // Packaged material selected -> add to packaging_materials payload
                const mat = rawMaterials.find(rm => String(rm.id) === String(row.packaging_id));
                const matUnitId = (unitMap[String(row.pack_unit)] || row.pack_unit || unitMap[String(mat?.unit_id)] || "pcs").toString().toLowerCase();
                const packQtyNum = parseFloat(row.pack_qty || 0);

                if (packQtyNum > 0) {
                    packagingMaterialsPayload.push({
                        raw_mat_id: row.packaging_id,
                        qty: packQtyNum.toString(),
                        price_unit: calcs.costPerPiece.toFixed(2),
                        total_price: calcs.packCoverTotalCost.toFixed(2),
                        unit: matUnitId
                    });
                }

                // Match PMD entry for this cover size from productDetails or distributionItems
                const procPId = activeProcess?.p_id || activeProcess?.product_id;
                const availableDetails = productDetails.filter(detail =>
                    String(detail.p_id) === String(procPId)
                );
                const searchList = distributionItems.length > 0 ? distributionItems : availableDetails;

                let matchedItem = null;
                if (mat && mat.title) {
                    const match = mat.title.match(/(\d+(?:\.\d+)?)\s*(grams?|g|kgs?|kilograms?)?/i);
                    if (match) {
                        const coverGrams = convertToGrams(match[1], match[2] || "grams");
                        matchedItem = searchList.find(item => {
                            if (item.id === "FREE_SIZE" || item.p_code === "FREE_SIZE" || item.pbox_code === "FREE SIZE / LOSE QTY") return false;
                            const itemGrams = convertToGrams(item.p_weight, item.pbox_unit);
                            return Math.abs(itemGrams - coverGrams) <= 1;
                        });
                    }
                }

                if (!matchedItem) {
                    matchedItem = searchList.find(item => item.id !== "FREE_SIZE" && item.p_code !== "FREE_SIZE" && item.pbox_code !== "FREE SIZE / LOSE QTY");
                }

                if (matchedItem && matchedItem.id) {
                    const targetPdId = matchedItem.id;
                    const qtyToAdd = calcs.usablePcs > 0 ? calcs.usablePcs : calcs.calculatedPcs;
                    batchDistributionMap[targetPdId] = (batchDistributionMap[targetPdId] || 0) + qtyToAdd;
                }
            } else {
                // No pack material selected -> Free Size / Lose Packs!
                const procPId = activeProcess?.p_id || activeProcess?.product_id;
                let freeSizeItem = distributionItems.find(item => item.id === "FREE_SIZE" || item.p_code === "FREE_SIZE" || item.pbox_code === "FREE SIZE / LOSE QTY") ||
                    productDetails.find(item => String(item.p_id) === String(procPId) && (item.id === "FREE_SIZE" || item.p_code === "FREE_SIZE" || item.pbox_code === "FREE SIZE / LOSE QTY"));
                const targetPdId = freeSizeItem ? freeSizeItem.id : "FREE_SIZE";
                batchDistributionMap[targetPdId] = (batchDistributionMap[targetPdId] || 0) + calcs.qtyInKg;
            }
        });

        const batchDistributionPayload = Object.entries(batchDistributionMap).map(([id, qty]) => ({
            id,
            qty: qty.toString()
        }));

        showLoader();
        try {
            const distributionPayload = {
                processing_id: activeProcessId,
                status: "4",
                created_by: UserItem?.user_id || "0",
                shop_id: shopItem?.shop_id || "0",
                branch_id: localStorage.getItem('branch_id') || "1",
                batch_distribution: batchDistributionPayload,
                packaging_materials: packagingMaterialsPayload,
                profit: chargesData.profit || 0
            };

            console.log("Submitting distribution data:", distributionPayload);

            const response = await finalize_processing(distributionPayload);

            if (response.data && response.data.status === "success") {
                toast.success("Process distribution completed successfully");

                // --- OLD LEDGER POSTING CODE FOR OLD TABLE (Preserved) ---
                /*
                const activePackagingMaterials = distributionItems.filter(item => item.packaging_id && parseFloat(item.packaging_qty || 0) > 0);
                for (const item of activePackagingMaterials) {
                    const packagingCost = parseFloat(item.packaging_qty) * parseFloat(item.packaging_price || 0);
                    if (packagingCost > 0) {
                        const generalDataPackaging = {
                            type: "3", // Raw Material/Packaging to Product Processing
                            ref_id: activeProcessId,
                            remarks: `Packaging Material to Product Processing - for item with weight ${item.p_weight} ${item.pbox_unit}`,
                            date: getFormattedCurrentDate2(),
                            created_by: UserItem?.user_id,
                            shop_id: shopItem?.id || "0",
                            amount: packagingCost.toFixed(2),
                            is_debit: "0",
                        };
                        const generalDataFinishedPackaging = {
                            type: "3.1", // Finished Product Stocks
                            ref_id: activeProcessId,
                            remarks: `Product Processed - Packaging Cost - for item with weight ${item.p_weight} ${item.pbox_unit}`,
                            date: getFormattedCurrentDate2(),
                            created_by: UserItem?.user_id,
                            shop_id: shopItem?.id || "0",
                            amount: packagingCost.toFixed(2),
                            is_debit: "1", // Debit
                        };
                        try {
                            await postGeneralData(generalDataPackaging);
                            await postGeneralData(generalDataFinishedPackaging);
                        } catch (glError) {
                            console.error("Error creating GL entry for packaging:", glError);
                        }
                    }
                }
                */

                // --- NEW LEDGER POSTING FOR PRODUCT PACKAGE DISTRIBUTION (newDistributionRows) ---
                for (const row of newDistributionRows) {
                    if (row.packaging_id) {
                        const calcs = getNewRowCalculations(row);
                        const packagingCost = calcs.packCoverTotalCost;
                        if (packagingCost > 0) {
                            const mat = rawMaterials.find(rm => String(rm.id) === String(row.packaging_id));
                            const matName = mat ? mat.title : "Packaging Material";
                            const generalDataPackaging = {
                                type: "3", // Raw Material/Packaging to Product Processing
                                ref_id: activeProcessId,
                                remarks: `Packaging Material to Product Processing - ${matName} (${row.product_qty || 0} ${row.product_unit || 'KG'})`,
                                date: getFormattedCurrentDate2(),
                                created_by: UserItem?.user_id,
                                shop_id: shopItem?.id || "0",
                                amount: packagingCost.toFixed(2),
                                is_debit: "0",
                            };
                            const generalDataFinishedPackaging = {
                                type: "3.1", // Finished Product Stocks
                                ref_id: activeProcessId,
                                remarks: `Product Processed - Packaging Cost - ${matName} (${row.product_qty || 0} ${row.product_unit || 'KG'})`,
                                date: getFormattedCurrentDate2(),
                                created_by: UserItem?.user_id,
                                shop_id: shopItem?.id || "0",
                                amount: packagingCost.toFixed(2),
                                is_debit: "1", // Debit
                            };
                            try {
                                await postGeneralData(generalDataPackaging);
                                await postGeneralData(generalDataFinishedPackaging);
                            } catch (glError) {
                                console.error("Error creating GL entry for packaging:", glError);
                            }
                        }
                    }
                }

                setActiveProcess(null);
                setActiveProcessId(null);
                setCurrentStep(1);
                setDistributionItems([]);
                setTotalDistributedQty(0);
                setDistributionError("");
                resetMainForm();
                setShowCreateModal(false);
                setShowPurchaseModal(false);

                fetchProcessList();

            } else {
                toast.error(response.data?.message || "Failed to complete distribution");
            }
        } catch (error) {
            console.error("Error submitting distribution:", error);
            toast.error(error?.response?.data?.message || "Error submitting distribution");
        } finally {
            hideLoader();
            setIsSubmitting(false);
        }
    };


    const handleProductDetailsSubmit = async (e) => {
        e.preventDefault();

        if (!validateProductDetails()) return;

        setLoading(true);
        try {
            const response = await create_product_details(formData1);

            if (response.data && response.data.status === "success") {
                toast.success("Product details added successfully");
                resetProductDetailsForm();
                setShowDetailsModal(false);
                // fetchProductDetails();

                if (currentStep === 3 && activeProcess) {
                    const freshDetails = await fetchProductDetails();
                    prepareDistribution(activeProcess, freshDetails);
                } else {
                    fetchProductDetails();
                    // prepareDistribution(activeProcess);
                }
            } else {
                toast.error(response.data?.message || "Failed to add product details");
            }
        } catch (error) {
            console.error("Error adding product details:", error);
            toast.error(error?.response?.data?.message || "Error adding product details");
        } finally {
            setLoading(false);
        }
    };

    const resetMainForm = () => {
        setFormData({
            p_id: "",
            desired_qty: "",
            expdate: "",
            mfgdate: new Date().toISOString().split("T")[0],
            unit: "kg",
            // warehouse_id: warehouse?.id || "0",
            shop_id: shopItem?.shop_id || "0",
            branch_id: localStorage.getItem('branch_id') || "1",
            user_id: UserItem?.user_id || "10",
            created_by: UserItem?.user_id,
            ingredients: []
        });
        setSelectedProduct(null);
        setIngredientsList([]);
        setErrors({});
        setSelectedPackagingId("");
        setSelectedPackagingQty("");
        setSelectedPackagingPrice("");
    };

    const resetProductDetailsForm = () => {
        setFormData1({
            p_id: "",
            p_code: "",
            p_weight: "",
            pbox_unit: "",
            p_price: "",
            pbox_qty: "",
            pbox_code: "",
            pbox_price: ""
        });
        setErrorss({});
    };


    const handleCancelProcess = async () => {
        if (isSubmitting) return;

        if (activeProcessId) {
            if (window.confirm("Are you sure you want to cancel this process? This will restore raw material quantities, delete finished stock, refund expenses, and delete the process record.")) {
                setIsSubmitting(true);
                showLoader();
                try {
                    const response = await cancel_processing({ processing_id: activeProcessId });
                    if (response.data && response.data.status === "success") {
                        setActiveProcess(null);
                        setActiveProcessId(null);
                        setCurrentStep(1);
                        resetMainForm();
                        setShowCreateModal(false);
                        setShowPurchaseModal(false);
                        fetchProcessList();
                        toast.success("Process successfully cancelled and all changes reversed.");
                    } else {
                        toast.error(response.data?.message || "Failed to cancel process");
                    }
                } catch (error) {
                    console.error("Error cancelling process:", error);
                    toast.error("Failed to cancel process. Please try again.");
                } finally {
                    hideLoader();
                    setIsSubmitting(false);
                }
            }
        } else {
            if (window.confirm("Are you sure you want to cancel? This will clear the current form data.")) {
                setActiveProcess(null);
                setActiveProcessId(null);
                setCurrentStep(1);
                resetMainForm();
                setShowCreateModal(false);
                setShowPurchaseModal(false);
                fetchProcessList();
                toast.info("Cleared form data.");
            }
        }
    };

    const handleDeleteProcess = async (process) => {
        if (window.confirm("Are you sure, you want to delete this process, if its deleted then you cannot undo this action !")) {
            showLoader();
            try {
                const response = await delete_processing(process.id);
                if (response.data && response.data.status === "success") {
                    toast.success(response.data.message || "Process deleted successfully");
                    fetchProcessList(currentPage);
                } else {
                    toast.error(response.data?.message || "Failed to delete process");
                }
            } catch (error) {
                console.error("Error deleting process:", error);
                toast.error(error?.response?.data?.message || "Error deleting process. Please try again.");
            } finally {
                hideLoader();
            }
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        fetchProcessList(pageNumber, "", entriesPerPage);
    };

    const handleViewProcessDetails = async (process) => {
        showLoader();
        try {
            const response = await get_completed_process_details(process.id);
            if (response.data && response.data.status === "success") {
                setSelectedCompletedProcess(response.data.data);
                setShowCompletedDetailsModal(true);
            } else {
                toast.error(response.data?.message || "Failed to fetch process details");
            }
        } catch (error) {
            console.error("Error fetching completed process details:", error);
            toast.error("Failed to fetch completed process details");
        } finally {
            hideLoader();
        }
    };

    const handleViewBatchReport = async (batchNo) => {
        if (!batchNo) return;
        showLoader();
        try {
            const response = await getBatchWiseSalesReport({ batch_no: batchNo });
            if (response.data && response.data.status === "success") {
                setBatchReportData(response.data);
                setShowBatchReportModal(true);
            } else {
                toast.error(response.data?.message || "Failed to fetch batch sales report");
            }
        } catch (error) {
            console.error("Error fetching batch sales report:", error);
            toast.error("Failed to fetch batch sales report");
        } finally {
            hideLoader();
        }
    };

    const handleResumeProcess = async (process, forceStep = null) => {
        const stepToStart = forceStep !== null ? forceStep : (
            process.is_order_based ? 1 : (
                parseInt(process.status) === 0 ? 2 :
                    parseInt(process.status) === 3 ? 3 : 1
            )
        );

        setActiveProcessId(process.is_order_based ? null : process.id);
        setActiveProcess({
            ...process,
            product_id: process.p_id
        });

        if (stepToStart === 1) {
            if (process.is_order_based) {
                setFormData({
                    p_id: process.p_id || "",
                    desired_qty: process.desired_qty || "",
                    unit: process.unit || "kg",
                    mfgdate: new Date().toISOString().split("T")[0],
                    expdate: "",
                    shop_id: shopItem?.shop_id || "0",
                    branch_id: UserItem?.user_id || "1",
                    user_id: UserItem?.user_id || "10",
                    created_by: UserItem?.user_id,
                    ingredients: []
                });
                fetchIngredientsFromProductMaster(process.p_id);
                setCurrentStep(1);
                return;
            }
            showLoader();
            try {
                const response = await get_completed_process_details(process.id);
                if (response.data && response.data.status === "success") {
                    const p = response.data.data;

                    setFormData({
                        p_id: process.p_id || p.p_id || "",
                        desired_qty: p.desired_qty || "",
                        unit: p.unit || "",
                        mfgdate: p.mfg_date || p.mfgdate || (p.create_date ? p.create_date.split('T')[0] : new Date().toISOString().split("T")[0]),
                        expdate: p.exp_date || p.expiry_date || "",
                        shop_id: p.shop_id || shopItem?.shop_id || "0",
                        branch_id: p.branch_id || localStorage.getItem('branch_id') || "1",
                        user_id: p.user_id || UserItem?.user_id || "10",
                        created_by: p.created_by || UserItem?.user_id,
                        ingredients: []
                    });

                    if (process.p_id || p.p_id) {
                        fetchIngredientsFromProductMaster(process.p_id || p.p_id);
                    }

                    setChargesData({
                        processing_id: process.id,
                        manufactured_qty: p.manufactured_qty || p.desired_qty || "",
                        other_charges: p.other_charges || "0",
                        eb_rent_charges: p.eb_rent_charges || "0",
                        labour_charges: p.labour_charges || "0",
                        package_charges: p.package_charges || "0",
                        status: "3",
                        shop_id: p.shop_id || shopItem?.shop_id || "0",
                        branch_id: p.branch_id || localStorage.getItem('branch_id') || "1",
                        user_id: p.user_id || UserItem?.user_id || "10",
                        created_by: p.created_by || UserItem?.user_id,
                        expiry_date: p.exp_date || p.expiry_date || "",
                        profit: p.profit || ""
                    });

                    setExpenseItems([
                        { id: 1, description: 'Labour Charges', amount: parseFloat(p.labour_charges || 0) },
                        { id: 2, description: 'Package Charges', amount: parseFloat(p.package_charges || 0) },
                        { id: 3, description: 'EB/Rent Charges', amount: parseFloat(p.eb_rent_charges || 0) },
                        { id: 4, description: 'Other Charges', amount: parseFloat(p.other_charges || 0) }
                    ]);

                    if (p.custom_expenses) {
                        setCustomExpenses(p.custom_expenses.map((item, idx) => ({
                            id: idx + 1,
                            description: item.title,
                            amount: item.amount
                        })));
                    } else {
                        setCustomExpenses([]);
                    }

                    if (p.ingredients && rawMaterials.length > 0) {
                        const pkgMat = p.ingredients.find(ing => {
                            const rm = rawMaterials.find(r => r.title === ing.raw_material_name);
                            return rm && String(rm.type) === "1";
                        });
                        if (pkgMat) {
                            const rm = rawMaterials.find(r => r.title === pkgMat.raw_material_name);
                            if (rm) {
                                setSelectedPackagingId(rm.id);
                                setSelectedPackagingQty(pkgMat.qty);
                                setSelectedPackagingPrice(pkgMat.price_unit || rm.latest_price_unit || "0");
                            }
                        } else {
                            setSelectedPackagingId("");
                            setSelectedPackagingQty("");
                            setSelectedPackagingPrice("");
                        }
                    }
                } else {
                    toast.error(response.data?.message || "Failed to fetch process details for editing");
                }
            } catch (err) {
                console.error("Error loading completed process details for editing:", err);
                toast.error("Failed to load completed process details for editing");
            } finally {
                hideLoader();
            }
        } else if (stepToStart === 2) {
            await fetchRawMaterialsForProcess(process.id);

            setChargesData({
                processing_id: process.id,
                manufactured_qty: process.desired_qty,
                other_charges: "0",
                eb_rent_charges: "0",
                labour_charges: "0",
                package_charges: "0",
                status: "3",
                // warehouse_id: warehouse?.id || "0",
                shop_id: shopItem?.shop_id || "0",
                branch_id: localStorage.getItem('branch_id') || "1",
                user_id: UserItem?.user_id || "10",
                created_by: UserItem?.user_id,
                expiry_date: process.exp_date || ""
            });
            setOriginalDesiredQty(parseFloat(process.desired_qty || 0));
        } else if (stepToStart === 3) {
            if (process?.id) {
                await fetchRawMaterialsForProcess(process.id);
            }
            setChargesData(prev => ({
                ...prev,
                processing_id: process.id,
                manufactured_qty: process.manufactured_qty || process.desired_qty || prev.manufactured_qty || ""
            }));
            prepareDistribution(process);
        }

        setCurrentStep(stepToStart);
    };

    const getStatusLabel = (status) => {
        switch (parseInt(status)) {
            case 0: return "Pending";
            case 1: return "In Progress";
            case 2: return "Manufacturing";
            case 3: return "Completed";
            case 4: return "Distributed";
            default: return "Unknown";
        }
    };

    const getStatusClass = (status) => {
        switch (parseInt(status)) {
            case 0: return "text-warning";
            case 1: return "text-info";
            case 2: return "text-primary";
            case 3: return "text-success";
            case 4: return "text-primary fw-bold";
            default: return "";
        }
    };

    const renderStep1 = () => {
        return (
            <div className="card">
                <div className="card-header bg-light">
                    <h5>{activeProcessId ? "Update Process" : "Create New Process"}</h5>
                </div>
                <div className="card-body">
                    <ProcessStepBar currentStep={currentStep} />

                    <form onSubmit={handleCreateProcess} className="row g-3">
                        {/* Product Selection */}
                        <div className="col-md-12">
                            <label className="form-label">Select Product <span className="text-danger">*</span></label>
                            <select
                                name="p_id"
                                value={formData.p_id}
                                onChange={handleFormChange}
                                className={`form-control ${errors.p_id ? 'is-invalid' : ''}`}
                                disabled={activeProcess?.is_order_based}
                            >
                                <option value="">Select Product</option>
                                {products.map(product => (
                                    <option key={product.product_id} value={Number(product.product_id)}>
                                        {product.title} ({displayLimit(product.weight_limit)})
                                    </option>
                                ))}
                            </select>
                            {errors.p_id && <div className="invalid-feedback">{errors.p_id}</div>}
                        </div>

                        {/* Desired Quantity */}
                        <div className="col-md-4">
                            <label className="form-label">Desired Quantity <span className="text-danger">*</span></label>
                            <input
                                // type="number"
                                type="text"
                                name="desired_qty"
                                value={formData.desired_qty}
                                onChange={handleFormChange}
                                onInput={(e) => {
                                    e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                    const parts = e.target.value.split('.');
                                    if (parts.length > 2) {
                                        e.target.value = parts[0] + '.' + parts.slice(1).join('');
                                    }
                                    if (parts[1] && parts[1].length > 3) {
                                        e.target.value = parts[0] + '.' + parts[1].substring(0, 3);
                                    }
                                }}
                                inputMode='decimal'
                                pattern="[0-9]*\.?[0-9]*"
                                placeholder="0.00"
                                className={`form-control ${errors.desired_qty ? 'is-invalid' : ''}`}
                                disabled={activeProcess?.is_order_based}
                            // min="0"
                            // step="1"
                            />
                            {errors.desired_qty && <div className="invalid-feedback">{errors.desired_qty}</div>}
                        </div>

                        {/* Unit */}
                        <div className="col-md-4">
                            <label className="form-label">Unit <span className="text-danger">*</span></label>
                            <select
                                name="unit"
                                value={formData.unit}
                                onChange={handleFormChange}
                                className={`form-control ${errors.unit ? 'is-invalid' : ''}`}
                            >
                                <option value="">Select Unit</option>
                                <option value="kg">Kilograms</option>
                                {/* <option value="Gram">Grams</option>
                                <option value="liters">Liters</option>
                                <option value="ml">Milliliters</option>
                                <option value="pcs">Pieces</option> */}
                            </select>
                            {errors.unit && <div className="invalid-feedback">{errors.unit}</div>}
                        </div>

                        {/* Manufacturing Date */}
                        <div className="col-md-4">
                            <label className="form-label">Manufacturing Date</label>
                            <input
                                type="date"
                                name="mfgdate"
                                value={formData.mfgdate}
                                onChange={handleFormChange}
                                className="form-control"
                            />
                        </div>

                        {/* Expiry Date */}
                        {/* <div className="col-md-4">
                            <label className="form-label">Expiry Date <span className="text-danger">*</span></label>
                            <input
                                type="date"
                                name="expdate"
                                value={formData.expdate}
                                onChange={handleFormChange}
                                className={`form-control ${errors.expdate ? 'is-invalid' : ''}`}
                                min={new Date().toISOString().split("T")[0]}
                            />
                            {errors.expdate && <div className="invalid-feedback">{errors.expdate}</div>}
                        </div> */}

                        {/* Ingredients Section */}
                        {selectedProduct && ingredientsList.length > 0 && (
                            <div className="col-12 mt-4">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="d-flex justify-content-between align-items-center">
                                            <h6 className="mb-0">
                                                <i className="bi bi-list-ul me-2"></i>
                                                Required Ingredients for {selectedProduct.title} - {formData.desired_qty && parseFloat(formData.desired_qty) > 0 ? `Showing data for ${formData.desired_qty} ${formData.unit || 'kg'}` : "Showing data for 1KG"}
                                            </h6>
                                            <div className="d-flex align-items-center gap-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger btn-sm"
                                                    onClick={() => {
                                                        const updated = ingredientsList.map(ing => ({
                                                            ...ing,
                                                            custom_qty: 0
                                                        }));
                                                        setIngredientsList(updated);
                                                    }}
                                                >
                                                    Clear All
                                                </button>
                                                <span className="badge bg-primary">
                                                    {ingredientsList.length} ingredient(s)
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        {formData.desired_qty && (
                                            <div className="alert alert-info mb-3">
                                                <i className="bi bi-info-circle me-2"></i>
                                                <strong>Production Target:</strong> {formData.desired_qty} {formData.unit}
                                            </div>
                                        )}

                                        <div className="table-responsive">
                                            <table className="table table-bordered table-striped">
                                                <thead className="table-dark">
                                                    <tr>
                                                        <th style={{ width: '5%' }}>S.No</th>
                                                        <th style={{ width: '35%' }}>Ingredient Name</th>
                                                        <th style={{ width: '30%' }}>Quantity</th>
                                                        <th style={{ width: '30%' }}>Unit</th>
                                                        {/* <th style={{ width: '25%' }}>Desired QTY</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {ingredientsList.map((ing, index) => (
                                                        <tr key={index}>
                                                            <td className="text-center">
                                                                <span className="badge bg-light text-dark">
                                                                    {index + 1}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <i className="bi bi-box me-2 text-primary"></i>
                                                                    <strong>{`${ing.title} (avbl: ${(Number(ing.remaining_stock) || 0).toFixed(2)})`}</strong>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    value={ing.custom_qty || ''}
                                                                    onChange={(e) => handleIngredientQtyChange(index, e.target.value)}
                                                                    onInput={(e) => {
                                                                        e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                                                                        const parts = e.target.value.split('.');
                                                                        if (parts.length > 2) {
                                                                            e.target.value = parts[0] + '.' + parts.slice(1).join('');
                                                                        }
                                                                        if (parts[1] && parts[1].length > 3) {
                                                                            e.target.value = parts[0] + '.' + parts[1].substring(0, 3);
                                                                        }
                                                                    }}
                                                                    inputMode='decimal'
                                                                    pattern="[0-9]*\.?[0-9]*"
                                                                    placeholder="0.00"
                                                                    className="form-control form-control-sm"
                                                                    onWheel={(e) => e.target.blur()}
                                                                    min="0"
                                                                // disabled
                                                                />
                                                            </td>
                                                            <td>
                                                                <select
                                                                    value={ing.custom_unit || (isLitreType(ing.id) ? "Ml" : "grams")}
                                                                    onChange={(e) => handleIngredientUnitChange(index, e.target.value)}
                                                                    className="form-control form-control-sm text-center"
                                                                    style={{ textAlign: "center" }}
                                                                    disabled
                                                                >
                                                                    <option value="" style={{ textAlign: "center" }}>Select Unit</option>
                                                                    {isLitreType(ing.id) ? (
                                                                        <>
                                                                            <option value="Ml" style={{ textAlign: "center" }}>Ml</option>
                                                                            <option value="Li" style={{ textAlign: "center" }}>Li (Litre)</option>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <option value="grams" style={{ textAlign: "center" }}>Grams</option>
                                                                            <option value="kg" style={{ textAlign: "center" }}>Kg (Kilograms)</option>
                                                                        </>
                                                                    )}
                                                                </select>
                                                            </td>
                                                            {/* <td>
                                                            {formData.desired_qty}
                                                            </td> */}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                        }

                        {/* No Ingredients Message */}
                        {
                            selectedProduct && ingredientsList.length === 0 && (
                                <div className="col-12 mt-4">
                                    <div className="alert alert-warning">
                                        <i className="bi bi-exclamation-triangle me-2"></i>
                                        <strong>No Ingredients Found:</strong> This product doesn't have any ingredients configured.
                                        The process will be created without ingredient requirements.
                                    </div>
                                </div>
                            )
                        }

                        <div className="col-12 d-flex justify-content-between mt-4">
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => {
                                    resetMainForm();
                                    fetchProcessList();
                                }}
                            >
                                <i className="bi bi-x-circle me-1"></i>Cancel
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={!formData.p_id || !formData.desired_qty || !formData.unit || isSubmitting}
                            >
                                {isSubmitting ? "Processing..." : <>Next: Manufacturing <i className="bi bi-arrow-right ms-1"></i></>}
                            </button>
                        </div>
                    </form >
                </div >
            </div >
        );
    };

    const scaleRawMaterialsListForNewQty = (newQty) => {
        if (!originalDesiredQty || originalDesiredQty <= 0) return;
        const ratio = newQty / originalDesiredQty;

        setRawMaterialsList(originalRawMaterials.map(mat => {
            const origQty = parseFloat(mat.qty || 0);
            const origPrice = parseFloat(mat.price || 0);
            return {
                ...mat,
                qty: (origQty * ratio).toFixed(3),
                price: (origPrice * ratio).toFixed(2)
            };
        }));
    };

    const handleStep2DesiredQtyChange = (e) => {
        const val = e.target.value;
        const newDesiredQty = parseFloat(val) || 0;

        setActiveProcess(prev => ({
            ...prev,
            desired_qty: val
        }));

        setChargesData(prev => ({
            ...prev,
            manufactured_qty: val
        }));

        if (newDesiredQty >= 0) {
            scaleRawMaterialsListForNewQty(newDesiredQty);
        }
    };

    const renderStep2 = () => {
        if (!activeProcess) return null;

        return (
            <div className="card">
                <div className="card-header bg-light">
                    <h5>Manufacturing Details</h5>
                </div>
                <div className="card-body">
                    <ProcessStepBar currentStep={currentStep} />

                    {/* Product Info */}
                    <div className="alert alert-info">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <strong>Product:</strong> {activeProcess.product_title}
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <strong>Desired Qty:</strong>
                                {activeProcess.is_order_based ? (
                                    <input
                                        type="number"
                                        className="form-control form-control-sm d-inline-block text-center fw-bold"
                                        style={{ width: "90px", padding: "2px 5px", fontSize: "14px", display: "inline-block" }}
                                        value={activeProcess.desired_qty || ""}
                                        onChange={handleStep2DesiredQtyChange}
                                        onWheel={(e) => e.currentTarget.blur()}
                                        min="0"
                                        step="any"
                                    />
                                ) : (
                                    <span> {activeProcess.desired_qty || 0}</span>
                                )}{" "}
                                <span>{activeProcess.unit || 'units'}</span>
                            </div>
                            {activeProcess.batch_no && (
                                <div>
                                    <strong>Batch #:</strong> {activeProcess.batch_no}
                                </div>
                            )}
                        </div>
                    </div>

                    <form onSubmit={handleManufacturingSubmit}>
                        {/* Commented out Packaging Material Section (shifted to Step 3)
                        <div className="card mb-4" style={{ ...getPackagingCardStyle(), transition: "background-color 0.3s ease" }}>
                            <div className="card-header bg-light" style={{ backgroundColor: "transparent" }}>
                                <h6 className="mb-0 text-start">Packaging Material</h6>
                            </div>
                            <div className="card-body">
                                <div className="row g-3 text-start">
                                    <div className="col-md-4">
                                        <label className="form-label">Select Packaging Material</label>
                                        <select
                                            className="form-select"
                                            value={selectedPackagingId}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                setSelectedPackagingId(val);
                                                const rawMat = rawMaterials.find(rm => String(rm.id) === String(val));
                                                if (rawMat) {
                                                    setSelectedPackagingPrice(rawMat.latest_price_unit || "0");
                                                } else {
                                                    setSelectedPackagingPrice("0");
                                                }
                                            }}
                                        >
                                            <option value="">-- Choose Packaging Material --</option>
                                            {rawMaterials.filter(rm => rm.type == "1").map(rm => (
                                                <option key={rm.id} value={rm.id} disabled={parseFloat(rm.remaining_stock || 0) <= 0}>
                                                    {rm.title} (Stock: {parseFloat(rm.remaining_stock || 0).toFixed(2)} {unitMap[String(rm.unit_id)] || rm.unit_id || 'kg'})
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="col-md-2">
                                        <label className="form-label">Quantity</label>
                                        <div className="input-group">
                                            <input
                                                type="number"
                                                className="form-control"
                                                value={selectedPackagingQty}
                                                onChange={(e) => setSelectedPackagingQty(e.target.value)}
                                                placeholder="0.0"
                                                min="0"
                                                step="any"
                                            />
                                            <span className="input-group-text bg-light text-muted">
                                                {selectedPackagingId ? (unitMap[String(rawMaterials.find(rm => String(rm.id) === String(selectedPackagingId))?.unit_id)] || rawMaterials.find(rm => String(rm.id) === String(selectedPackagingId))?.unit_id || "kg") : "kg"}
                                            </span>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <label className="form-label">Unit Price (₹)</label>
                                        <div className="input-group">
                                            <span className="input-group-text">₹</span>
                                            <input
                                                type="number"
                                                className="form-control bg-light"
                                                value={selectedPackagingPrice}
                                                placeholder="0.00"
                                                readOnly
                                                disabled
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <label className="form-label">Total Price (₹)</label>
                                        <div className="input-group">
                                            <span className="input-group-text">₹</span>
                                            <input
                                                type="text"
                                                className="form-control bg-light"
                                                value={
                                                    selectedPackagingQty && selectedPackagingPrice
                                                        ? (parseFloat(selectedPackagingQty) * parseFloat(selectedPackagingPrice)).toFixed(2)
                                                        : "0.00"
                                                }
                                                readOnly
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        */}

                        {/* Raw Materials Used Section */}
                        <div className="card mb-4">
                            <div className="card-header bg-light">
                                <h6 className="mb-0">Raw Materials Used</h6>
                            </div>
                            <div className="card-body">

                                <div className="table-responsive">
                                    <table className="table table-bordered table-sm">
                                        <thead>
                                            <tr>
                                                <th width="50">No.</th>
                                                <th>Material Name</th>
                                                <th width="120">Quantity</th>
                                                <th width="100">Unit</th>
                                                <th width="120">Total</th>
                                                {/* <th width="150">Total</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {/* Original un-grouped mapping commented out:
                                            rawMaterialsList && rawMaterialsList.length > 0 ? (
                                                rawMaterialsList.map((material, index) => (
                                                    <tr key={material.id || index}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <div><strong>{material.raw_material_name}</strong></div>
                                                        </td>
                                                        <td className="text-end">
                                                            {(() => {
                                                                const rmDetail = rawMaterials.find(rm => String(rm.id) === String(material.raw_mat_id));
                                                                const matUnit = (rmDetail && String(rmDetail.type) === "2") ? "li" : (unitMap[String(material.unit_id)] || (rmDetail ? (unitMap[String(rmDetail.unit_id)] || rmDetail.unit_id) : material.unit_id) || "");
                                                                const lowerUnit = String(matUnit).toLowerCase();
                                                                const qtyVal = parseFloat(material.qty || 0);
                                                                if (lowerUnit === "grams" || lowerUnit === "g" || lowerUnit === "gram" || lowerUnit === "ml" || lowerUnit === "milliliters") {
                                                                    return Math.round(qtyVal);
                                                                }
                                                                return qtyVal.toFixed(2);
                                                            })()}
                                                        </td>
                                                        <td>
                                                            {(() => {
                                                                const rmDetail = rawMaterials.find(rm => String(rm.id) === String(material.raw_mat_id));
                                                                if (rmDetail && String(rmDetail.type) === "2") {
                                                                    return "li";
                                                                }
                                                                return unitMap[String(material.unit_id)] || (rmDetail ? (unitMap[String(rmDetail.unit_id)] || rmDetail.unit_id) : material.unit_id) || "-";
                                                            })()}
                                                        </td>
                                                        <td className="text-end">₹{parseFloat(material.price || 0).toFixed(2)}</td>
                                                    </tr>
                                                ))
                                            ) : null */}

                                            {groupedDisplayMaterials && groupedDisplayMaterials.length > 0 ? (
                                                groupedDisplayMaterials.map((material, index) => (
                                                    <tr key={material.raw_mat_id || material.id || index}>
                                                        <td>{index + 1}</td>
                                                        <td>
                                                            <div><strong>{material.raw_material_name}</strong></div>
                                                        </td>
                                                        <td className="text-end">
                                                            {(() => {
                                                                const rmDetail = rawMaterials.find(rm => String(rm.id) === String(material.raw_mat_id));
                                                                const matUnit = (rmDetail && String(rmDetail.type) === "2") ? "li" : (unitMap[String(material.unit_id)] || (rmDetail ? (unitMap[String(rmDetail.unit_id)] || rmDetail.unit_id) : material.unit_id) || "");
                                                                const lowerUnit = String(matUnit).toLowerCase();
                                                                const qtyVal = parseFloat(material.qty || 0);
                                                                if (lowerUnit === "grams" || lowerUnit === "g" || lowerUnit === "gram" || lowerUnit === "ml" || lowerUnit === "milliliters") {
                                                                    return Math.round(qtyVal);
                                                                }
                                                                return qtyVal.toFixed(2);
                                                            })()}
                                                        </td>
                                                        <td>
                                                            {(() => {
                                                                const rmDetail = rawMaterials.find(rm => String(rm.id) === String(material.raw_mat_id));
                                                                if (rmDetail && String(rmDetail.type) === "2") {
                                                                    return "li";
                                                                }
                                                                return unitMap[String(material.unit_id)] || (rmDetail ? (unitMap[String(rmDetail.unit_id)] || rmDetail.unit_id) : material.unit_id) || "-";
                                                            })()}
                                                        </td>
                                                        <td className="text-end">₹{parseFloat(material.price || 0).toFixed(2)}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">
                                                        No raw materials data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                        <tfoot>
                                            <tr className="table-light">
                                                <td colSpan="4" className="text-end"><strong>Total Raw Material Cost:</strong></td>
                                                <td className="text-end">
                                                    <strong>₹{calculateRawMaterialTotal().toFixed(2)}</strong>
                                                </td>
                                            </tr>
                                            {/* 
                                            <tr className="table-secondary">
                                                <td colSpan="4" className="text-end"><strong>Overall Cost (Raw + Packaging):</strong></td>
                                                <td className="text-end">
                                                    <strong>
                                                        ₹{(
                                                            calculateRawMaterialTotal() +
                                                            (selectedPackagingQty && selectedPackagingPrice
                                                                ? parseFloat(selectedPackagingQty) * parseFloat(selectedPackagingPrice)
                                                                : 0)
                                                        ).toFixed(2)}
                                                    </strong>
                                                </td>
                                            </tr>
                                            */}
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>


                        {/* Manufacturing Details */}
                        <div className="row mb-3">
                            {/* Manufacturing Quantity */}
                            <div className="col-md-6">
                                <label className="form-label">Outcome Quantity <span className="text-danger">*</span></label>
                                <div className="input-group">
                                    <input
                                        type="number"
                                        name="manufactured_qty"
                                        value={chargesData.manufactured_qty}
                                        onChange={handleChargesChange}
                                        onWheel={(e) => e.currentTarget.blur()}
                                        className={`form-control ${errors.manufactured_qty ? 'is-invalid' : ''}`}
                                        min="0"
                                        step="any"
                                        required
                                    />
                                    <span className="input-group-text">{activeProcess.unit || 'units'}</span>
                                </div>
                                {errors.manufactured_qty && <div className="invalid-feedback">{errors.manufactured_qty}</div>}
                                <small className="text-muted">The actual quantity produced</small>
                            </div>

                            {/* Expiry Date */}
                            <div className="col-md-6">
                                <label className="form-label">Expiry Date {/* <span className="text-danger">*</span> */}</label>
                                <input
                                    type="date"
                                    name="expiry_date"
                                    value={chargesData.expiry_date}
                                    onChange={handleChargesChange}
                                    className={`form-control ${errors.expiry_date ? 'is-invalid' : ''}`}
                                    min={new Date().toISOString().split('T')[0]}
                                /* required */
                                />
                                {errors.expiry_date && <div className="invalid-feedback">{errors.expiry_date}</div>}
                                <small className="text-muted">When this product will expire</small>
                            </div>
                        </div>





                        {/* Manufacturing Expenses Section */}
                        <div className="card mb-4">
                            <div className="card-header bg-light d-flex justify-content-between align-items-center">
                                <h6 className="mb-0">Manufacturing Expenses</h6>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => {
                                        const newId = customExpenses.length > 0
                                            ? Math.max(...customExpenses.map(item => item.id)) + 1
                                            : 1;

                                        setCustomExpenses([
                                            ...customExpenses,
                                            { id: newId, description: '', amount: 0 }
                                        ]);
                                    }}
                                >
                                    <i className="bi bi-plus-circle me-1"></i> Add Custom Charge
                                </button>
                            </div>

                            <div className="card-body">
                                <div className="row g-3">
                                    {/* Standard expense items */}
                                    {expenseItems.map((item) => {
                                        if (item.description === 'Package Charges') {
                                            return null;
                                        }
                                        return (
                                            <div className="col-md-6" key={item.id}>
                                                <label className="form-label">{item.description}</label>
                                                <div className="input-group">
                                                    <span className="input-group-text">₹</span>
                                                    <input
                                                        type="number"
                                                        value={item.amount}
                                                        onChange={(e) => handleExpenseChange(item.id, e.target.value)}
                                                        onWheel={(e) => e.currentTarget.blur()}
                                                        className="form-control"
                                                        placeholder="0.00"
                                                        min="0"
                                                        step="1"
                                                    />
                                                </div>
                                            </div>
                                        );
                                    })}

                                    {/* Custom expense items with delete option */}
                                    {customExpenses.map((item) => (
                                        <div className="col-md-6" key={`custom-${item.id}`}>
                                            <div className="mb-2">
                                                <input
                                                    type="text"
                                                    value={item.description}
                                                    onChange={(e) => {
                                                        const updatedItems = customExpenses.map(i =>
                                                            i.id === item.id ? { ...i, description: e.target.value } : i
                                                        );
                                                        setCustomExpenses(updatedItems);
                                                    }}
                                                    className="form-control mb-2"
                                                    placeholder="Enter expense title"
                                                />
                                            </div>
                                            <div className="input-group">
                                                <span className="input-group-text">₹</span>
                                                <input
                                                    type="number"
                                                    value={item.amount}
                                                    onChange={(e) => {
                                                        const updatedItems = customExpenses.map(i =>
                                                            i.id === item.id ? { ...i, amount: e.target.value } : i
                                                        );
                                                        setCustomExpenses(updatedItems);
                                                    }}
                                                    onWheel={(e) => e.currentTarget.blur()}
                                                    className="form-control"
                                                    placeholder="0.00"
                                                    min="0"
                                                    step="1"
                                                />
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={() => {
                                                        const updatedItems = customExpenses.filter(i => i.id !== item.id);
                                                        setCustomExpenses(updatedItems);
                                                    }}
                                                >
                                                    <i className="bi bi-trash"></i>
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>


                        {/* Cost Summary */}
                        <div className="card mb-4 bg-light ">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Manufacturing Cost Summary</h6>

                                {/* <div className="d-flex justify-content-between mb-2">
                                    <span>Raw Materials Cost:</span>
                                    <strong>₹{calculateRawMaterialTotal().toFixed(2)}</strong>
                                </div>

                                {expenseItems.map(item => (
                                    <div className="d-flex justify-content-between mb-2" key={item.id}>
                                        <span>{item.description}:</span>
                                        <strong>₹{parseFloat(item.amount || 0).toFixed(2)}</strong>
                                    </div>
                                ))} */}

                                <hr />
                                <div className="d-flex justify-content-between mb-2">
                                    <h6 className="mb-0">Total Manufacturing Cost:</h6>
                                    <h6 className="mb-0 text-primary">₹{calculateTotalCost().toFixed(2)}</h6>
                                </div>

                                <div className="d-flex justify-content-between mt-2">
                                    <span className="fw-semibold">
                                        Per {activeProcess?.unit ? (activeProcess.unit.toLowerCase() === 'kg' ? 'Kg' : activeProcess.unit) : 'Kg'} Price:
                                    </span>
                                    <strong className="text-dark">
                                        ₹{formatWithoutRounding(calculatePerUnitCost())}
                                    </strong>
                                </div>

                                {/* Suggested Selling Price (Hidden per request, code preserved) */}
                                {/* 
                                <div className="d-flex justify-content-between align-items-center mt-2">
                                    <div className="d-flex align-items-center">
                                        <span className="me-2">
                                            Suggested Selling Price (
                                            <input
                                                type="number"
                                                name="profit"
                                                value={chargesData.profit}
                                                onChange={(e) =>
                                                    setChargesData((prev) => ({
                                                        ...prev,
                                                        profit: e.target.value,
                                                    }))
                                                }
                                                onWheel={(e) => e.currentTarget.blur()}
                                                className="form-control d-inline-block"
                                                style={{ width: "70px", display: "inline-block" }}
                                                min={0}
                                                max={50}
                                            />
                                            <span className="ms-1">%</span>
                                            ):
                                        </span>
                                    </div>

                                    <strong className="text-success">
                                        {chargesData.profit
                                            ? `${chargesData.profit}% → ₹${(
                                                (calculateTotalCost() * chargesData.profit) /
                                                100
                                            ).toFixed(2)}`
                                            : "—"}
                                    </strong>
                                </div>
                                */}
                            </div>
                        </div>

                        {/* Navigation Buttons */}
                        <div className="d-flex justify-content-between">
                            <div>
                                {/* <button
                                    type="button"
                                    className="btn btn-outline-secondary me-2"
                                    onClick={() => setCurrentStep(1)}
                                >
                                    <i className="bi bi-arrow-left me-1"></i> Back
                                </button> */}
                                <button
                                    type="button"
                                    className="btn btn-outline-danger"
                                    onClick={handleCancelProcess}
                                    disabled={isSubmitting}
                                >
                                    <i className="bi bi-x-circle me-1"></i> Cancel Process
                                </button>
                            </div>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={!chargesData.manufactured_qty || isSubmitting}
                            >
                                {isSubmitting ? "Processing..." : <>Next: Distribution <i className="bi bi-arrow-right ms-1"></i></>}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    };

    const renderStep3 = () => {
        if (!activeProcess) return null;

        return (
            <div className="card">
                <div className="card-header bg-light">
                    <h5>Product Distribution</h5>
                </div>
                <div className="card-body">
                    <ProcessStepBar currentStep={currentStep} />

                    {/* Product Info */}
                    <div className="alert alert-info">
                        <div className="d-flex justify-content-between">
                            <span><strong>Product:</strong> {activeProcess.product_title}</span>
                            {activeProcess.batch_no && (
                                <span><strong>Batch:</strong> {activeProcess.batch_no}</span>
                            )}
                            {/* <span><strong>Total Quantity:</strong>
                                {(() => {
                                    const qty = parseFloat(activeProcess.manufactured_qty || activeProcess.desired_qty);
                                    const qtyInGrams = qty < 100 ? qty * 1000 : qty;
                                    return `${qtyInGrams.toFixed(0)} grams (${(qtyInGrams / 1000).toFixed(2)} kg)`;
                                })()}
                            </span> */}
                            <span>
                                <strong>Total Quantity:</strong>{" "}
                                {(() => {
                                    const qtyKg = parseFloat(
                                        activeProcess.avl_qty !== undefined && activeProcess.avl_qty !== null
                                            ? activeProcess.avl_qty
                                            : (activeProcess.manufactured_qty || activeProcess.desired_qty || 0)
                                    );

                                    const qtyGrams = qtyKg * 1000;

                                    return `${qtyKg.toFixed(2)} kg`;
                                })()}
                            </span>
                        </div>
                    </div>

                    {/* Commented out global packaging selection as it is now row-based
                    <div className="card mb-4" style={{ ...getPackagingCardStyle(), transition: "background-color 0.3s ease" }}>
                        <div className="card-header bg-light" style={{ backgroundColor: "transparent" }}>
                            <h6 className="mb-0 text-start">Packaging Material</h6>
                        </div>
                        <div className="card-body">
                            <div className="row g-3 text-start">
                                <div className="col-md-4">
                                    <label className="form-label">Select Packaging Material</label>
                                    <select
                                        className="form-select"
                                        value={selectedPackagingId}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (val) {
                                                const rawMat = rawMaterials.find(rm => String(rm.id) === String(val));
                                                if (rawMat) {
                                                    const match = rawMat.title.match(/^(\d+)\s*(grams?|g|kgs?|kilograms?)?/i);
                                                    if (match) {
                                                        const coverSizeGrams = convertToGrams(match[1], match[2]);
                                                        const activeItems = distributionItems.filter(item => parseFloat(item.qty || 0) > 0);
                                                        const allowedWeightsGrams = (activeItems.length > 0 ? activeItems : distributionItems)
                                                            .map(item => convertToGrams(item.p_weight, item.pbox_unit));

                                                        if (!allowedWeightsGrams.includes(coverSizeGrams)) {
                                                            const allowedWeightsStr = (activeItems.length > 0 ? activeItems : distributionItems)
                                                                .map(item => `${item.p_weight} ${item.pbox_unit || 'grams'}`)
                                                                .join(", ");
                                                            toast.error(`Cannot select ${rawMat.title}. The packaging size must match the package weight (${allowedWeightsStr}).`);
                                                            setSelectedPackagingId("");
                                                            setSelectedPackagingPrice("0");
                                                            setSelectedPackagingQty("");
                                                            return;
                                                        }
                                                    }
                                                }
                                            }
                                            setSelectedPackagingId(val);
                                            const rawMat = rawMaterials.find(rm => String(rm.id) === String(val));
                                            if (rawMat) {
                                                setSelectedPackagingPrice(rawMat.latest_price_unit || "0");
                                                const match = rawMat.title.match(/^(\d+)/);
                                                if (match) {
                                                    const coverSizeGrams = parseFloat(match[1]);
                                                    const totalQtyKg = parseFloat(activeProcess.manufactured_qty || activeProcess.desired_qty || 0);
                                                    const coverSizeInKg = coverSizeGrams / 1000;
                                                    if (coverSizeInKg > 0) {
                                                        const calculatedQty = Math.ceil(totalQtyKg / coverSizeInKg);
                                                        setSelectedPackagingQty(calculatedQty.toString());
                                                    }
                                                }
                                            } else {
                                                setSelectedPackagingPrice("0");
                                                setSelectedPackagingQty("");
                                            }
                                        }}
                                    >
                                        <option value="">-- Choose Packaging Material --</option>
                                        {rawMaterials.filter(rm => rm.type == "1").map(rm => (
                                            <option key={rm.id} value={rm.id} disabled={parseFloat(rm.remaining_stock || 0) <= 0}>
                                                {rm.title} (Stock: {parseFloat(rm.remaining_stock || 0).toFixed(2)} {unitMap[String(rm.unit_id)] || rm.unit_id || 'kg'})
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-2">
                                    <label className="form-label">Quantity</label>
                                    <div className="input-group">
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={selectedPackagingQty}
                                            onChange={(e) => setSelectedPackagingQty(e.target.value)}
                                            onWheel={(e) => e.currentTarget.blur()}
                                            placeholder="0.0"
                                            min="0"
                                            step="any"
                                        />
                                        <span className="input-group-text bg-light text-muted">
                                            {selectedPackagingId ? (unitMap[String(rawMaterials.find(rm => String(rm.id) === String(selectedPackagingId))?.unit_id)] || rawMaterials.find(rm => String(rm.id) === String(selectedPackagingId))?.unit_id || "kg") : "kg"}
                                        </span>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">Unit Price (₹)</label>
                                    <div className="input-group">
                                        <span className="input-group-text">₹</span>
                                        <input
                                            type="number"
                                            className="form-control bg-light"
                                            value={selectedPackagingPrice}
                                            placeholder="0.00"
                                            readOnly
                                            disabled
                                        />
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <label className="form-label">Total Price (₹)</label>
                                    <div className="input-group">
                                        <span className="input-group-text">₹</span>
                                        <input
                                            type="text"
                                            className="form-control bg-light"
                                            value={
                                                selectedPackagingQty && selectedPackagingPrice
                                                    ? (parseFloat(selectedPackagingQty) * parseFloat(selectedPackagingPrice)).toFixed(2)
                                                    : "0.00"
                                            }
                                            readOnly
                                            disabled
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    */}

                    {/* Product Package Management Header */}
                    <div className="d-flex justify-content-between mb-3">
                        <h6>Package Distribution</h6>
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                resetProductDetailsForm();
                                setFormData1({
                                    ...formData1,
                                    p_id: activeProcess.product_id || activeProcess.p_id
                                });
                                setShowDetailsModal(true);
                            }}
                        >
                            <i className="bi bi-plus-circle me-1"></i>Add Package Size
                        </button>
                    </div>

                    {distributionError && (
                        <div className="alert alert-danger">
                            <i className="bi bi-exclamation-triangle-fill me-2"></i>
                            {distributionError}
                        </div>
                    )}

                    {distributionItems.length === 0 ? (
                        <div className="alert alert-warning">
                            <i className="bi bi-info-circle me-2"></i>
                            No package sizes available for this product. Please add product details to continue.
                        </div>
                    ) : (
                        <form onSubmit={handleDistributionSubmit}>
                            {/* PREVIOUS PACKAGE DISTRIBUTION TABLE STRUCTURE (COMMENTED OUT)
                            <div className="table-responsive">
                                <table className="table table-bordered">
                                    <thead className="table-light">
                                        <tr>
                                            <th width="40">No.</th>
                                            <th>Package Type</th>
                                            <th width="100">Weight</th>
                                            <th width="150">Quantity (Packets)</th>
                                            <th width="150">Total Weight</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {distributionItems.map((item, index) => (
                                            <tr key={item.id}>
                                                <td className="text-center">{index + 1}</td>
                                                <td>{item.product_title}</td>
                                                <td>
                                                    {item.pbox_code === "FREE SIZE / LOSE QTY" || item.id === "FREE_SIZE" ? "Lose Packs" : item.p_weight + " " + item.pbox_unit}
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        value={item.qty}
                                                        onChange={(e) => handleDistributionQtyChange(item.id, e.target.value)}
                                                        onWheel={(e) => e.currentTarget.blur()}
                                                        min="0"
                                                        step="any"
                                                    />
                                                </td>
                                                <td>
                                                    <strong>
                                                        {(() => {
                                                            const totalGrams = convertToGrams(item.p_weight, item.pbox_unit) * (item.qty || 0);
                                                            if (totalGrams <= 999) {
                                                                return `${totalGrams} grams`;
                                                            } else {
                                                                return `${(totalGrams / 1000).toFixed(2)} kg`;
                                                            }
                                                        })()}
                                                    </strong>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>

                                    <tfoot>
                                        <tr className="table-active">
                                            <td colSpan="4" className="text-end"><strong>Total Distributed:</strong></td>
                                            <td
                                                className={(() => {
                                                    const targetInGrams = getTargetInGrams(activeProcess);
                                                    if (totalDistributedQty > targetInGrams) return "text-danger fw-bold";
                                                    if (Math.abs(totalDistributedQty - targetInGrams) <= 1) return "text-success fw-bold";
                                                    return "text-warning fw-bold";
                                                })()}
                                            >
                                                <strong>
                                                    {totalDistributedQty.toFixed(0)} grams
                                                    {totalDistributedQty >= 1000 && (
                                                        <small className="text-muted ms-2">
                                                            ({(totalDistributedQty / 1000).toFixed(2)} kg)
                                                        </small>
                                                    )}
                                                </strong>
                                            </td>
                                        </tr>
                                        <tr className="table">
                                            <td colSpan="4" className="text-end"><strong>Remaining Quantity:</strong></td>
                                            <td
                                                className={(() => {
                                                    const qty = parseFloat(
                                                        activeProcess.avl_qty !== undefined && activeProcess.avl_qty !== null
                                                            ? activeProcess.avl_qty
                                                            : activeProcess.manufactured_qty
                                                    );
                                                    const targetInGrams = qty * 1000;
                                                    const remainingQty = targetInGrams - totalDistributedQty;

                                                    if (remainingQty < 0) return "text-danger fw-bold"; // Over distributed
                                                    if (Math.abs(remainingQty) <= 1) return "text-success fw-bold"; // Perfect or within 1g
                                                    return "text-warning fw-bold"; // Still remaining
                                                })()}
                                            >
                                                <strong>
                                                    {(() => {
                                                        const qty = parseFloat(
                                                            activeProcess.avl_qty !== undefined && activeProcess.avl_qty !== null
                                                                ? activeProcess.avl_qty
                                                                : activeProcess.manufactured_qty
                                                        );
                                                        const targetInGrams = qty * 1000;
                                                        const remainingQty = targetInGrams - totalDistributedQty;

                                                        return (
                                                            <>
                                                                {remainingQty.toFixed(0)} grams
                                                                <small className="text-muted ms-2">
                                                                    ({(remainingQty / 1000).toFixed(2)} kg)
                                                                </small>
                                                            </>
                                                        );
                                                    })()}
                                                </strong>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            */}

                            {/* PACKAGE DISTRIBUTION TABLE (HIDDEN VIA STYLE) */}
                            <div style={{ display: "none" }}>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-sm mb-0" style={{ width: "100%", fontFamily: "poppins" }}>
                                        <thead className="table-light">
                                            <tr>
                                                <th width="40">No.</th>
                                                <th width="100">Weight</th>
                                                <th width="140">Quantity (Packets)</th>
                                                <th width="140">Total Weight</th>
                                                <th width="240">Packaging Material</th>
                                                <th width="120">Packaging Qty</th>
                                                <th width="110">Unit Price (₹)</th>
                                                <th width="120">Total Price (₹)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {distributionItems.map((item, index) => (
                                                <tr key={item.row_id || item.id || index}>
                                                    <td className="text-center">{index + 1}</td>
                                                    <td className="text-center">
                                                        <select
                                                            className="form-select form-select-sm"
                                                            style={{ minWidth: "125px", fontSize: "0.85rem" }}
                                                            value={item.id}
                                                            onChange={(e) => handleRowWeightChange(item.row_id || index, e.target.value)}
                                                        >
                                                            {getAvailableWeightOptions().map(detail => (
                                                                <option key={detail.id} value={detail.id}>
                                                                    {detail.pbox_code === "FREE SIZE / LOSE QTY" || detail.id === "FREE_SIZE"
                                                                        ? "Lose Packs"
                                                                        : `${detail.p_weight} ${detail.pbox_unit || ''}`}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control form-control-sm text-center"
                                                            value={item.qty || ""}
                                                            onChange={(e) => handleDistributionQtyChange(item.row_id || item.id, e.target.value)}
                                                            onWheel={(e) => e.currentTarget.blur()}
                                                            min="0"
                                                            step="any"
                                                        />
                                                    </td>
                                                    <td className="text-center">
                                                        <strong>
                                                            {(() => {
                                                                const totalGrams = convertToGrams(item.p_weight, item.pbox_unit) * (item.qty || 0);
                                                                if (totalGrams <= 999) {
                                                                    return `${totalGrams} grams`;
                                                                } else {
                                                                    return `${(totalGrams / 1000).toFixed(2)} kg`;
                                                                }
                                                            })()}
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        <select
                                                            className="form-select form-select-sm"
                                                            value={item.packaging_id || ""}
                                                            onChange={(e) => handleRowPackagingIdChange(item.row_id || item.id, e.target.value)}
                                                        >
                                                            <option value="">-- Choose --</option>
                                                            {rawMaterials.filter(rm => String(rm.type) === "1").map(rm => (
                                                                <option key={rm.id} value={rm.id} disabled={parseFloat(rm.remaining_stock || 0) <= 0}>
                                                                    {rm.title} (Stock: {parseFloat(rm.remaining_stock || 0).toFixed(2)} {unitMap[String(rm.unit_id)] || rm.unit_id || 'kg'})
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <div className="input-group input-group-sm">
                                                            <input
                                                                type="number"
                                                                className="form-control form-control-sm text-center"
                                                                value={item.packaging_qty !== undefined ? item.packaging_qty : ""}
                                                                onChange={(e) => handleRowPackagingQtyChange(item.row_id || item.id, e.target.value)}
                                                                onWheel={(e) => e.currentTarget.blur()}
                                                                placeholder="0"
                                                                min="0"
                                                                step="any"
                                                                disabled={!item.packaging_id}
                                                            />
                                                            {item.packaging_id && (
                                                                <span className="input-group-text px-1 bg-light text-muted" style={{ fontSize: "0.75rem" }}>
                                                                    {item.packaging_unit || "pcs"}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="number"
                                                            className="form-control form-control-sm text-center"
                                                            value={item.packaging_price || "0"}
                                                            placeholder="0.00"
                                                            readOnly
                                                            disabled
                                                        />
                                                    </td>
                                                    <td>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm text-center"
                                                            value={(parseFloat(item.packaging_qty || 0) * parseFloat(item.packaging_price || 0)).toFixed(2)}
                                                            readOnly
                                                            disabled
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>

                                        <tfoot>
                                            <tr className="table-active">
                                                <td colSpan="3" className="text-end fw-bold">Total Distributed:</td>
                                                <td
                                                    className={(() => {
                                                        const targetInGrams = getTargetInGrams(activeProcess);
                                                        if (totalDistributedQty > targetInGrams) return "text-danger fw-bold text-center";
                                                        if (Math.abs(totalDistributedQty - targetInGrams) <= 1) return "text-success fw-bold text-center";
                                                        return "text-warning fw-bold text-center";
                                                    })()}
                                                >
                                                    <strong>
                                                        {totalDistributedQty.toFixed(0)} grams
                                                        {totalDistributedQty >= 1000 && (
                                                            <small className="text-muted ms-2">
                                                                ({(totalDistributedQty / 1000).toFixed(2)} kg)
                                                            </small>
                                                        )}
                                                    </strong>
                                                </td>
                                                <td colSpan="3" className="text-end fw-bold">Total Packaging Cost:</td>
                                                <td className="text-center fw-bold text-success">
                                                    <strong>₹{parseFloat(totalPackagingPrice).toFixed(2)}</strong>
                                                </td>
                                            </tr>
                                            <tr className="table-light">
                                                <td colSpan="3" className="text-end fw-bold">Remaining Quantity:</td>
                                                <td
                                                    className={(() => {
                                                        const qty = parseFloat(
                                                            activeProcess.avl_qty !== undefined && activeProcess.avl_qty !== null
                                                                ? activeProcess.avl_qty
                                                                : activeProcess.manufactured_qty
                                                        );
                                                        const targetInGrams = qty * 1000;
                                                        const remainingQty = targetInGrams - totalDistributedQty;

                                                        if (remainingQty < 0) return "text-danger fw-bold text-center"; // Over distributed
                                                        if (Math.abs(remainingQty) <= 1) return "text-success fw-bold text-center"; // Perfect or within 1g
                                                        return "text-warning fw-bold text-center"; // Still remaining
                                                    })()}
                                                >
                                                    <strong>
                                                        {(() => {
                                                            const qty = parseFloat(
                                                                activeProcess.avl_qty !== undefined && activeProcess.avl_qty !== null
                                                                    ? activeProcess.avl_qty
                                                                    : activeProcess.manufactured_qty
                                                            );
                                                            const targetInGrams = qty * 1000;
                                                            const remainingQty = targetInGrams - totalDistributedQty;

                                                            return (
                                                                <>
                                                                    {remainingQty.toFixed(0)} grams
                                                                    <small className="text-muted ms-2">
                                                                        ({(remainingQty / 1000).toFixed(2)} kg)
                                                                    </small>
                                                                </>
                                                            );
                                                        })()}
                                                    </strong>
                                                </td>
                                                <td colSpan="4"></td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>

                            {/* NEW DISTRIBUTION FLOW SECTION (Multi-Column Vertical Card Layout) */}
                            <div className="card mt-4 shadow-sm" style={{ borderColor: "#1e293b", borderRadius: "12px", overflow: "hidden" }}>
                                <div className="card-header text-white d-flex justify-content-between align-items-center py-2.5 px-3" style={{ backgroundColor: "#1e293b" }}>
                                    <h6 className="mb-0 text-white fw-bold d-flex align-items-center gap-2">
                                        <i className="bi bi-box-seam fs-5"></i>Product Package Distribution
                                    </h6>
                                    <button
                                        type="button"
                                        className="btn btn-light btn-sm fw-semibold shadow-sm"
                                        onClick={addNewDistributionRow}
                                    >
                                        <i className="bi bi-plus-circle me-1"></i>Add
                                    </button>
                                </div>

                                <div className="card-body p-3 bg-light">

                                    {/* --- OLD HORIZONTAL TABLE LAYOUT (Preserved in Comments) --- */}
                                    {/*
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-sm align-middle mb-0" style={{ width: "100%", fontSize: "0.85rem" }}>
                                            <thead className="text-center align-middle">
                                                <tr>
                                                    <th>#</th>
                                                    <th>Product Qty</th>
                                                    <th>Product Price / kg (₹)</th>
                                                    <th>Product Bulk Cost (₹)</th>
                                                    <th>Pack Material</th>
                                                    <th>Pack Qty</th>
                                                    <th>Pack Cover Price (₹)</th>
                                                    <th>Wastages</th>
                                                    <th>Overall Costing (₹)</th>
                                                    <th>Per Piece Costing (₹)</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                ...
                                            </tbody>
                                        </table>
                                    </div>
                                    */}

                                    {/* Vertical Cards for Each Package Entry */}
                                    {newDistributionRows.map((row, index) => {
                                        const calcs = getNewRowCalculations(row);
                                        return (
                                            <div key={row.id || index} className="card border shadow-sm mb-3" style={{ borderRadius: "10px", backgroundColor: "#ffffff" }}>
                                                {/* Card Sub-Header */}
                                                <div className="card-header bg-white py-2 px-3 d-flex justify-content-between align-items-center border-bottom">
                                                    <div className="d-flex align-items-center gap-2">
                                                        <span className="badge bg-primary rounded-circle px-2 py-1 fs-6">#{index + 1}</span>
                                                        <span className="fw-bold text-dark small">Package Distribution Item #{index + 1}</span>
                                                    </div>
                                                    {newDistributionRows.length > 1 && (
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-outline-danger px-2.5 py-1 rounded-pill d-flex align-items-center gap-1"
                                                            title="Remove Row"
                                                            onClick={() => removeNewDistributionRow(index)}
                                                        >
                                                            <i className="bi bi-trash"></i> <span className="small">Delete Row</span>
                                                        </button>
                                                    )}
                                                </div>

                                                {/* Card Content - 3 Responsive Columns */}
                                                <div className="card-body p-3">
                                                    <div className="row g-3">

                                                        {/* Section 1: Product Powder Allocation */}
                                                        <div className="col-md-4">
                                                            <div className="p-3 rounded-3 border h-100" style={{ backgroundColor: "#f0f9ff", borderColor: "#bae6fd" }}>
                                                                <div className="fw-bold text-primary mb-2.5 small d-flex align-items-center gap-1.5 border-bottom pb-1.5" style={{ borderColor: "#bae6fd" }}>
                                                                    <i className="bi bi-box"></i> 1. Powder Allocation
                                                                </div>
                                                                <div className="row g-2">
                                                                    <div className="col-12">
                                                                        <label className="form-label text-muted mb-1 small">Product Qty Used</label>
                                                                        <div className="input-group input-group-sm">
                                                                            <input
                                                                                type="number"
                                                                                className="form-control text-center fw-semibold"
                                                                                placeholder="Qty"
                                                                                value={row.product_qty}
                                                                                onChange={(e) => handleNewRowChange(index, "product_qty", e.target.value)}
                                                                                onWheel={(e) => e.target.blur()}
                                                                                step="any" min="0"
                                                                            />
                                                                            <select
                                                                                className="form-select px-1"
                                                                                style={{ maxWidth: "85px" }}
                                                                                value={row.product_unit || ""}
                                                                                onChange={(e) => handleNewRowChange(index, "product_unit", e.target.value)}
                                                                            >
                                                                                <option value="">Unit</option>
                                                                                {getAvailableUnits.map((unit) => (
                                                                                    <option key={unit.id} value={unit.id}>{unit.title}</option>
                                                                                ))}
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-6 mt-2">
                                                                        <span className="text-muted small d-block">Price / kg</span>
                                                                        <span className="fw-bold text-dark">₹{calcs.costPerKg.toFixed(2)}</span>
                                                                    </div>
                                                                    <div className="col-6 text-end mt-2">
                                                                        <span className="text-muted small d-block">Bulk Cost</span>
                                                                        <span className="fw-bold text-primary">₹{calcs.productBulkCost.toFixed(2)}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Section 2: Packaging Material & Wastages */}
                                                        <div className="col-md-5">
                                                            <div className="p-3 rounded-3 border h-100" style={{ backgroundColor: "#fff7ed", borderColor: "#fed7aa" }}>
                                                                <div className="fw-bold text-warning-emphasis mb-2.5 small d-flex align-items-center gap-1.5 border-bottom pb-1.5" style={{ borderColor: "#fed7aa" }}>
                                                                    <i className="bi bi-bag"></i> 2. Packaging & Wastages
                                                                </div>
                                                                <div className="row g-2">
                                                                    <div className="col-12">
                                                                        <label className="form-label text-muted mb-1 small">Pack Material</label>
                                                                        <select
                                                                            className="form-select form-select-sm"
                                                                            value={row.packaging_id || ""}
                                                                            onChange={(e) => handleNewRowChange(index, "packaging_id", e.target.value)}
                                                                        >
                                                                            <option value="">-- Select Material --</option>
                                                                            {rawMaterials.filter(rm => String(rm.type) === "1").map(rm => (
                                                                                <option key={rm.id} value={rm.id} disabled={parseFloat(rm.remaining_stock || 0) <= 0}>
                                                                                    {rm.title} (Stock: {parseFloat(rm.remaining_stock || 0).toFixed(2)} {unitMap[String(rm.unit_id)] || rm.unit_id || 'pcs'})
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <label className="form-label text-muted mb-1 small">Pack Qty</label>
                                                                        <div className="input-group input-group-sm">
                                                                            <input
                                                                                type="number"
                                                                                className="form-control text-center"
                                                                                placeholder="Qty"
                                                                                value={row.pack_qty}
                                                                                onChange={(e) => handleNewRowChange(index, "pack_qty", e.target.value)}
                                                                                onWheel={(e) => e.target.blur()}
                                                                                step="any" min="0"
                                                                            />
                                                                            <select
                                                                                className="form-select px-1"
                                                                                style={{ maxWidth: "80px" }}
                                                                                value={row.pack_unit || "pcs"}
                                                                                onChange={(e) => handleNewRowChange(index, "pack_unit", e.target.value)}
                                                                            >
                                                                                <option value="">Unit</option>
                                                                                {getAvailableUnits
                                                                                    .filter((unit) => {
                                                                                        const title = (unit.title || "").toString().trim().toLowerCase();
                                                                                        return title === "kg" || title === "pcs";
                                                                                    })
                                                                                    .map((unit) => (
                                                                                        <option key={unit.id} value={unit.id}>{unit.title}</option>
                                                                                    ))}
                                                                            </select>
                                                                        </div>
                                                                        {calcs.isKgPackUnit && calcs.pcsPerKg > 0 && (
                                                                            <div className="text-muted mt-1 font-monospace fw-semibold" style={{ fontSize: '0.70rem' }}>
                                                                                (1 Kg = {calcs.pcsPerKg} pcs)
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <label className="form-label text-muted mb-1 small">Wastages</label>
                                                                        <div className="input-group input-group-sm">
                                                                            <input
                                                                                type="number"
                                                                                className="form-control text-center"
                                                                                placeholder="0"
                                                                                value={row.wastage_val}
                                                                                onChange={(e) => handleNewRowChange(index, "wastage_val", e.target.value)}
                                                                                onWheel={(e) => e.target.blur()}
                                                                                step="any" min="0"
                                                                            />
                                                                            <select
                                                                                className="form-select px-1"
                                                                                style={{ maxWidth: "80px" }}
                                                                                value={row.wastage_unit || "pcs"}
                                                                                onChange={(e) => handleNewRowChange(index, "wastage_unit", e.target.value)}
                                                                            >
                                                                                <option value="pcs">pcs</option>
                                                                                {getAvailableUnits.map((unit) => (
                                                                                    <option key={unit.id} value={unit.id}>{unit.title}</option>
                                                                                ))}
                                                                                <option value="₹">₹</option>
                                                                            </select>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* Section 3: Costing & Output */}
                                                        <div className="col-md-3">
                                                            <div className="p-3 rounded-3 border h-100 d-flex flex-column justify-content-between" style={{ backgroundColor: "#ecfdf5", borderColor: "#a7f3d0" }}>
                                                                <div className="fw-bold text-success mb-2.5 small d-flex align-items-center gap-1.5 border-bottom pb-1.5" style={{ borderColor: "#a7f3d0" }}>
                                                                    <i className="bi bi-calculator"></i> 3. Costing & Output
                                                                </div>
                                                                <div>
                                                                    <div className="d-flex justify-content-between mb-1.5">
                                                                        <span className="text-muted small">Bulk Cost:</span>
                                                                        <span className="fw-semibold text-dark">₹{calcs.productBulkCost.toFixed(2)}</span>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between mb-1.5">
                                                                        <span className="text-muted small">Pack Cover Price:</span>
                                                                        <span className="fw-semibold text-dark">₹{calcs.packCoverPrice.toFixed(2)}</span>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between mb-1.5">
                                                                        <span className="text-muted small">Overall Costing:</span>
                                                                        <span className="fw-bold text-primary">₹{calcs.overallCosting.toFixed(2)}</span>
                                                                    </div>
                                                                </div>
                                                                <div className="mt-2 text-center pt-2 border-top border-success-subtle">
                                                                    <span className="text-muted small d-block mb-1">Per Piece Costing</span>
                                                                    <span className="badge bg-success fs-6 fw-semibold px-3 py-1.5 shadow-sm">
                                                                        ₹{parseFloat(calcs.perPieceCosting.toFixed(3))} / pc
                                                                    </span>
                                                                    {calcs.usablePcs > 0 && (
                                                                        <div className="text-muted extra-small mt-1">({calcs.usablePcs.toFixed(0)} usable pcs)</div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}

                                    {/* Overall Batch Summary Banner */}
                                    {(() => {
                                        const summary = calculateNewDistributionSummary();
                                        return (
                                            <div className="card border-0 shadow-sm rounded-3 mt-3" style={{ backgroundColor: "#1e293b", color: "#ffffff" }}>
                                                <div className="card-body p-3">
                                                    <div className="row g-3 align-items-center text-center text-md-start">
                                                        <div className="col-md-3">
                                                            <span className="text-white-50 d-block small">Total Distributed</span>
                                                            <span className={`fw-bold fs-6 ${summary.totalDistributedKg > summary.totalBulkKg ? "text-danger" : "text-success"}`}>
                                                                {summary.totalDistributedKg.toFixed(2)} kg {/* <small className="text-white-50">({(summary.totalDistributedKg * 1000).toFixed(0)} g)</small> */}
                                                            </span>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <span className="text-white-50 d-block small">Remaining Bulk Stock</span>
                                                            <span className={`fw-bold fs-6 ${summary.remainingKg < 0 ? "text-danger" : "text-warning"}`}>
                                                                {summary.remainingKg.toFixed(2)} kg {/* <small className="text-white-50">({summary.remainingGrams.toFixed(0)} g)</small> */}
                                                            </span>
                                                        </div>
                                                        <div className="col-md-3">
                                                            <span className="text-white-50 d-block small">Packaging & Wastage Cost</span>
                                                            <span className="fw-bold fs-6 text-info">
                                                                ₹{(summary.totalPackCost + summary.totalWastageCost).toFixed(2)}
                                                            </span>
                                                        </div>
                                                        <div className="col-md-3 text-md-end">
                                                            <span className="text-white-50 d-block small">Total Process Cost</span>
                                                            {/* <span className="text-white-50 d-block small">Total Process Cost & Avg Cost</span> */}
                                                            <span className="fw-bold fs-5 text-success">₹{summary.totalOverallCosting.toFixed(2)}</span>
                                                            {/* <span className="badge bg-primary fs-6 px-2.5 py-1">
                                                                ₹{parseFloat(summary.avgPerPieceCost.toFixed(3))} / pc
                                                            </span> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })()}

                                </div>
                            </div>
                            <div className="d-flex justify-content-between mt-4">
                                <div>
                                    {/* <button
                                        type="button"
                                        className="btn btn-outline-secondary me-2"
                                        onClick={() => setCurrentStep(2)}
                                    >
                                        <i className="bi bi-arrow-left me-1"></i> Back
                                    </button> */}
                                    <button
                                        type="button"
                                        className="btn btn-outline-danger"
                                        onClick={handleCancelProcess}
                                        disabled={isSubmitting}
                                    >
                                        <i className="bi bi-x-circle me-1"></i> Cancel Process
                                    </button>
                                </div>
                                <button
                                    type="submit"
                                    className="btn btn-success"
                                    disabled={!isDistributionComplete() || isSubmitting}
                                >
                                    {isSubmitting ? "Completing..." : <><i className="bi bi-check-circle me-1"></i> Complete Process</>}
                                </button>


                            </div>
                        </form>
                    )}
                </div>
            </div>
        );
    };

    const handlePrintCompletedDetails = (p) => {
        if (!p) return;

        const customExpenses = p.custom_expenses || [];
        const customExpensesTotal = customExpenses.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

        const totalExpenses = (
            parseFloat(p.eb_rent_charges || 0) +
            parseFloat(p.labour_charges || 0) +
            parseFloat(p.package_charges || 0) +
            parseFloat(p.other_charges || 0) +
            customExpensesTotal
        );

        const totalDistributedQty = (p.distribution || []).reduce((sum, item) => sum + parseFloat(item.qty || 0), 0);
        const costPerPacket = totalDistributedQty > 0 ? (parseFloat(p.overall_price || 0) / totalDistributedQty) : 0;

        const manufacturedQty = parseFloat(p.manufactured_qty || p.desired_qty || 0);
        const undistributedQty = parseFloat(p.undistributed_qty !== undefined ? p.undistributed_qty : 0);
        const distributedQty = Math.max(0, manufacturedQty - undistributedQty);
        const overallPrice = parseFloat(p.overall_price || 0);
        const mfgUnitCost = manufacturedQty > 0 ? (overallPrice / manufacturedQty) : 0;
        const distributedCost = distributedQty * mfgUnitCost;
        const undistributedCost = undistributedQty * mfgUnitCost;

        let customExpensesHTML = '';
        if (customExpenses.length > 0) {
            customExpensesHTML = customExpenses.map(item => `
                <div class="expense-row">
                    <span>${item.title}:</span>
                    <span class="value">₹${parseFloat(item.amount || 0).toFixed(2)}</span>
                </div>
            `).join('');
        }

        const printWindow = window.open('', '_blank');

        // Build ingredients table rows
        let ingredientsRows = '';
        if (p.ingredients && p.ingredients.length > 0) {
            p.ingredients.forEach((item, idx) => {
                ingredientsRows += `
                    <tr>
                        <td>${idx + 1}</td>
                        <td style="font-weight: 600;">${item.raw_material_name}</td>
                        <td style="text-align: right;">${getIngredientQtyAndUnitDisplay(item, rawMaterials, unitMap)}</td>
                        <td style="text-align: right; font-weight: bold; color: #2e7d32;">${formatIngredientPrice(item)}</td>
                    </tr>
                `;
            });
            const totalIngredientCost = p.ingredients.reduce((sum, item) => {
                const qty = parseFloat(item.qty || 0);
                const priceUnit = parseFloat(item.price_unit || 0);
                let cost = qty * priceUnit;
                if (isNaN(priceUnit) || priceUnit <= 0 || isNaN(cost) || cost <= 0) {
                    cost = parseFloat(item.price || 0);
                }
                return sum + cost;
            }, 0);
            ingredientsRows += `
                <tr style="background-color: #f1f8e9; border-top: 2px solid #2e7d32; font-weight: bold;">
                    <td colspan="3" style="text-align: right; color: #2e7d32; font-weight: bold; font-size: 10pt;">Total Ingredient Cost:</td>
                    <td style="text-align: right; font-weight: bold; color: #2e7d32; font-size: 10pt;">₹${totalIngredientCost.toFixed(2)}</td>
                </tr>
            `;
        } else {
            ingredientsRows = `<tr><td colspan="4" style="text-align: center; color: #666;">No raw materials were used or recorded.</td></tr>`;
        }

        // Build distribution table rows
        let distributionRows = '';
        if (p.distribution && p.distribution.length > 0) {
            p.distribution.forEach((item, idx) => {
                const qty = parseFloat(item.qty || 0);
                // const price = parseFloat(item.price || 0);
                // const totalVal = qty * price;

                // Calculate true unit cost per packet from batch portion breakdown
                const weightGrams = parseFloat(item.p_weight || 0);
                const unitStr = String(item.pbox_unit || "").toLowerCase().trim();
                const packetWeightInKg = (unitStr.includes("kg") || unitStr.includes("kilo"))
                    ? weightGrams
                    : (unitStr.includes("gram") || unitStr === "g")
                        ? (weightGrams / 1000.0)
                        : weightGrams;

                // True unit price and total value
                const truePrice = mfgUnitCost * packetWeightInKg;
                const totalVal = qty * truePrice;
                const formattedPrice = truePrice < 0.01 && truePrice > 0 ? truePrice.toFixed(4) : truePrice.toFixed(2);

                const isLoose = item.is_loose || item.isLoose ||
                    (item.packet_title && item.packet_title.toLowerCase().includes("loose")) ||
                    (p.product_title && p.product_title.toLowerCase().includes("loose")) ||
                    String(item.status) === "3";
                const qtyUnit = isLoose ? (p.unit || "kg") : "packets";

                distributionRows += `
                    <tr>
                        <td>${idx + 1}</td>
                        <td style="font-weight: 600;">${item.packet_title}</td>
                        <td style="text-align: right; font-weight: bold; color: #2e7d32;">${qty.toFixed(1)} ${qtyUnit}</td>
                        <td style="text-align: right; font-weight: bold; color: #666;">₹${formattedPrice}</td>
                        <td style="text-align: right; font-weight: bold; color: #0d6efd;">₹${totalVal.toFixed(2)}</td>
                    </tr>
                `;
            });
        } else {
            distributionRows = `<tr><td colspan="5" style="text-align: center; color: #666;">No packet distributions were recorded.</td></tr>`;
        }

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
            <head>
                <title>Batch Details - #${p.batch_no || 'N/A'}</title>
                <style>
                    body {
                        font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
                        font-size: 11pt;
                        color: #333;
                        line-height: 1.4;
                        margin: 0;
                        padding: 20px;
                    }
                    .print-container {
                        max-width: 800px;
                        margin: 0 auto;
                        border: 1px solid #e0e0e0;
                        border-radius: 8px;
                        padding: 30px;
                        box-shadow: 0 4px 6px rgba(0,0,0,0.05);
                    }
                    .header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        border-bottom: 3px solid #2e7d32;
                        padding-bottom: 15px;
                        margin-bottom: 25px;
                    }
                    .header-title {
                        margin: 0;
                        font-size: 22pt;
                        font-weight: bold;
                        color: #2e7d32;
                    }
                    .header-badge {
                        background-color: #2e7d32;
                        color: white;
                        padding: 8px 16px;
                        border-radius: 20px;
                        font-weight: bold;
                        font-size: 12pt;
                    }
                    .section-card {
                        background-color: #f8f9fa;
                        border-radius: 8px;
                        padding: 20px;
                        margin-bottom: 20px;
                        border: 1px solid #e9ecef;
                    }
                    .section-title {
                        font-size: 13pt;
                        font-weight: bold;
                        color: #2e7d32;
                        margin-top: 0;
                        margin-bottom: 15px;
                        display: flex;
                        align-items: center;
                        gap: 10px;
                    }
                    .section-title-number {
                        background-color: #2e7d32;
                        color: white;
                        border-radius: 50%;
                        width: 24px;
                        height: 24px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 10pt;
                    }
                    .grid-4 {
                        display: grid;
                        grid-template-columns: repeat(4, 1fr);
                        gap: 15px;
                    }
                    .grid-2 {
                        display: grid;
                        grid-template-columns: repeat(2, 1fr);
                        gap: 20px;
                    }
                    .label {
                        font-size: 9pt;
                        color: #666;
                        text-transform: uppercase;
                        display: block;
                        margin-bottom: 5px;
                    }
                    .value {
                        font-weight: 600;
                        color: #111;
                        font-size: 11pt;
                    }
                    .value-highlight {
                        color: #2e7d32;
                        font-weight: 700;
                    }
                    table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-top: 10px;
                        background: white;
                        border-radius: 6px;
                        overflow: hidden;
                        border: 1px solid #dee2e6;
                    }
                    th, td {
                        padding: 10px 12px;
                        font-size: 10pt;
                        text-align: left;
                        border-bottom: 1px solid #dee2e6;
                    }
                    th {
                        background-color: #2e7d32;
                        color: white;
                        font-weight: 600;
                    }
                    .text-right {
                        text-align: right;
                    }
                    .expense-row {
                        display: flex;
                        justify-content: space-between;
                        padding: 6px 0;
                        border-bottom: 1px dashed #e9ecef;
                        font-size: 10pt;
                    }
                    .expense-total {
                        display: flex;
                        justify-content: space-between;
                        padding: 10px 0 0 0;
                        margin-top: 8px;
                        border-top: 2px solid #2e7d32;
                        font-weight: bold;
                        color: #2e7d32;
                        font-size: 12pt;
                    }
                    .price-large {
                        font-size: 16pt;
                        font-weight: bold;
                    }
                    .price-cost {
                        color: #dc3545;
                    }
                    .price-sales {
                        color: #2e7d32;
                    }
                    .remarks-box {
                        background-color: #fff3cd;
                        border: 1px solid #ffeeba;
                        color: #856404;
                        padding: 15px;
                        border-radius: 6px;
                        margin-top: 20px;
                    }
                    .footer-note {
                        text-align: center;
                        margin-top: 30px;
                        font-size: 9pt;
                        color: #888;
                        border-top: 1px solid #e0e0e0;
                        padding-top: 15px;
                    }
                    @media print {
                        body {
                            padding: 0;
                        }
                        .print-container {
                            border: none;
                            box-shadow: none;
                            padding: 0;
                            max-width: 100%;
                        }
                        @page {
                            size: A4;
                            margin: 1.5cm;
                        }
                    }
                </style>
            </head>
            <body>
                <div class="print-container">
                    <div class="header">
                        <div>
                            <h1 class="header-title">${shopItem?.title || 'Processing Batch Details'}</h1>
                            <div style="font-size: 10pt; color: #555; margin-top: 4px;">
                                ${shopItem?.Address || ''} ${shopItem?.phone1 ? '| Tel: ' + shopItem?.phone1 : ''}
                            </div>
                        </div>
                        <div class="header-badge">Batch #${p.batch_no || 'N/A'}</div>
                    </div>

                    <!-- Step 1: Setup Details -->
                    <div class="section-card">
                        <h2 class="section-title">
                            <span class="section-title-number">1</span>
                            Step 1: Setup Details
                        </h2>
                        <div class="grid-4">
                            <div>
                                <span class="label">Finished Product</span>
                                <span class="value">${p.product_title}</span>
                            </div>
                            <div>
                                <span class="label">Desired Quantity</span>
                                <span class="value">${p.desired_qty} ${p.unit}</span>
                            </div>
                            <div>
                                <span class="label">Processing Date</span>
                                <span class="value">${p.mfg_date || p.create_date?.split('T')[0]}</span>
                            </div>
                            <div>
                                <span class="label">Batch Number</span>
                                <span class="value value-highlight">${p.batch_no || '-'}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Step 2: Manufacturing Details & Expenses -->
                    <div class="section-card">
                        <h2 class="section-title">
                            <span class="section-title-number">2</span>
                            Step 2: Manufacturing & Expenses
                        </h2>
                        
                        <div style="margin-bottom: 20px;">
                            <span class="label" style="font-weight: bold; margin-bottom: 10px;">Ingredients Used</span>
                            <table>
                                <thead>
                                    <tr>
                                        <th style="width: 8%;">S.No</th>
                                        <th>Ingredient Name</th>
                                        <th style="text-align: right; width: 25%;">Quantity Used</th>
                                        <th style="text-align: right; width: 25%;">Total Price (INR)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    ${ingredientsRows}
                                </tbody>
                            </table>
                        </div>

                        <div class="grid-2" style="border-top: 1px solid #dee2e6; padding-top: 20px; margin-top: 20px;">
                            <div style="border-right: 1px solid #dee2e6; padding-right: 20px;">
                                <span class="label" style="font-weight: bold; margin-bottom: 10px;">Expenses Breakdown</span>
                                <div class="expense-row">
                                    <span>EB/Rent Charges:</span>
                                    <span class="value">₹${parseFloat(p.eb_rent_charges || 0).toFixed(2)}</span>
                                </div>
                                <div class="expense-row">
                                    <span>Labour Charges:</span>
                                    <span class="value">₹${parseFloat(p.labour_charges || 0).toFixed(2)}</span>
                                </div>
                                <div class="expense-row">
                                    <span>Package Charges:</span>
                                    <span class="value">₹${parseFloat(p.package_charges || 0).toFixed(2)}</span>
                                </div>
                                <div class="expense-row">
                                    <span>Other Charges:</span>
                                    <span class="value">₹${parseFloat(p.other_charges || 0).toFixed(2)}</span>
                                </div>
                                ${customExpensesHTML}
                                <div class="expense-total">
                                    <span>Total Expenses:</span>
                                    <span>₹${totalExpenses.toFixed(2)}</span>
                                </div>
                            </div>

                            <div style="padding-left: 20px;">
                                <span class="label" style="font-weight: bold; margin-bottom: 10px;">Product Pricing Details</span>
                                <div style="margin-bottom: 15px;">
                                    <span class="label">Manufactured Quantity</span>
                                    <span class="value" style="font-size: 12pt;">${p.manufactured_qty || p.desired_qty} ${p.unit}</span>
                                </div>
                                <div class="grid-2">
                                    <div>
                                        <!-- Commented old Cost Per Unit (Mfg Unit)
                                        <span class="label">Cost Per Unit (Mfg Unit)</span>
                                        <span class="price-large price-cost">₹${parseFloat(p.mfg_price_unit || 0).toFixed(2)}</span>
                                        -->
                                        <span class="label">Overall Manufacturing Cost</span>
                                        <span class="price-large price-cost">₹${parseFloat(p.overall_price || 0).toFixed(2)}</span>
                                        ${totalDistributedQty > 0 ? `
                                            <div style="margin-top: 15px;">
                                                <span class="label">Cost Per Distributed Pkt</span>
                                                <span class="price-large" style="color: #0d6efd;">₹${costPerPacket.toFixed(2)}</span>
                                            </div>
                                        ` : ''}
                                    </div>
                                    <div>
                                        <span class="label">Sales Price</span>
                                        <span class="price-large price-sales">₹${parseFloat(p.sales_price_unit || 0).toFixed(2)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Portion Breakdown Details -->
                    <div class="section-card">
                        <h2 class="section-title">
                            Batch Portion Breakdown
                        </h2>
                        <div class="grid-4">
                            <div>
                                <span class="label">Distributed Quantity</span>
                                <span class="value">${distributedQty.toFixed(2)} ${p.unit}</span>
                            </div>
                            <div>
                                <span class="label">Distributed Cost</span>
                                <span class="value" style="color: #2e7d32; font-weight: bold;">₹${distributedCost.toFixed(2)}</span>
                            </div>
                            <div>
                                <span class="label">Undistributed Quantity</span>
                                <span class="value">${undistributedQty.toFixed(2)} ${p.unit}</span>
                            </div>
                            <div>
                                <span class="label">Undistributed Cost</span>
                                <span class="value" style="color: #dc3545; font-weight: bold;">₹${undistributedCost.toFixed(2)}</span>
                            </div>
                        </div>
                    </div>

                    <!-- Step 3: Batch Distribution Details -->
                    <div class="section-card">
                        <h2 class="section-title">
                            <span class="section-title-number">3</span>
                            Step 3: Batch Distribution Details
                        </h2>
                        <table>
                            <thead>
                                <tr>
                                    <th style="width: 8%;">S.No</th>
                                    <th>Package Style</th>
                                    <th style="text-align: right; width: 25%;">Distributed Qty</th>
                                    <th style="text-align: right; width: 25%;">Unit Cost Per Packet</th>
                                    <th style="text-align: right; width: 25%;">Total Value (INR)</th>
                                </tr>
                            </thead>
                            <tbody>
                                ${distributionRows}
                            </tbody>
                        </table>
                    </div>

                    ${p.remarks ? `
                    <div class="remarks-box">
                        <strong style="display: block; font-size: 9pt; text-transform: uppercase; margin-bottom: 5px;">Remarks:</strong>
                        <div style="font-size: 10.5pt; font-weight: 500;">${p.remarks}</div>
                    </div>
                    ` : ''}

                    <div class="footer-note">
                        Report Generated on ${new Date().toLocaleDateString()} at ${new Date().toLocaleTimeString()}
                    </div>
                </div>

                <script>
                    window.onload = function() {
                        window.print();
                        setTimeout(function() {
                            window.close();
                        }, 500);
                    };
                </script>
            </body>
            </html>
        `);

        printWindow.document.close();
    };

    const renderBatchWiseSalesReportModal = () => {
        if (!showBatchReportModal || !batchReportData) return null;

        const header = batchReportData.header || {};
        const sales = batchReportData.sales || [];

        return (
            <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content shadow-lg border-0" style={{ borderRadius: '16px', overflow: 'hidden' }}>
                        {/* Modal Header */}
                        <div className="modal-header bg-primary text-white py-3" style={{ borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}>
                            <div className="d-flex align-items-center gap-2">
                                <i className="bi bi-file-earmark-bar-graph fs-4"></i>
                                <h5 className="modal-title fw-bold m-0">Batch wise Report</h5>
                            </div>
                            <span className="badge bg-white text-primary fw-bold px-3 py-2 rounded-pill shadow-sm ms-auto me-3">
                                Batch #{header.batch_no || 'N/A'}
                            </span>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                style={{ marginLeft: "0" }}
                                onClick={() => {
                                    setShowBatchReportModal(false);
                                    setBatchReportData(null);
                                }}
                            ></button>
                        </div>

                        {/* Modal Body */}
                        <div className="modal-body p-4" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                            {/* Summary Cards */}
                            <div className="row g-3 mb-4">
                                <div className="col-md-6 col-lg-3">
                                    <div className="p-3 bg-light rounded shadow-sm border h-100 d-flex flex-column justify-content-between">
                                        <small className="text-muted d-block text-uppercase fw-bold mb-1" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>Product</small>
                                        <span className="fw-bold text-dark fs-6 text-truncate" title={header.product_name || '-'}>{header.product_name || '-'}</span>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-3">
                                    <div className="p-3 bg-light rounded shadow-sm border h-100 d-flex flex-column justify-content-between">
                                        <small className="text-muted d-block text-uppercase fw-bold mb-1" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>Batch No</small>
                                        <span className="fw-bold text-primary fs-6">{header.batch_no || '-'}</span>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-3">
                                    <div className="p-3 bg-light rounded shadow-sm border h-100 d-flex flex-column justify-content-between">
                                        <small className="text-muted d-block text-uppercase fw-bold mb-1" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>Total Qty</small>
                                        <span className="fw-bold text-success fs-6">{header.total_qty || '0'} {header.unit || 'kg'}</span>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-3">
                                    <div className="p-3 bg-light rounded shadow-sm border h-100 d-flex flex-column justify-content-between">
                                        <small className="text-muted d-block text-uppercase fw-bold mb-1" style={{ fontSize: '0.7rem', letterSpacing: '0.5px' }}>Created Details</small>
                                        <div className="d-flex flex-column">
                                            <span className="fw-semibold text-secondary" style={{ fontSize: '0.78rem', lineHeight: '1.2' }}>
                                                Date: {header.created_date || '-'}
                                            </span>
                                            <span className="fw-semibold text-secondary" style={{ fontSize: '0.78rem', lineHeight: '1.2' }}>
                                                By: {header.creator_name || 'System'}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Sales Table */}
                            <h6 className="fw-bold text-dark mb-3">Sales Breakdown</h6>
                            <div className="table-responsive">
                                <table className="table table-sm table-striped table-hover align-middle border mb-0 bg-white" style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                    <thead className="table-primary text-white">
                                        <tr>
                                            <th className="ps-3 py-2 small" style={{ backgroundColor: "#0d6efd", color: "white" }}>#</th>
                                            <th className="py-2 small" style={{ backgroundColor: "#0d6efd", color: "white" }}>Client</th>
                                            <th className="py-2 small" style={{ backgroundColor: "#0d6efd", color: "white" }}>Date</th>
                                            <th className="py-2 small text-end" style={{ backgroundColor: "#0d6efd", color: "white" }}>Qty</th>
                                            <th className="py-2 small" style={{ backgroundColor: "#0d6efd", color: "white" }}>Invoice No</th>
                                            <th className="pe-3 py-2 small text-end" style={{ backgroundColor: "#0d6efd", color: "white" }}>Remaining</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sales.length > 0 ? (
                                            sales.map((sale, idx) => (
                                                <tr key={idx}>
                                                    <td className="ps-3 py-2 text-secondary small">{idx + 1}</td>
                                                    <td className="py-2 fw-semibold text-dark small" style={{ maxWidth: "160px", whiteSpace: "normal", overflowWrap: "break-word" }}>{sale.customer_name || 'Unknown/Direct'}</td>
                                                    <td className="py-2 text-secondary small">{(sale.order_date || sale.txn_date || '').split(' ')[0]}</td>
                                                    <td className="py-2 text-end fw-bold text-success small">{parseFloat(sale.qty || 0).toFixed(1)} pkts ({sale.weight_in_kg || 0} {header.unit || 'kg'})</td>
                                                    <td className="py-2 fw-semibold text-primary small">{sale.order_id || '-'}</td>
                                                    <td className="pe-3 py-2 text-end fw-bold text-danger small">{sale.remaining_qty} {header.unit || 'kg'}</td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center py-4 text-muted small">
                                                    <i className="bi bi-inbox me-2"></i>
                                                    No sales recorded for this batch yet.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Modal Footer */}
                        <div className="modal-footer bg-light py-2" style={{ borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px' }}>
                            <button
                                type="button"
                                className="btn btn-secondary px-4 rounded-pill shadow-sm"
                                onClick={() => {
                                    setShowBatchReportModal(false);
                                    setBatchReportData(null);
                                }}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const renderCompletedDetailsModal = () => {
        if (!showCompletedDetailsModal || !selectedCompletedProcess) return null;

        const p = selectedCompletedProcess;

        // Calculate total charges
        const customExpenses = p.custom_expenses || [];
        const customExpensesTotal = customExpenses.reduce((sum, item) => sum + parseFloat(item.amount || 0), 0);

        const totalExpenses = (
            parseFloat(p.eb_rent_charges || 0) +
            parseFloat(p.labour_charges || 0) +
            parseFloat(p.package_charges || 0) +
            parseFloat(p.other_charges || 0) +
            customExpensesTotal
        );

        const totalDistributedQty = (p.distribution || []).reduce((sum, item) => sum + parseFloat(item.qty || 0), 0);
        const costPerPacket = totalDistributedQty > 0 ? (parseFloat(p.overall_price || 0) / totalDistributedQty) : 0;

        const manufacturedQty = parseFloat(p.manufactured_qty || p.desired_qty || 0);
        const undistributedQty = parseFloat(p.undistributed_qty !== undefined ? p.undistributed_qty : 0);
        const distributedQty = Math.max(0, manufacturedQty - undistributedQty);
        const overallPrice = parseFloat(p.overall_price || 0);
        const mfgUnitCost = manufacturedQty > 0 ? (overallPrice / manufacturedQty) : 0;
        const distributedCost = distributedQty * mfgUnitCost;
        const undistributedCost = undistributedQty * mfgUnitCost;

        return (
            <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060 }}>
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content shadow-lg border-0" style={{ borderRadius: '16px', overflow: 'hidden' }}>

                        {/* Modal Header */}
                        <div className="modal-header bg-success text-white py-3" style={{ borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}>
                            <div className="d-flex align-items-center gap-2">
                                <i className="bi bi-patch-check-fill fs-4"></i>
                                <h5 className="modal-title fw-bold m-0">Processing Batch Details</h5>
                            </div>
                            <span className="badge bg-white text-success fw-bold px-3 py-2 rounded-pill shadow-sm ms-auto me-3">
                                Batch #{p.batch_no || 'N/A'}
                            </span>
                            <button
                                type="button"
                                className="btn-close btn-close-white"
                                style={{ marginLeft: "0" }}
                                onClick={() => {
                                    setShowCompletedDetailsModal(false);
                                    setSelectedCompletedProcess(null);
                                }}
                            ></button>
                        </div>

                        {/* Modal Body */}
                        <div className="modal-body p-4" style={{ maxHeight: '75vh', overflowY: 'auto' }}>
                            <div className="row g-4">

                                {/* Step 1: Creation Summary */}
                                <div className="col-12">
                                    <div className="card border-0 bg-light shadow-sm" style={{ borderRadius: '12px' }}>
                                        <div className="card-body p-3">
                                            <h6 className="fw-bold text-success mb-3 d-flex align-items-center gap-2">
                                                <span className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '24px', height: '24px', fontSize: '12px' }}>1</span>
                                                Step 1: Setup Details
                                            </h6>
                                            <div className="row g-3">
                                                <div className="col-md-6 col-lg-3">
                                                    <small className="text-muted d-block">Finished Product</small>
                                                    <span className="fw-semibold text-dark fs-6">{p.product_title}</span>
                                                </div>
                                                <div className="col-md-6 col-lg-3">
                                                    <small className="text-muted d-block">Desired Quantity</small>
                                                    <span className="fw-semibold text-dark fs-6">{p.desired_qty} {p.unit}</span>
                                                </div>
                                                <div className="col-md-6 col-lg-3">
                                                    <small className="text-muted d-block">Processing Date</small>
                                                    <span className="fw-semibold text-dark fs-6">{p.mfg_date || p.create_date?.split('T')[0]}</span>
                                                </div>
                                                <div className="col-md-6 col-lg-3">
                                                    <small className="text-muted d-block">Batch Number</small>
                                                    <span className="fw-semibold text-dark fs-6 text-success">{p.batch_no || '-'}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Step 2: Manufacturing Details */}
                                <div className="col-12">
                                    <div className="card border-0 shadow-sm" style={{ borderRadius: '12px', border: '1px solid #e3e6f0' }}>
                                        <div className="card-body p-3">
                                            <h6 className="fw-bold text-success mb-3 d-flex align-items-center gap-2">
                                                <span className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center" style={{ width: '24px', height: '24px', fontSize: '12px' }}>2</span>
                                                Step 2: Manufacturing & Expenses
                                            </h6>

                                            {/* Ingredients list */}
                                            <div className="mb-4">
                                                <span className="fw-bold text-secondary d-block mb-2 small text-uppercase">Ingredients Used</span>
                                                {p.ingredients && p.ingredients.length > 0 ? (
                                                    <div className="table-responsive">
                                                        <table className="table table-sm table-striped table-hover align-middle border mb-0" style={{ borderRadius: '8px', overflow: 'hidden' }}>
                                                            <thead className="table-success text-white">
                                                                <tr>
                                                                    <th className="ps-3 py-2 small" style={{ backgroundColor: "#2e7d32", color: "white" }}>S.No</th>
                                                                    <th className="py-2 small" style={{ backgroundColor: "#2e7d32", color: "white" }}>Ingredient Name</th>
                                                                    <th className="py-2 small text-end" style={{ backgroundColor: "#2e7d32", color: "white" }}>Quantity Used</th>
                                                                    <th className="pe-3 py-2 small text-end" style={{ backgroundColor: "#2e7d32", color: "white" }}>Total Price (INR)</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {p.ingredients.map((item, idx) => (
                                                                    <tr key={idx}>
                                                                        <td className="ps-3 py-2 text-secondary small">{idx + 1}</td>
                                                                        <td className="py-2 fw-semibold text-dark small">{item.raw_material_name}</td>
                                                                        <td className="py-2 text-end fw-semibold text-secondary small">
                                                                            {getIngredientQtyAndUnitDisplay(item, rawMaterials, unitMap)}
                                                                        </td>
                                                                        <td className="pe-3 py-2 text-end fw-bold text-success small">{formatIngredientPrice(item)}</td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                            <tfoot>
                                                                <tr style={{ backgroundColor: "#f1f8e9", borderTop: "2px solid #2e7d32" }}>
                                                                    <td colSpan="3" className="text-end fw-bold ps-3 py-2 small" style={{ color: "#2e7d32" }}>Total Ingredient Cost:</td>
                                                                    <td className="pe-3 py-2 text-end fw-bold text-success small" style={{ color: "#2e7d32" }}>₹{p.ingredients.reduce((sum, item) => {
                                                                        const qty = parseFloat(item.qty || 0);
                                                                        const priceUnit = parseFloat(item.price_unit || 0);
                                                                        let cost = qty * priceUnit;
                                                                        if (isNaN(priceUnit) || priceUnit <= 0 || isNaN(cost) || cost <= 0) {
                                                                            cost = parseFloat(item.price || 0);
                                                                        }
                                                                        return sum + cost;
                                                                    }, 0).toFixed(2)}</td>
                                                                </tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                ) : (
                                                    <div className="text-muted p-2 bg-light rounded text-center small">No raw materials were used or recorded.</div>
                                                )}
                                            </div>

                                            {/* Expenses and Cost Per Unit */}
                                            <div className="row g-3 pt-2 border-top">
                                                <div className="col-md-6 border-end">
                                                    <span className="fw-bold text-secondary d-block mb-2 small text-uppercase">Expenses breakdown</span>
                                                    <div className="d-flex flex-column gap-1 small">
                                                        <div className="d-flex justify-content-between text-secondary">
                                                            <span>EB/Rent Charges:</span>
                                                            <span className="fw-semibold text-dark">₹{parseFloat(p.eb_rent_charges || 0).toFixed(2)}</span>
                                                        </div>
                                                        <div className="d-flex justify-content-between text-secondary">
                                                            <span>Labour Charges:</span>
                                                            <span className="fw-semibold text-dark">₹{parseFloat(p.labour_charges || 0).toFixed(2)}</span>
                                                        </div>
                                                        <div className="d-flex justify-content-between text-secondary">
                                                            <span>Package Charges:</span>
                                                            <span className="fw-semibold text-dark">₹{parseFloat(p.package_charges || 0).toFixed(2)}</span>
                                                        </div>
                                                        <div className="d-flex justify-content-between text-secondary">
                                                            <span>Other Charges:</span>
                                                            <span className="fw-semibold text-dark">₹{parseFloat(p.other_charges || 0).toFixed(2)}</span>
                                                        </div>
                                                        {customExpenses.map((item, idx) => (
                                                            <div key={idx} className="d-flex justify-content-between text-secondary">
                                                                <span>{item.title}:</span>
                                                                <span className="fw-semibold text-dark">₹{parseFloat(item.amount || 0).toFixed(2)}</span>
                                                            </div>
                                                        ))}
                                                        <div className="d-flex justify-content-between fw-bold text-success border-top pt-1 mt-1 fs-6">
                                                            <span>Total Expenses:</span>
                                                            <span>₹{totalExpenses.toFixed(2)}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-6 ps-md-4">
                                                    <span className="fw-bold text-secondary d-block mb-2 small text-uppercase">Product Pricing details</span>
                                                    <div className="d-flex flex-column gap-2">
                                                        <div>
                                                            <small className="text-muted d-block small">Manufactured Quantity</small>
                                                            <span className="fw-bold text-dark">{manufacturedQty.toFixed(2)} {p.unit}</span>
                                                        </div>
                                                        <div className="row g-2">
                                                            <div className="col-6">
                                                                {/* Commented Cost Per Unit (Mfg Unit) as requested
                                                                <small className="text-muted d-block small">Cost Per Unit (Mfg Unit)</small>
                                                                <span className="fw-bold text-danger fs-5">₹{parseFloat(p.mfg_price_unit || 0).toFixed(2)}</span>
                                                                */}
                                                                <small className="text-muted d-block small">Overall Manufacturing Cost</small>
                                                                <span className="fw-bold text-danger fs-5">₹{overallPrice.toFixed(2)}</span>
                                                                {totalDistributedQty > 0 && (
                                                                    <div className="mt-2">
                                                                        <small className="text-muted d-block small">Cost Per Distributed Pkt</small>
                                                                        <span className="fw-bold text-primary fs-6">₹{costPerPacket.toFixed(2)}</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className="col-6">
                                                                <small className="text-muted d-block small">Sales Price (per mfg unit)</small>
                                                                <span className="fw-bold text-success fs-5">₹{parseFloat(p.sales_price_unit || 0).toFixed(2)}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Portion Breakdown KPI Cards */}
                                <div className="col-12">
                                    <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                        <div className="card-body p-3.5">
                                            <h6 className="fw-bold text-success mb-3 d-flex align-items-center gap-2" style={{ fontSize: "15px" }}>
                                                <i className="bi bi-pie-chart-fill text-success fs-5"></i>
                                                Batch Portion Breakdown
                                            </h6>
                                            <div className="row g-3">

                                                {/* Distributed Quantity */}
                                                <div className="col-md-6 col-lg-3">
                                                    <div className="p-3 bg-white rounded-2xl shadow-sm border-start border-4 border-emerald-500 h-100" style={{ borderLeft: "4px solid #10b981", borderTop: "1px solid #f1f5f9", borderRight: "1px solid #f1f5f9", borderBottom: "1px solid #f1f5f9" }}>
                                                        <div className="d-flex align-items-center justify-content-between mb-1">
                                                            <span className="text-xs fw-semibold text-slate-500 text-uppercase tracking-wider">Distributed Qty</span>
                                                            <div className="rounded-circle bg-emerald-50 text-emerald-600 d-flex align-items-center justify-content-center" style={{ width: "28px", height: "28px", backgroundColor: "#ecfdf5", color: "#10b981" }}>
                                                                <i className="bi bi-box-seam fs-6"></i>
                                                            </div>
                                                        </div>
                                                        <h5 className="fw-extrabold text-slate-800 mb-0" style={{ fontSize: "18px" }}>{distributedQty.toFixed(2)} <small className="text-xs text-slate-500 font-normal">{p.unit}</small></h5>
                                                    </div>
                                                </div>

                                                {/* Distributed Cost */}
                                                <div className="col-md-6 col-lg-3">
                                                    <div className="p-3 bg-white rounded-2xl shadow-sm border-start border-4 border-emerald-500 h-100" style={{ borderLeft: "4px solid #10b981", borderTop: "1px solid #f1f5f9", borderRight: "1px solid #f1f5f9", borderBottom: "1px solid #f1f5f9" }}>
                                                        <div className="d-flex align-items-center justify-content-between mb-1">
                                                            <span className="text-xs fw-semibold text-slate-500 text-uppercase tracking-wider">Distributed Cost</span>
                                                            <div className="rounded-circle bg-emerald-50 text-emerald-600 d-flex align-items-center justify-content-center" style={{ width: "28px", height: "28px", backgroundColor: "#ecfdf5", color: "#10b981" }}>
                                                                <i className="bi bi-currency-rupee fs-6"></i>
                                                            </div>
                                                        </div>
                                                        <h5 className="fw-extrabold text-emerald-600 mb-0" style={{ fontSize: "18px", color: "#10b981" }}>₹{distributedCost.toFixed(2)}</h5>
                                                    </div>
                                                </div>

                                                {/* Undistributed Quantity */}
                                                <div className="col-md-6 col-lg-3">
                                                    <div className="p-3 bg-white rounded-2xl shadow-sm border-start border-4 border-slate-400 h-100" style={{ borderLeft: "4px solid #64748b", borderTop: "1px solid #f1f5f9", borderRight: "1px solid #f1f5f9", borderBottom: "1px solid #f1f5f9" }}>
                                                        <div className="d-flex align-items-center justify-content-between mb-1">
                                                            <span className="text-xs fw-semibold text-slate-500 text-uppercase tracking-wider">Undistributed Qty</span>
                                                            <div className="rounded-circle bg-slate-100 text-slate-600 d-flex align-items-center justify-content-center" style={{ width: "28px", height: "28px", backgroundColor: "#f1f5f9", color: "#475569" }}>
                                                                <i className="bi bi-inbox fs-6"></i>
                                                            </div>
                                                        </div>
                                                        <h5 className="fw-extrabold text-slate-700 mb-0" style={{ fontSize: "18px" }}>{undistributedQty.toFixed(2)} <small className="text-xs text-slate-500 font-normal">{p.unit}</small></h5>
                                                    </div>
                                                </div>

                                                {/* Undistributed Cost */}
                                                <div className="col-md-6 col-lg-3">
                                                    <div className="p-3 bg-white rounded-2xl shadow-sm border-start border-4 border-rose-500 h-100" style={{ borderLeft: "4px solid #ef4444", borderTop: "1px solid #f1f5f9", borderRight: "1px solid #f1f5f9", borderBottom: "1px solid #f1f5f9" }}>
                                                        <div className="d-flex align-items-center justify-content-between mb-1">
                                                            <span className="text-xs fw-semibold text-slate-500 text-uppercase tracking-wider">Undistributed Cost</span>
                                                            <div className="rounded-circle bg-rose-50 text-rose-500 d-flex align-items-center justify-content-center" style={{ width: "28px", height: "28px", backgroundColor: "#fff1f2", color: "#ef4444" }}>
                                                                <i className="bi bi-exclamation-circle fs-6"></i>
                                                            </div>
                                                        </div>
                                                        <h5 className="fw-extrabold text-rose-500 mb-0" style={{ fontSize: "18px", color: "#ef4444" }}>₹{undistributedCost.toFixed(2)}</h5>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Step 3: Batch Distribution Cards */}
                                <div className="col-12">
                                    <div className="card border-0 shadow-sm" style={{ borderRadius: '16px', background: '#f8fafc', border: '1px solid #e2e8f0' }}>
                                        <div className="card-body p-3.5">
                                            <h6 className="fw-bold text-success mb-3 d-flex align-items-center gap-2" style={{ fontSize: "15px" }}>
                                                <span className="bg-success text-white rounded-circle d-flex align-items-center justify-content-center fw-bold" style={{ width: '24px', height: '24px', fontSize: '12px', backgroundColor: "#10b981" }}>3</span>
                                                Step 3: Batch Distribution Details
                                            </h6>

                                            {p.distribution && p.distribution.length > 0 ? (
                                                <div className="row g-3">
                                                    {p.distribution.map((item, idx) => {
                                                        const qty = parseFloat(item.qty || 0);
                                                        const weightGrams = parseFloat(item.p_weight || 0);
                                                        const unitStr = String(item.pbox_unit || "").toLowerCase().trim();
                                                        const packetWeightInKg = (unitStr.includes("kg") || unitStr.includes("kilo"))
                                                            ? weightGrams
                                                            : (unitStr.includes("gram") || unitStr === "g")
                                                                ? (weightGrams / 1000.0)
                                                                : weightGrams;

                                                        const truePrice = mfgUnitCost * packetWeightInKg;
                                                        const totalVal = qty * truePrice;
                                                        const isSingleItem = p.distribution.length === 1;

                                                        const isLoose = item.is_loose || item.isLoose ||
                                                            (item.packet_title && item.packet_title.toLowerCase().includes("loose")) ||
                                                            (p.product_title && p.product_title.toLowerCase().includes("loose")) ||
                                                            String(item.status) === "3";
                                                        const qtyUnit = isLoose ? (p.unit || "kg") : "pkts";
                                                        const unitCostTitle = isLoose ? `UNIT COST / ${p.unit ? p.unit.toUpperCase() : 'KG'}` : "UNIT COST / PKT";

                                                        return (
                                                            <div className={isSingleItem ? "col-12" : "col-12 col-md-6"} key={idx}>
                                                                <div className="card border-0 shadow-sm bg-white h-100 p-3.5" style={{ borderRadius: "16px", border: "1px solid #cbd5e1" }}>

                                                                    {/* Card Header */}
                                                                    <div className="d-flex justify-content-between align-items-center mb-3 pb-2.5 border-bottom">
                                                                        <div className="d-flex align-items-center gap-2.5 text-start">
                                                                            <div className="p-2.5 rounded-xl bg-emerald-50 text-emerald-600 d-flex align-items-center justify-content-center" style={{ backgroundColor: "#ecfdf5", color: "#059669", borderRadius: "12px", width: "40px", height: "40px" }}>
                                                                                <i className="bi bi-box2-heart-fill fs-5"></i>
                                                                            </div>
                                                                            <div>
                                                                                <h6 className="fw-bold text-slate-900 mb-0 text-start" style={{ fontSize: "16px", color: "#0f172a" }}>
                                                                                    {item.packet_title}
                                                                                </h6>
                                                                                <small className="text-slate-500 d-block text-start font-medium" style={{ fontSize: "12px" }}>Package Style #{idx + 1}</small>
                                                                            </div>
                                                                        </div>
                                                                        <span className="badge fw-bold px-3 py-1.5 rounded-pill" style={{ backgroundColor: "#d1fae5", color: "#065f46", fontSize: "12px" }}>
                                                                            #{idx + 1}
                                                                        </span>
                                                                    </div>

                                                                    {/* Card Metrics Grid */}
                                                                    <div className="row g-2 text-start">
                                                                        <div className="col-4">
                                                                            <div className="p-2.5 bg-slate-50 rounded-xl" style={{ backgroundColor: "#f1f5f9", borderRadius: "12px" }}>
                                                                                <small className="d-block mb-1 font-bold" style={{ fontSize: "11px", color: "#475569", textTransform: "uppercase", letterSpacing: "0.3px" }}>Distributed Qty</small>
                                                                                <strong className="d-block font-extrabold" style={{ fontSize: "16px", color: "#059669" }}>{qty.toFixed(1)} {qtyUnit}</strong>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            <div className="p-2.5 bg-slate-50 rounded-xl" style={{ backgroundColor: "#f1f5f9", borderRadius: "12px" }}>
                                                                                <small className="d-block mb-1 font-bold" style={{ fontSize: "11px", color: "#475569", textTransform: "uppercase", letterSpacing: "0.3px" }}>{unitCostTitle}</small>
                                                                                <strong className="d-block font-extrabold" style={{ fontSize: "16px", color: "#0f172a" }}>
                                                                                    ₹{truePrice < 0.01 && truePrice > 0 ? truePrice.toFixed(4) : truePrice.toFixed(2)}
                                                                                </strong>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-4">
                                                                            <div className="p-2.5 rounded-xl" style={{ backgroundColor: "#eff6ff", borderRadius: "12px", border: "1px solid #dbeafe" }}>
                                                                                <small className="d-block mb-1 font-bold" style={{ fontSize: "11px", color: "#1d4ed8", textTransform: "uppercase", letterSpacing: "0.3px" }}>Total Value (INR)</small>
                                                                                <strong className="d-block font-extrabold" style={{ fontSize: "16px", color: "#1e40af" }}>₹{totalVal.toFixed(2)}</strong>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            ) : (
                                                <div className="text-muted p-3 rounded-xl text-center small bg-white border border-dashed">
                                                    No packet distributions were recorded.
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Remarks Card if exists */}
                                {p.remarks && (
                                    <div className="col-12">
                                        <div className="p-3 bg-warning bg-opacity-10 text-warning-dark border border-warning rounded" style={{ borderRadius: '8px' }}>
                                            <strong className="d-block mb-1 small text-uppercase">Remarks:</strong>
                                            <p className="mb-0 small">{p.remarks}</p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Modal Footer */}
                        <div className="modal-footer bg-light py-2" style={{ borderBottomLeftRadius: '16px', borderBottomRightRadius: '16px' }}>
                            <button
                                type="button"
                                className="btn btn-success px-4 rounded-pill shadow-sm me-2 d-flex align-items-center gap-2"
                                onClick={() => handlePrintCompletedDetails(p)}
                            >
                                <i className="bi bi-printer"></i>
                                Print Details
                            </button>
                            <button
                                type="button"
                                className="btn btn-secondary px-4 rounded-pill shadow-sm"
                                onClick={() => {
                                    setShowCompletedDetailsModal(false);
                                    setSelectedCompletedProcess(null);
                                }}
                            >
                                Close Details
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="page-wrappers">
            <div className="page-content">
                <NaviGate />
                <div className="mb-0 d-flex justify-content-between align-items-center">
                    <h6 className="mb-0 text-uppercase">
                        Product Processing Management
                    </h6>
                    <div className="d-flex gap-2">

                        {!activeProcess && (
                            <button
                                type="button"
                                onClick={() => setShowPurchaseModal(true)}
                                className="btn btn-success"
                            >
                                Add Purchase
                            </button>
                        )}

                        {!activeProcess ? (
                            <button
                                type="button"
                                onClick={() => {
                                    setCurrentStep(1);
                                    setShowCreateModal(true);
                                }}
                                className="btn btn-primary mb-0"
                            >
                                Create Process
                            </button>
                        ) : (
                            <div className="d-flex align-items-center gap-2">
                                <span className="badge bg-primary py-2 px-3">
                                    Process #{activeProcessId} - {currentStep === 1 ? 'Creation' : currentStep === 2 ? 'Manufacturing' : 'Distribution'} Step
                                </span>
                                <button
                                    type="button"
                                    onClick={() => {
                                        resetMainForm();
                                        setActiveProcess(null);
                                        setActiveProcessId(null);
                                        setCurrentStep(1);
                                        setShowCreateModal(false);
                                        setShowPurchaseModal(false);
                                        fetchProcessList();
                                    }}
                                    className="btn btn-outline-secondary d-flex align-items-center gap-1 py-1 px-3 shadow-sm rounded-1"
                                    style={{ textTransform: "none" }}
                                >
                                    <i className="bi bi-arrow-left"></i>
                                    Back to List
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <hr className="mt-1" />

                {/* Multi-step Processing Form or Process List */}
                {activeProcess && !showCreateModal ? (
                    <>
                        {currentStep === 1 && renderStep1()}
                        {currentStep === 2 && renderStep2()}
                        {currentStep === 3 && renderStep3()}
                    </>
                ) : (
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-striped table-bordered">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Product</th>
                                            <th>Batch No</th>
                                            <th>Quantity</th>
                                            <th>Avl Qty</th>
                                            <th>Status</th>
                                            <th>Created Date</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {processList.length > 0 ? (
                                            processList.map((process, index) => (
                                                <tr key={process.id}>
                                                    <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
                                                    <td>{process?.product_title}</td>
                                                    <td>
                                                        {process.batch_no ? (
                                                            <span
                                                                className="text-primary fw-bold"
                                                                style={{ cursor: "pointer", textDecoration: "underline" }}
                                                                onClick={() => handleViewBatchReport(process.batch_no)}
                                                            >
                                                                {process.batch_no}
                                                            </span>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                    <td>
                                                        {/* {process.desired_qty} {process.unit} */}
                                                        {process.manufactured_qty || process.desired_qty} {process.unit}
                                                    </td>
                                                    <td>
                                                        {parseFloat(process.status) >= 3 ? (
                                                            <span className="badge bg-light text-dark px-2 py-1 border fw-semibold">
                                                                {parseFloat(process.avl_qty || 0).toFixed(2)} {process.unit}
                                                            </span>
                                                        ) : (
                                                            <span className="text-muted">-</span>
                                                        )}
                                                    </td>
                                                    <td className={getStatusClass(process.status)}>
                                                        {getStatusLabel(process.status)}
                                                    </td>
                                                    <td>{process.mfg_date || process.create_date?.split('T')[0] || '-'}</td>
                                                    <td className="" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                                        {parseInt(process.status) === 4 ? (
                                                            <div className="d-flex align-items-center gap-2">
                                                                <button
                                                                    className="btn btn-sm d-flex align-items-center justify-content-center gap-1 px-2 py-1 border-0 rounded-pill bg-success text-white shadow-sm"
                                                                    type="button"
                                                                    disabled
                                                                    title="Process Completed"
                                                                >
                                                                    <i className="bi bi-check-circle-fill"></i>
                                                                    <span className="fw-semibold small">Completed</span>
                                                                </button>
                                                                <button
                                                                    className="btn btn-link text-primary p-0 border-0 ms-1 d-flex align-items-center justify-content-center"
                                                                    style={{ fontSize: "1.25rem", textDecoration: "none" }}
                                                                    type="button"
                                                                    onClick={() => handleViewProcessDetails(process)}
                                                                    title="View Process Details"
                                                                >
                                                                    <i className="bi bi-eye-fill"></i>
                                                                </button>
                                                                <button
                                                                    className="btn btn-link text-danger p-0 border-0 ms-1 d-flex align-items-center justify-content-center"
                                                                    style={{ fontSize: "1.25rem", textDecoration: "none" }}
                                                                    type="button"
                                                                    onClick={() => handleDeleteProcess(process)}
                                                                    title="Delete Process"
                                                                >
                                                                    <i className="bi bi-trash-fill"></i>
                                                                </button>
                                                            </div>
                                                        ) : (
                                                            <div className="d-flex align-items-center gap-3">
                                                                <button
                                                                    className={`btn btn-sm d-flex align-items-center justify-content-center gap-1 px-2 py-1 rounded-pill shadow-sm ${parseInt(process.status) === 3
                                                                        ? 'btn-warning text-dark'
                                                                        : 'btn-primary'
                                                                        }`}
                                                                    type="button"
                                                                    onClick={() => handleResumeProcess(process)}
                                                                    title={
                                                                        parseInt(process.status) === 0
                                                                            ? 'Continue this process'
                                                                            : parseInt(process.status) === 3
                                                                                ? 'Proceed to distribution stage'
                                                                                : 'Resume process'
                                                                    }
                                                                >
                                                                    <i
                                                                        className={`bi ${parseInt(process.status) === 3
                                                                            ? 'bi-box-arrow-up-right'
                                                                            : 'bi-arrow-right-circle-fill'
                                                                            }`}
                                                                    ></i>
                                                                    <span className="fw-semibold small">
                                                                        {parseInt(process.status) === 0
                                                                            ? 'Continue'
                                                                            : parseInt(process.status) === 3
                                                                                ? 'Distribute'
                                                                                : 'Continue'}
                                                                    </span>
                                                                </button>
                                                                <img
                                                                    src='/assets/images/icons/edit.png'
                                                                    onClick={() => handleResumeProcess(process, 1)}
                                                                    height="16px"
                                                                    alt="Edit"
                                                                    style={{ cursor: 'pointer' }}
                                                                    title="Edit this process starting from step 1"
                                                                />
                                                                {!process.is_order_based && (
                                                                    <button
                                                                        className="btn btn-link text-danger p-0 border-0 ms-1 d-flex align-items-center justify-content-center"
                                                                        style={{ fontSize: "1.25rem", textDecoration: "none" }}
                                                                        type="button"
                                                                        onClick={() => handleDeleteProcess(process)}
                                                                        title="Delete Process"
                                                                    >
                                                                        <i className="bi bi-trash-fill"></i>
                                                                    </button>
                                                                )}
                                                            </div>
                                                        )}
                                                    </td>

                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="7" className="text-center py-3">No processing records found</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <Pagination
                                currentPage={currentPage}
                                totalPages={totalPages}
                                onPageChange={handlePageChange}
                                entriesPerPage={entriesPerPage}
                                onEntriesPerPageChange={(val) => {
                                    setEntriesPerPage(val);
                                    setCurrentPage(1);
                                    fetchProcessList(1, "", val);
                                }}
                            />
                        </div>
                    </div>
                )}

                {/* Create Process Modal */}
                {showCreateModal && (
                    <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Create New Process</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => {
                                            resetMainForm();
                                            setActiveProcess(null);
                                            setActiveProcessId(null);
                                            setCurrentStep(1);
                                            setShowCreateModal(false);
                                            fetchProcessList();
                                        }}
                                        disabled={isSubmitting}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    {currentStep === 1 && renderStep1()}
                                    {currentStep === 2 && renderStep2()}
                                    {currentStep === 3 && renderStep3()}
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Product Details Modal */}
                {showDetailsModal && (
                    <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-2">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Add Product Package Details</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => {
                                            setShowDetailsModal(false);
                                            resetProductDetailsForm();
                                        }}
                                    ></button>
                                </div>

                                <div className="modal-body">
                                    <form onSubmit={handleProductDetailsSubmit}>
                                        <div className="row g-3">
                                            {/* Product Selection */}
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Select Product <span className="text-danger">*</span>
                                                </label>
                                                <select
                                                    name="p_id"
                                                    value={formData1.p_id}
                                                    onChange={handleProductSelect}
                                                    className={`form-control ${errorss.p_id ? "is-invalid" : ""}`}
                                                    disabled={activeProcess ? true : false} // Disable if in active process
                                                >
                                                    <option value="">Select Product</option>
                                                    {products.map((product) => (
                                                        <option key={product.product_id} value={product.product_id}>
                                                            {product.title} ({displayLimit(product.weight_limit)})
                                                        </option>
                                                    ))}
                                                </select>
                                                {errorss.p_id && <div className="invalid-feedback">{errorss.p_id}</div>}
                                            </div>

                                            {/* Product Code */}
                                            <div className="col-md-6">
                                                <label className="form-label">Product Code</label>
                                                <input
                                                    type="text"
                                                    name="p_code"
                                                    value={formData1.p_code}
                                                    onChange={handleInputChange}
                                                    className="form-control"
                                                />
                                            </div>

                                            {/* Product Weight */}
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Weight <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="p_weight"
                                                    value={formData1.p_weight}
                                                    onChange={handleInputChange}
                                                    className={`form-control ${errorss.p_weight ? "is-invalid" : ""}`}
                                                    placeholder="0.00"
                                                />
                                                {errorss.p_weight && <div className="invalid-feedback">{errorss.p_weight}</div>}
                                            </div>

                                            {/* Unit */}
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Unit <span className="text-danger">*</span>
                                                </label>
                                                <select
                                                    name="pbox_unit"
                                                    value={formData1.pbox_unit}
                                                    onChange={handleInputChange}
                                                    className={`form-control ${errorss.pbox_unit ? "is-invalid" : ""}`}
                                                >
                                                    <option value="">Select Unit</option>
                                                    <option value="grams">Grams</option>
                                                    <option value="kilograms">Kilograms</option>
                                                    {/* <option value="liters">Liters</option>
                                                        <option value="milliliters">Milliliters</option>
                                                        <option value="pcs">Pieces</option> */}
                                                </select>
                                                {errorss.pbox_unit && <div className="invalid-feedback">{errorss.pbox_unit}</div>}
                                            </div>

                                            {/* Price */}
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Price <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    name="p_price"
                                                    value={formData1.p_price}
                                                    onChange={handleInputChange}
                                                    className={`form-control ${errorss.p_price ? "is-invalid" : ""}`}
                                                    placeholder="0.00"
                                                />
                                                {errorss.p_price && <div className="invalid-feedback">{errorss.p_price}</div>}
                                            </div>

                                            {/* Box Quantity */}
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Box Quantity
                                                </label>
                                                <input
                                                    type="number"
                                                    name="pbox_qty"
                                                    value={formData1.pbox_qty}
                                                    onChange={handleInputChange}
                                                    onWheel={(e) => e.currentTarget.blur()}
                                                    className={`form-control ${errorss.pbox_qty ? "is-invalid" : ""}`}
                                                />
                                                {errorss.pbox_qty && <div className="invalid-feedback">{errorss.pbox_qty}</div>}
                                            </div>

                                            {/* Box Code */}
                                            <div className="col-md-6">
                                                <label className="form-label">Box Code</label>
                                                <input
                                                    type="text"
                                                    name="pbox_code"
                                                    value={formData1.pbox_code}
                                                    onChange={handleInputChange}
                                                    className="form-control"
                                                />
                                            </div>

                                            {/* Box Price */}
                                            <div className="col-md-6">
                                                <label className="form-label">Box Price</label>
                                                <input
                                                    type="number"
                                                    name="pbox_price"
                                                    value={formData1.pbox_price}
                                                    onChange={handleInputChange}
                                                    onWheel={(e) => e.currentTarget.blur()}
                                                    className="form-control"
                                                    step="1"
                                                />
                                            </div>
                                        </div>

                                        <div className="text-end mt-4">
                                            <button
                                                type="button"
                                                className="btn btn-secondary me-2"
                                                onClick={() => {
                                                    setShowDetailsModal(false);
                                                    resetProductDetailsForm();
                                                }}
                                            >
                                                Cancel
                                            </button>
                                            <button type="submit" className="btn btn-primary" disabled={loading}>
                                                {loading ? "Saving..." : "Save Details"}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Remaining stock use   Modal */}
                {showExistingBatchModal && foundBatch && (
                    <div
                        className="modal fade show"
                        style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
                        tabIndex="-1"
                    >
                        <div className="modal-dialog modal-dialog-centered modal-md">
                            <div className="modal-content">

                                {/* Header */}
                                <div className="modal-header bg-primary text-white">
                                    <h5 className="modal-title fw-bold">
                                        Existing Batch Found
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close btn-close-white"
                                        onClick={() => setShowExistingBatchModal(false)}
                                    ></button>
                                </div>

                                {/* Body */}
                                <div className="modal-body">

                                    <div className="list-group mb-3">
                                        <div className="list-group-item d-flex justify-content-between">
                                            <span className="text-muted">Processing ID</span>
                                            <span className="fw-semibold">{foundBatch.processing_id}</span>
                                        </div>

                                        <div className="list-group-item d-flex justify-content-between">
                                            <span className="text-muted">Product</span>
                                            <span className="fw-semibold">{foundBatch.product_name}</span>
                                        </div>

                                        <div className="list-group-item d-flex justify-content-between">
                                            <span className="text-muted">Batch No</span>
                                            <span className="fw-semibold">{foundBatch.batch_no}</span>
                                        </div>

                                        <div className="list-group-item d-flex justify-content-between">
                                            <span className="text-muted">Remaining</span>
                                            <span className="fw-bold text-success">
                                                {Number(foundBatch.remaining).toFixed(3)} {foundBatch.unit}
                                            </span>
                                        </div>
                                    </div>

                                    <p className="text-secondary small text-center">
                                        You can use the remaining stock or create a new batch.
                                    </p>
                                </div>

                                {/* Footer */}
                                <div className="modal-footer d-flex justify-content-between gap-2">
                                    <button
                                        type="button"
                                        className="btn btn-outline-dark link-opacity-30-hover w-30"
                                        onClick={handleContinueNewProcess}
                                    >
                                        Create New Process
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-success w-30"
                                        onClick={handleUseRemainingStock}
                                    >
                                        Use Remaining Stock
                                    </button>
                                </div>

                            </div>
                        </div>

                    </div>
                )}

                {/* Add purchase model  */}
                {showPurchaseModal && (
                    <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header bg-success text-white">
                                    <h5 className="modal-title">
                                        <i className="bi bi-cart-plus me-2"></i>
                                        Add Product Purchase
                                    </h5>
                                    <button
                                        type="button"
                                        className="btn-close btn-close-white"
                                        onClick={() => {
                                            resetModal();
                                        }}
                                    ></button>
                                </div>

                                <div className="modal-body">
                                    <form onSubmit={handleCreateProcess1}>
                                        <div className="row g-3">
                                            {/* Product Selection */}
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Select Product <span className="text-danger">*</span>
                                                </label>
                                                <select
                                                    className="form-select"
                                                    value={purchaseData.p_id}
                                                    onChange={(e) => {
                                                        const selectedProd = products.find(p => p.product_id == e.target.value);
                                                        setPurchaseData({
                                                            ...purchaseData,
                                                            p_id: e.target.value,
                                                            unit: selectedProd?.unit || ""
                                                        });
                                                    }}
                                                    required
                                                >
                                                    <option value="">Choose a product...</option>
                                                    {products.map((product) => (
                                                        <option key={product.product_id} value={product.product_id}>
                                                            {product.title} ({displayLimit(product.weight_limit)})
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Old Batch Number
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={purchaseData.oldbatchnum}
                                                    onChange={(e) => setPurchaseData({
                                                        ...purchaseData,
                                                        oldbatchnum: e.target.value
                                                    })}
                                                    placeholder="Enter old Batch Number"
                                                />
                                            </div>

                                            {/* Quantity and Unit */}
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Purchase Quantity <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={purchaseData.desired_qty}
                                                    onChange={(e) => setPurchaseData({
                                                        ...purchaseData,
                                                        desired_qty: e.target.value
                                                    })}
                                                    onWheel={(e) => e.currentTarget.blur()}
                                                    placeholder="Enter quantity"
                                                    min="0.01"
                                                    step="0.01"
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Unit <span className="text-danger">*</span>
                                                </label>
                                                <select
                                                    className="form-select"
                                                    value={purchaseData.unit}
                                                    onChange={(e) => setPurchaseData({
                                                        ...purchaseData,
                                                        unit: e.target.value
                                                    })}
                                                    required
                                                >
                                                    <option value="">Select unit</option>
                                                    <option value="kg">Kilograms (kg)</option>
                                                    {/* <option value="g">Grams (g)</option>
                                                        <option value="l">Liters (l)</option>
                                                        <option value="ml">Milliliters (ml)</option>
                                                        <option value="pcs">Pieces (pcs)</option> */}
                                                </select>
                                            </div>

                                            {/* Manufacturing Date */}
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Manufacturing Date <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={purchaseData.mfgdate}
                                                    onChange={(e) => setPurchaseData({
                                                        ...purchaseData,
                                                        mfgdate: e.target.value
                                                    })}
                                                    max={new Date().toISOString().split('T')[0]}
                                                    required
                                                />
                                            </div>

                                            {/* Expiry Date */}
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Expiry Date <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={purchaseData.expdate}
                                                    onChange={(e) => setPurchaseData({
                                                        ...purchaseData,
                                                        expdate: e.target.value
                                                    })}
                                                    min={new Date().toISOString().split('T')[0]}
                                                    required
                                                />
                                            </div>

                                            {/* <div className="col-md-6">
                                                    <label className="form-label">
                                                        From 
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={purchaseData.from}
                                                        onChange={(e) => setFormData({
                                                            ...purchaseData,
                                                            from: e.target.value
                                                        })}
                                                        placeholder="Enter From "
                                                        required
                                                    />
                                                </div> */}

                                            {/* Purchase Price and Total Purchase Price */}
                                            <div className="col-md-3">
                                                <label className="form-label" style={{ minHeight: "40px", display: "flex", alignItems: "flex-end" }}>
                                                    Purchase Price (per unit) <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={purchaseData.purchase_prize}
                                                    onChange={(e) => setPurchaseData({
                                                        ...purchaseData,
                                                        purchase_prize: e.target.value
                                                    })}
                                                    onWheel={(e) => e.currentTarget.blur()}
                                                    placeholder="Enter Price"
                                                    min="0"
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label" style={{ minHeight: "40px", display: "flex", alignItems: "flex-end" }}>
                                                    Total Purchase Price
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control bg-light"
                                                    value={((parseFloat(purchaseData.desired_qty || 0) * parseFloat(purchaseData.purchase_prize || 0)) || 0).toFixed(2)}
                                                    readOnly
                                                    disabled
                                                />
                                            </div>

                                            {/* Sale Price and Total Sale Price */}
                                            <div className="col-md-3">
                                                <label className="form-label" style={{ minHeight: "40px", display: "flex", alignItems: "flex-end" }}>
                                                    Sale Price (per unit) <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={purchaseData.sale_prize}
                                                    onChange={(e) => setPurchaseData({
                                                        ...purchaseData,
                                                        sale_prize: e.target.value
                                                    })}
                                                    onWheel={(e) => e.currentTarget.blur()}
                                                    placeholder="Enter Price"
                                                    min="0"
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-3">
                                                <label className="form-label" style={{ minHeight: "40px", display: "flex", alignItems: "flex-end" }}>
                                                    Total Sale Price
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control bg-light"
                                                    value={((parseFloat(purchaseData.desired_qty || 0) * parseFloat(purchaseData.sale_prize || 0)) || 0).toFixed(2)}
                                                    readOnly
                                                    disabled
                                                />
                                            </div>



                                            {/* Additional Information Card */}
                                            {/* <div className="col-12">
                                                    <div className="card bg-light">
                                                        <div className="card-body">
                                                            <h6 className="card-title mb-3">Additional Information</h6>
                                                            <div className="row g-2">
                                                                <div className="col-md-4">
                                                                    <small className="text-muted">Shop ID:</small>
                                                                    <p className="mb-0 fw-semibold">{formData.shop_id}</p>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <small className="text-muted">Branch ID:</small>
                                                                    <p className="mb-0 fw-semibold">{formData.branch_id}</p>
                                                                </div>
                                                                <div className="col-md-4">
                                                                    <small className="text-muted">Created By:</small>
                                                                    <p className="mb-0 fw-semibold">{formData.created_by}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                        </div>

                                        {/* Modal Footer */}
                                        <div className="d-flex justify-content-end gap-2 mt-4">
                                            <button
                                                type="button"
                                                className="btn btn-secondary"
                                                onClick={() => {
                                                    resetModal();
                                                }}
                                            >
                                                Cancel
                                            </button>
                                            <button type="submit" className="btn btn-success">
                                                <i className="bi bi-check-circle me-1"></i>
                                                Add Purchase
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {renderCompletedDetailsModal()}
                {renderBatchWiseSalesReportModal()}

            </div>
        </div>
    );
};

export default Product_process;

